var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _g2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _use, _use2, _g3, _rect, _rect2, _path21, _mask, _path22, _g4, _g5, _g6, _path23, _path24, _mask2, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _mask3, _use3, _g7, _use4, _g8, _use5, _g9, _use6, _g10, _use7, _g11, _use8, _g12, _use9, _g13, _path37, _path38, _path39, _rect3, _rect4, _path40, _path41, _g14, _g15, _path42, _mask4, _use10, _g16, _use11, _g17, _use12, _g18, _use13, _g19, _use14, _g20, _use15, _g21, _use16, _g22, _path43, _path44, _path45, _rect5, _rect6, _path46, _path47, _g23, _g24, _path48, _mask5, _use17, _g25, _use18, _g26, _use19, _g27, _use20, _g28, _use21, _g29, _use22, _g30, _use23, _g31, _path49, _path50, _path51, _rect7, _rect8, _path52, _path53, _g32, _g33, _path54, _mask6, _use24, _g34, _use25, _g35, _use26, _g36, _use27, _g37, _use28, _g38, _use29, _g39, _use30, _g40, _path55, _path56, _path57, _rect9, _rect10, _path58, _path59, _g41, _g42, _path60, _mask7, _use31, _g43, _use32, _g44, _use33, _g45, _use34, _g46, _use35, _g47, _use36, _g48, _use37, _g49, _path61, _path62, _path63, _rect11, _rect12, _path64, _path65, _g50, _path66, _path67, _mask8, _g51, _path68, _path69, _rect13, _rect14, _path70, _path71, _g52, _path72, _path73, _mask9, _use38, _g53, _use39, _g54, _use40, _g55, _use41, _g56, _use42, _g57, _use43, _g58, _use44, _g59, _path74, _path75, _path76, _rect15, _rect16, _path77, _path78, _g60, _g61, _path79, _mask10, _use45, _g62, _use46, _g63, _use47, _g64, _use48, _g65, _use49, _g66, _use50, _g67, _use51, _g68, _path80, _path81, _path82, _rect17, _rect18, _path83, _path84, _g69, _g70, _path85, _mask11, _use52, _g71, _use53, _g72, _use54, _g73, _use55, _g74, _use56, _g75, _use57, _g76, _use58, _g77, _path86, _path87, _path88, _rect19, _rect20, _path89, _path90, _g78, _g79, _path91, _mask12, _use59, _g80, _use60, _g81, _use61, _g82, _use62, _g83, _use63, _g84, _use64, _g85, _use65, _g86, _path92, _path93, _path94, _rect21, _rect22, _path95, _path96, _g87, _path97, _path98, _mask13, _use66, _g88, _use67, _g89, _use68, _g90, _use69, _g91, _use70, _g92, _use71, _g93, _use72, _g94, _path99, _path100, _path101, _rect23, _rect24, _path102, _path103, _g95, _path104, _path105, _mask14, _use73, _g96, _use74, _g97, _use75, _g98, _use76, _g99, _use77, _g100, _use78, _g101, _use79, _g102, _path106, _path107, _path108, _rect25, _rect26, _path109, _path110, _g103, _g104, _path111, _mask15, _use80, _g105, _use81, _g106, _use82, _g107, _use83, _g108, _use84, _g109, _use85, _g110, _use86, _g111, _path112, _path113, _path114, _rect27, _rect28, _path115, _path116, _g112, _g113, _path117, _mask16, _use87, _g114, _use88, _g115, _use89, _g116, _use90, _g117, _use91, _g118, _use92, _g119, _use93, _g120, _path118, _path119, _path120, _rect29, _rect30, _path121, _path122, _g121, _g122, _path123, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTourGraphic5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 450 253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 450,
    height: 253,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M450 0H0v253h450z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b0b0b",
    d: "M450 0H0v253h450z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 25,
    height: 7,
    x: 3,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.2 3.7H3.8v6.1h23.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillRule: "evenodd",
    d: "M6.8 3.7a3 3 0 0 0 0 6.1H14a3 3 0 0 1 0-6z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 4,
    height: 4,
    x: 6,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.7 5.1H6.4v3.4h3.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    width: 4,
    height: 3,
    x: 6,
    y: 6,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.5 6.6h3.2v1.2q0 .6-.7.7H7a1 1 0 0 1-.6-.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4 6.5h3.3v.7H6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9V5.8h.7V9zM6.4 9V5.8h.7V9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4 7.8h3.3v.7H6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.1 7.7v.8h-.7v-.8zm-.7-.5h.7v-.7h-.7zm3.3 1.3v-.8H9v.8z",
    clipRule: "evenodd"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.6 5.9-3.1.6v-.1q0-.5.2-.5l2.4-.5q.3 0 .4.3z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#g)",
    d: "M14 3.8h10.2a3 3 0 0 1 0 6H14a3 3 0 0 1 0-6Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25 6.7v.6l-.3.4-.3.2-.4.1h-.4l-.4-.3-.2-.4V6.2l.2-.3q.1-.2.4-.3h.8l.3.3.2.3zm-.5.1v-.4l-.1-.3L24 6h-.2l-.2.2-.1.3v1l.3.2h.4l.2-.2v-.2zM22 5.6V8h-.4V5.6zm.8 0V6h-2v-.4zm-2.2 0V8H20V5.6zM18.8 7h-.6v-.4h.8v-.2l.1-.1V6h-.7v2h-.5V5.6H19l.3.1.2.2v.6l-.3.2H19zm0 1h-.7l.2-.4h.7l.1-.2V7h-.7v-.4h.6v.1h.4l.2.3v.7l-.3.2zm-3.1-2.4h1.4l.3.3.1.4v.3l-.2.3-.3.1h-1v-.3h.7l.2-.2v-.4l-.2-.1h-.6v2h-.5zM17.1 8l-.6-1.1h.5l.6 1zm-1.7-1.3-.1.5-.2.4-.3.2-.4.1h-.5l-.3-.3-.2-.4v-1l.2-.3.3-.3h.9l.3.3.2.3zm-.5.1v-.4l-.2-.3-.3-.2H14l-.1.2-.1.3v1l.2.2h.5l.1-.2.1-.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i",
    width: 25,
    height: 14,
    x: 3,
    y: 19,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.4 19.2H7.5c-2 0-3.7 1.7-3.7 3.7v5.7c0 2 1.6 3.7 3.7 3.7h16c2 0 3.7-1.7 3.7-3.7v-5.7c0-2-1.7-3.7-3.8-3.7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c1e7fe",
    d: "M23.4 19.2H7.5c-2 0-3.7 1.7-3.7 3.7v5.7c0 2 1.6 3.7 3.7 3.7h16c2 0 3.7-1.7 3.7-3.7v-5.7c0-2-1.7-3.7-3.8-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c1c1c",
    fillOpacity: 0.8,
    d: "M27.2 19.2H3.8v13.1h23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.2 26h-1.4v1.4h-.4V26H10v-.5h1.4v-1.4h.4v1.4h1.4zm3.4-1.4v2.3h-.3L15 25.1V27h-.3v-2.3h.3l1.2 1.8v-1.8zm1.2 2.4-.3-.1-.4-.4v-.8l.2-.3.8-.2.2.2.2.3v.4h-1.3V26h1v-.2l-.2-.2h-.5l-.1.3v.7l.2.2h.5l.2-.2.2.1-.2.2-.2.1zm1.5-.4.5-1.4h.1v.3l-.4 1.4h-.2zm-.3-1.4.4 1.4v.3h-.2l-.5-1.7zm1.4 1.4.3-1.4h.3l-.5 1.7h-.2zm-.4-1.4.4 1.4v.3h-.1l-.5-1.4v-.3z"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M9.3 41.3v.4h-.7v-.4zm-2 0v1.1h-.7v-1.1zm2 1.5V44h-.7v-1.2zm-2 .8v.4h-.7v-.4zm2.4-2.7H8.2V42h1.5zm-2 0H6.3v2h1.6zm2 1.5H8.2v2h1.5zm-2 .8H6.3v1.2h1.6zm5.5.6h-.5v-.3h.5l.5-.1.3-.3V42l-.1-.3-.3-.2h-1V41h.7l.4.1q.3 0 .4.3l.2.4.1.5v.7a1 1 0 0 1-.7.6zm-.4-2.7v2.7h-.3v-2.7zm3.3 2.4v-1.3l-.2-.1h-.5l-.1.1v.2h-.4v-.2l.2-.2.3-.2h.7l.2.3.1.3v1.4h-.3zm0-.9v.2h-.6l-.2.1v.1l-.1.2v.2h.2l.2.1.4-.2.1-.2.2.2-.1.2-.4.3h-.6l-.3-.3V43l.2-.2.3-.2zm2 .7V43h-.2l-.3-.2h-.3l-.2-.2-.1-.1V42l.1-.1.3-.2h.7l.2.3.1.3h-.3v-.2h-.2l-.2-.1h-.3v.1l-.1.2v.1h.2l.2.2h.4l.3.3v.2l-.2.5H18l-.3.1h-.5l-.2-.3-.1-.3h.3v.2l.3.1h.5zm1.1-2.3v2.8H19V41zm0 1.7H19v-.3l.2-.4.6-.2h.3l.2.1.1.3v1.6h-.3v-1.6h-.2l-.2-.1-.4.2zm1.7-1.7h.4v2.8h-.4zm1.7 1.8v.4q0 .3-.2.3l-.2.3h-.7l-.2-.2-.2-.3v-1l.2-.3.2-.2h.7l.2.3.2.3zm-.3 0v-.3l-.1-.2-.4-.2h-.3l-.1.1-.1.2v.9l.2.2h.5l.2-.2v-.5m.7 0v-.4l.2-.3.3-.2.4-.1h.3l.3.3.2.3v.8l-.2.3-.6.3h-.4l-.5-.6zm.3 0v.3l.1.2.2.2h.5l.2-.2v-.2l.1-.3v-.3l-.1-.2-.2-.2h-.5l-.2.2v.2zm3 .7v-1.3l-.1-.1h-.5l-.1.1v.2h-.4v-.2l.2-.2.2-.2h.7l.3.3.1.3v1.4h-.3zm.1-.9v.2h-.6l-.2.1v.1l-.1.2v.2h.1l.3.1.4-.2v-.2l.2.2v.2l-.4.3h-.6l-.3-.3V43l.2-.2.3-.2zm1.2-.5v1.7h-.4v-2h.4zm.6-.3v.3h-.4l-.1.1-.1.2v.2h-.2v-.3l.2-.3.2-.1zm1.5 1.6V41h.4v2.8h-.4zm-1.3-.6v-.4l.2-.3.6-.3h.3l.2.2.2.3v1l-.2.3-.2.2h-.7l-.2-.3-.2-.3zm.3 0v.3l.1.2.2.2h.2l.5-.2.1-.3v-.6l-.2-.2h-.1l-.2-.1H29l-.2.2v.5m-19.3 8H8l-.4-.4H6.4q-.3 0-.4.4v2.4q0 .4.4.4h3.3l.2-.3v-2q0-.5-.4-.5m0 2.4h-3v-2.4h1l.3.4h1.7zM9.1 52H6.8v-.4h2.3zm-.7.8H6.8v-.4h1.6zm5.1-.7h-.7v-.3h1l.2-.2V51l-.2-.2-.3-.1h-.7v2.4h-.3v-2.7h1l.5.1.3.3.1.4v.5l-.4.2zm1.6-.6v1.7h-.3v-2h.3zm.7-.3v.3h-.4l-.2.1v.2l-.1.2H15v-.3l.1-.3.2-.2zm.2 1v-.4l.2-.4.3-.2h.7l.3.2.2.4v.8l-.2.3-.6.3h-.4l-.5-.6zm.3 0v.3l.1.2.2.2h.5l.2-.2v-.2l.1-.3v-.3l-.1-.3-.2-.1h-.2l-.5.1v.3zm1.9-1h.3v2.5l-.2.2h-.5v-.2h.2l.2-.1zm0-.5v-.2h.3v.3zm1.7 2.5h-.4l-.4-.6-.1-.4v-.5l.3-.3a1 1 0 0 1 1-.2l.2.2.1.3v.6h-1.4V52h1.1v-.3l-.2-.2H20l-.4.1-.1.3v.8l.5.2h.3l.2-.2.2.1-.1.2-.3.1zm2-.3h.2l.2-.2v-.2h.4q0 .3-.2.4l-.6.3h-.4l-.3-.3-.2-.3v-.8l.2-.4.3-.2h.8l.2.3.2.4h-.4v-.3l-.2-.1h-.5l-.2.2v1l.2.2zm2-1.7v.2h-1.1v-.2zm-.7-.5h.3v2.1l.1.1h.3v.3h-.5l-.2-.2zm2.2 2v-.2l-.2-.1-.2-.1h-.3l-.3-.2-.1-.2v-.4l.1-.2.3-.1h.7l.2.3.1.3h-.3v-.2l-.2-.1h-.5l-.1.3v.1h.2l.2.1.4.2.3.1v.3l-.2.4-.2.2h-.8l-.2-.3-.1-.3h.3l.1.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#9a9ca5",
    d: "M6.7 61.2v2h-.4v-2zm.6 0v.4H5.7v-.4zm.8 2h-.3l-.5-.7v-.3l.2-.3.2-.1h.6l.2.1.1.3v.4h-1v-.2h.7v-.2l-.1-.1h-.4v.7l.1.1h.4l.2-.1.2.2-.2.1zm1.2-1.1v1.1H9v-1.4h.4zm0 .3H9v-.2l.2-.3.4-.2h.2l.1.2.1.1v1.3h-.3V62h-.4l-.1.2zm.8 0v-.3l.1-.2.2-.1h.6l.1.2v1.3h-.4V62h-.4v.3m1.6-.4v1.8h-.4v-2h.4zm1 .5v.3l-.2.3-.1.1H12l-.2-.1-.1-.3v-.6l.1-.3.2-.1h.5l.1.1.1.3zm-.4 0v-.3a.2.2 0 0 0-.3-.2H12l-.1.1v.2l-.1.1v.4l.1.1h.4v-.4m1-1.4v2.1H13v-2zm1.2 1.8v-.7l-.1-.2H14v.2h-.5V62l.2-.1.2-.1h.6l.2.2v1l.1.1h-.4V63m0-.6v.3H14v.4h.3V63l.1-.1.1.1-.2.2v.1h-.5l-.2-.1v-.6l.3-.1zm1.4-.5v.2H15V62zm-.6-.4h.4V63h.2v.3h-.4l-.2-.1zm1.5 1.9h-.3a1 1 0 0 1-.4-.8v-.3l.2-.3.2-.1h.6l.2.1v.3l.1.3v.1h-1.2v-.2h.8V62h-.4l-.1.2v.5l.2.1h.3l.2-.1.2.2-.1.1zm1.7-.5-.2-.1H18l-.2-.1-.1-.1-.1-.1V62l.3-.1h.5q.2 0 .3.2v.2h-.4v-.1l-.2-.1H18l-.1.2.1.1h.2l.3.1.2.2v.4l-.1.1-.2.1h-.6l-.3-.2V63h.3v.1h.5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M41.3 66H8.4a4.7 4.7 0 1 0 0 9.4h32.9a4.7 4.7 0 1 0 0-9.3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M8.4 68.8H6.8q-.3 0-.4.4v3.1q0 .3.4.4H9q.4 0 .4-.4V70zm-1.6 3.5v-3.1h1.4v1h1v2.1zm7.8-1.8v.2l-.1.5-.2.4-.4.3H13l-.3-.3-.2-.4V70l.2-.4.3-.3h.9l.4.3.2.4zm-.4.2V70q0-.3-.2-.3l-.2-.2h-.6q-.2 0-.2.2-.2 0-.2.3v1l.2.3.2.2h.6l.2-.2.2-.3zm1.2-.5V72H15v-2h.4zm.6-.3v.3h-.4l-.1.2-.1.1v.2h-.2v-.3l.2-.2q0-.2.2-.2zm.3-.8h.3v2.8h-.3zm1.7 1.8v.4l-.2.4-.3.2H17l-.3-.2-.1-.3-.1-.4v-.6l.2-.3.3-.1.3-.1h.3l.3.3.1.3zm-.4 0v-.5a.4.4 0 0 0-.5-.2H17l-.2.1v.2l-.1.2v.7l.2.2h.6l.1-.2.1-.2zm1.2-1v2h-.4v-2zm-.4-.5h.4v.2h-.3zm1.7.5v.3h-1v-.3zm-.7-.5h.4v2.2h.4v.3h-.5q-.2 0-.2-.2zm1 1.5v-.4l.3-.3.2-.2.4-.1h.4l.3.3.2.3v.8l-.2.4-.7.2H21l-.4-.6zm.4 0v.6l.3.1h.5l.1-.1.1-.3v-.8l-.2-.2h-.3l-.4.2-.1.2zm3.7-1.7V72h-.3v-2.7zm.9 0v.3h-2v-.3zm1 2.7H26l-.5-.5v-.9l.2-.3a1 1 0 0 1 1-.2q.2 0 .3.2l.1.3v.5h-1.4v-.3h1.1v-.2l-.2-.2-.3-.1-.3.2-.2.2v.7l.2.2.4.2.3-.1.2-.2.2.2-.1.1-.3.2zm1.5-1.6V72h-.4v-2h.4zm0 .5h-.2v-.3q0-.3.2-.3l.2-.2.4-.1h.2l.4.4v1.6h-.3v-1.5l-.2-.2H28l-.2.2zm1.2-.1h-.2v-.3l.2-.3.2-.1.4-.1h.2l.2.2.2.2v1.6H30v-1.6h-.2l-.2-.1h-.2l-.2.1v.2zm2-.4v2.4h-.3v-2.8h.3zm1.4.6v.4l-.2.4-.6.2h-.3l-.2-.2-.2-.3v-1l.2-.3.2-.1.3-.1h.4l.2.3.2.3zm-.3 0v-.3l-.2-.2-.4-.2h-.2l-.1.1-.2.2v.9l.3.2h.5l.1-.1.1-.3zm1.1-1.8v2.8H33v-2.8zm1.7 2.5v-1.3h-.2l-.2-.1h-.2l-.2.1v.2h-.4v-.2l.2-.2.3-.2h.7l.3.3v1.5l.1.2H35zm0-.9v.2h-.5l-.2.1-.1.2v.3l.1.1h.2l.5-.2v-.2l.2.2v.2l-.4.3H34l-.2-.2-.1-.3V71l.2-.2.3-.1zm1.7-.8v.3h-1v-.3zm-.7-.5h.4v2.2h.3v.3h-.5l-.1-.2zm2 2.5h-.4l-.5-.5v-.9l.2-.3a1 1 0 0 1 1-.2l.2.2.2.3v.5h-1.5v-.3h1.2v-.2l-.2-.2-.3-.1-.4.2v.2l-.1.3v.4l.1.2.5.2.3-.1.2-.2.2.2-.2.1-.2.2zm2.3-.5v-.2H40l-.3-.2h-.3l-.2-.2-.2-.1v-.5l.2-.1.2-.2h.7l.3.3v.3h-.3v-.1l-.2-.2h-.4l-.1.1v.3l.2.1h.2l.4.2.2.2.1.3v.2l-.2.2-.3.1h-.7l-.3-.3v-.3h.3v.2l.2.1h.6zM8.2 80h-.4v.5h-.6v.4h.6v.6h.4v-.6h.6v-.4h-.6zm.2-1.8H6.8q-.3 0-.4.3v3.2q0 .3.4.4H9q.4 0 .4-.4v-2.4zm.7 3.5H6.8v-3.2h1.4v1h1zm5-1.3h.4l-.2.5-.3.3-.6.1H13l-.3-.3-.2-.4v-1.3l.2-.4.3-.2.5-.1h.5l.3.4.2.5H14V79l-.3-.2h-.6l-.3.2-.1.3v1l.1.4.2.2h.7l.2-.2zm2 .4v-1.5h.3v2h-.3zm0-.4h.2v.4l-.2.3-.2.1-.4.1h-.2l-.4-.4v-1.6h.3v1.5l.1.1.1.1h.5l.2-.3zm2 .4v-.2l-.2-.1h-.2l-.3-.2H17v-.8l.1-.2h.3l.3-.1h.4l.2.3.1.3h-.3v-.2l-.2-.1h-.5l-.1.3v.1h.2l.2.1.4.2.3.2v.2l-.2.5H18l-.3.1h-.5L17 81l-.1-.3h.3v.2l.3.1h.4l.2-.1zm1.6-1.5v.3h-1v-.3zm-.7-.5h.4V81h.3v.3h-.5l-.1-.2zm1 1.5v-.4l.2-.3.3-.3h.8l.3.3.1.3.1.4v.4l-.2.3-.7.3h-.4l-.4-.6zm.3 0v.3l.2.2.1.2h.5l.2-.2.1-.2v-.8l-.3-.2h-.5l-.1.2-.1.2zm2.3-.6v1.6h-.4v-2h.3zm-.1.5h-.2v-.4l.2-.3.3-.2h.6l.3.3v1.7h-.3v-1.6l-.2-.1h-.4l-.2.1v.3zm1.3-.2-.3.1.1-.3.2-.3.2-.2h.6l.2.1.2.3v1.6h-.3V80l-.1-.3-.1-.1H24zm3.6-1.4v2.7h-.3v-2.7zm.9 0v.3h-2.1v-.3zm1 2.7H29l-.5-.6V80l.2-.4a1 1 0 0 1 1-.2l.2.2.2.3v.6h-1.5V80h1.2v-.3l-.2-.2h-.3l-.4.1v.3l-.1.3v.3l.1.2.2.2h.6l.2-.2.2.1-.2.2-.2.2zm1.4-1.6v1.6h-.3v-2h.3zm0 .5h-.2v-.4l.2-.3.3-.2h.6l.3.3v1.7h-.3v-1.6l-.2-.1H31l-.2.1-.1.3zM32 80l-.3.1v-.3l.2-.3.3-.2h.6l.2.1.1.3v1.6h-.3v-1.6l-.2-.1h-.5l-.1.2zm2-.3V82h-.3v-2.7h.3zm1.4.6v.4l-.2.3-.6.3h-.3L34 81l-.1-.3-.1-.4v-.6l.2-.3.3-.2h.6l.3.2.1.4zm-.4 0V80l-.1-.2-.4-.3h-.2l-.2.2v.2l-.2.2v.4l.2.3.1.2h.5l.2-.2.1-.2zm1.2-1.8v2.8h-.4v-2.8zm1.7 2.4v-1.2l-.2-.1h-.6v.2h-.4v-.2l.2-.2h.3l.3-.1h.4l.2.3.1.3v1.3H38zm0-.8v.2h-.6l-.1.1-.2.1v.4h.2l.2.1.4-.2.1-.2.2.2-.1.1-.4.4H37l-.3-.3v-.6l.2-.2h.3l.4-.1zm1.7-.8v.3h-1v-.3zm-.7-.5h.3V81l.1.1h.3v.3h-.5l-.2-.2zm2 2.5h-.5l-.4-.6-.1-.3V80l.3-.4a1 1 0 0 1 1-.2l.2.2.1.3v.6h-1.4V80h1.1v-.3l-.2-.2h-.2l-.4.1-.1.3v.8l.3.2h.5l.2-.2.3.1-.2.2-.3.2zm2.2-.5v-.2l-.1-.1h-.3l-.3-.2H42V80l-.1-.3v-.2l.2-.2h.2l.3-.1h.4l.3.3v.3H43v-.2l-.2-.1h-.6v.4h.2l.3.1.4.2.2.2v.2l-.1.5H43l-.3.1h-.4L42 81l-.1-.3h.3l.1.2.2.1h.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#9a9ca5",
    d: "M6.6 90.6H6v-.3h.7v-.1L7 90v-.2h-.1l-.2-.1h-.4v1.7h-.4v-2H7l.3.6v.3l-.3.3zm1.4-.4v1.2h-.4v-1.5H8zm.4-.3v.3h-.3v.1l-.1.1v.1h-.1V90l.2-.1zm.1.7v-.3l.2-.2.2-.2h.6q.2 0 .2.2l.2.2v.6l-.2.3-.2.1H9l-.3-.4zm.4 0v.3l.2.1h.3l.1-.2v-.5l-.1-.1H9zm1.3-.7h.4v1.8l-.2.2H10v-.3h.2zm0-.4v-.2h.3l.1.2v.1zm1.4 1.9h-.3l-.5-.7v-.4l.2-.2.2-.2h.6l.2.1.2.3v.4H11v-.2h.8v-.2l-.1-.1h-.3l-.1.2v.6h.5l.2-.1.2.2-.2.1zM13 91h.2v-.3h.5l-.1.3-.2.2h-.7l-.2-.1-.1-.3v-.6l.1-.2.2-.2h.7l.2.2v.3h-.3v-.1l-.1-.1h-.3l-.1.2v.6zm1.6-1.2v.2h-.9zm-.6-.4h.4V91h.2v.3h-.4l-.2-.1zm2.6 1.3-.2-.1h-.2l-.2-.2-.3-.1-.1-.2v-.4q0-.2.2-.2l.2-.1h.7l.2.2.1.3h-.4v-.1l-.1-.1H16v.4h.4l.2.2.2.1.2.4v.3l-.2.1-.2.1h-.9l-.1-.3-.1-.3h.4v.2h.1l.1.1h.4zm1.4.6h-.4l-.4-.7v-.4l.2-.2.2-.2h.6l.2.1.1.3v.4h-1.1v-.2h.8v-.2l-.1-.1h-.4v.8h.5l.1-.1.2.2v.1zm1.5-1.5v.2h-.8zm-.6-.4h.4V91h.2v.3h-.4l-.2-.1zm1.6.4v.2h-.9zm-.7-.4h.4V91h.2v.3H20l-.1-.1zm1.3.4v1.5h-.4v-1.5zm-.4-.4v-.2h.4v.3zm1.1.7v1.2h-.4v-1.5h.4zm0 .4v-.3l.1-.3.4-.2h.2l.2.2v.1l.1.3v1h-.4v-1.2H22l-.1.2zm2.2-.7h.3v1.7l-.3.3h-.8l-.1-.2.1-.2h.2l.2.1h.2v-.1l.1-.2V90m-1 .7v-.3l.1-.3.5-.2h.2l.2.3v.2l.1.3v.3l-.1.3-.2.1h-.2l-.5-.1-.1-.3zm.4 0v.3l.1.1h.3l.1-.1v-.6l-.1-.1h-.3l-.1.2zm2 .3H25l-.2-.1-.2-.1v-.1l-.1-.2.2-.3.1-.1h.6l.2.2.1.2h-.4V90H25l-.1.1v.1l.1.1h.2l.2.1.2.2.1.2v.2l-.2.2h-.8l-.2-.2h.3v.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M6.2 97.5v2.7h3.5v-2.7zm.8.4v.4h-.4v-.4zM6.6 99v-.3H7v.3zm0 .4H7v.4h-.4zm2.7.4h-2v-.4h2zm0-.8h-2v-.3h2zm0-.7h-2v-.4h2zm4.2.7h-.7v-.3h1l.2-.3V98l-.2-.2h-1v2.3h-.3v-2.6H14l.3.3.1.5v.4l-.4.3zm1.6-.6v1.6h-.3v-2h.3zm.7-.4v.3h-.4l-.2.2v.1l-.1.2H15v-.3l.1-.2.2-.2zm.2 1v-.4l.2-.3.3-.2.4-.1h.3l.3.3.2.3v.8l-.2.4-.6.3-.4-.1-.5-.6zm.3 0v.3l.1.3.2.1h.5l.2-.1v-.3l.1-.2v-.4l-.1-.2-.2-.2h-.5l-.2.2v.2zm1.9-1h.3v2.6l-.2.2h-.5v-.3h.4zm0-.5h.3v.2l-.1.1h-.2zm1.7 2.6-.4-.1-.4-.5-.1-.4v-.5l.3-.3a1 1 0 0 1 1-.2l.2.2.1.3v.5h-1.4v-.3h1.1v-.2l-.2-.2-.2-.1-.4.2-.1.2v.9l.5.2h.3l.2-.3.2.2-.1.2-.3.1zm2-.3h.2l.2-.2v-.2h.4q0 .2-.2.3l-.6.4-.4-.1-.3-.2-.2-.4v-.8l.2-.3.3-.2.4-.1.4.1.2.3.2.3h-.4v-.2l-.2-.2h-.5l-.2.2v1.1l.2.1zm2-1.8v.3h-1.1V98zm-.7-.4h.3v2l.1.1h.3v.3h-.5l-.2-.2zm3-.2v2.6h-.4v-2.6zm.8 0v.2h-2v-.2zm.8 2.4.5-1.8h.4l-.8 2.3-.2.3-.2.2h-.4v-.3h.3l.1-.1.1-.2zm-.4-1.8.5 1.6v.3l-.2.2-.7-2zm2 .4v2.4H29V98h.3zm1.3.6v.5l-.2.3-.6.3-.3-.1-.3-.2-.1-.3-.1-.3v-.6l.2-.3.3-.2.3-.1h.3l.3.3.1.3zm-.4 0v-.3l-.1-.2-.4-.2h-.2l-.2.2v.1l-.2.2v.5l.1.2.2.2h.5l.2-.1.1-.3zm1.6 1h-.3l-.5-.5v-.9l.2-.3a1 1 0 0 1 1-.2l.2.2.1.3.1.4v.1h-1.5v-.3h1.2l-.1-.2-.1-.2-.3-.1-.4.2-.1.2v.7l.1.2.2.1h.5l.3-.2.2.2-.2.2-.2.1zm2.3-.5-.1-.2h-.3l-.3-.1-.2-.1-.2-.2v-.4l.2-.2.2-.2h.7l.3.3v.3h-.3v-.1l-.2-.2h-.4l-.1.1v.3l.1.1h.3l.4.2.2.2v.3l-.1.4-.3.1h-.7l-.3-.3v-.3h.2l.1.2.2.1h.6zM6.5 108a.3.3 0 1 0 0 .5.3.3 0 0 0 0-.6m0-1.2a.3.3 0 1 0 0 .5.3.3 0 0 0 0-.5m0 2.3q-.3 0-.3.3t.3.3.2-.3-.2-.3m.5.5h2.8v-.4H7zm0-1.2h2.8v-.4H7zm0-1.5v.3h2.8v-.3zm6.5 1.5h-.7v-.2h.7l.3-.1.2-.2v-.5l-.2-.2h-1v2.3h-.3v-2.7h1l.5.1.3.3.1.4v.5l-.4.3zm1.6-.6v1.7h-.3v-2h.3zm.7-.3v.3h-.4l-.2.1v.2l-.1.2H15v-.3l.1-.3.2-.2zm.2 1v-.4l.2-.3.3-.2.4-.1h.3l.3.3.2.3v.8l-.2.3-.6.3h-.4l-.5-.6zm.3 0v.3l.1.2.2.2h.5l.2-.2v-.2l.1-.3v-.3l-.1-.2-.2-.2h-.5l-.2.2v.2zm1.9-1h.3v2.5l-.2.2h-.5v-.2h.2l.2-.1zm0-.5v-.2h.3v.3zm1.7 2.5h-.4l-.4-.5-.1-.4v-.5l.3-.4a1 1 0 0 1 1-.2l.2.3.1.3v.5h-1.4v-.3h1.1v-.3l-.2-.2H20l-.4.1-.1.3v.9l.5.2.3-.1.2-.2.2.1-.1.2-.3.2zm2-.3h.2l.2-.1v-.2h.4l-.2.3-.6.3h-.4l-.3-.3-.2-.3v-.8l.2-.3.3-.2.4-.1h.4l.2.3.2.4h-.4v-.2l-.2-.2h-.5l-.2.2v1l.2.2zm2-1.7v.3h-1.1v-.3zm-.7-.5h.3v2.2h.3v.3h-.4l-.2-.2zm3.5 1.8-.2-.2h-.2q0-.2-.3-.2l-.3-.1-.3-.2-.2-.2v-.3l.2-.5.3-.2h.4l.5.1.3.3.1.4h-.3l-.1-.3-.2-.2h-.6l-.2.2v.4l.3.2h.2l.4.2.3.2.2.2v.6l-.2.2-.3.2h-.8l-.3-.2-.2-.2-.1-.4h.3v.3l.2.1.2.1h.6l.2-.2zm2 .2v-1.5h.3v2h-.4zm0-.4v.4l-.1.3-.3.2h-.6l-.3-.4v-1.6h.2v1.5l.2.1v.1h.6l.1-.3zm.8-2h.3v2.9h-.3zm1.7 1.9v.4l-.2.3-.3.3h-.6l-.3-.2-.1-.3-.1-.4v-.6l.2-.3.3-.2h.6l.3.3.1.3zm-.4 0v-.5l-.3-.2h-.4l-.2.1v.2l-.1.2v.7l.2.2h.5l.2-.2v-.2zm2.7-1.7v2.7H33v-2.7zm.8 0v.3h-2v-.3zm.8 2.5.6-1.8h.3l-.8 2.3-.2.3-.1.1h-.4v-.2h.2l.2-.1v-.2zm-.4-1.8.5 1.5.1.4-.2.1-.8-2zm2 .4v2.4h-.4v-2.8h.3zm1.3.6v.4l-.2.3-.6.3H37l-.2-.2-.2-.3v-1l.2-.3.2-.2h.7l.2.3.2.3zm-.3 0v-.3l-.2-.2-.4-.2H37l-.2.1v.2l-.1.2v.7l.3.2h.5l.1-.2.1-.2zm1.6 1h-.4l-.5-.5v-.9l.2-.4a1 1 0 0 1 1-.2l.2.3.2.3v.5h-1.5v-.3h1.2v-.3l-.2-.2h-.3l-.4.1v.3l-.1.3v.3l.1.3.5.2.3-.1.2-.2.2.1q0 .2-.2.2l-.2.2zm2.3-.5v-.2h-.2q0-.2-.3-.2h-.3l-.2-.2-.1-.1v-.5l.1-.2h.2l.3-.1h.4l.3.3.1.3h-.3v-.2l-.2-.1h-.5l-.1.1v.3h.2l.2.1.4.2q.2 0 .2.2l.1.2v.3l-.2.2h-.2l-.3.1h-.5l-.3-.3v-.3h.3v.2l.2.1h.6zm-35.2 7.6v.4q0 .2-.2.2H6v.8h.2q.2 0 .2.2v.4q0 .5.6.6h.6v-.4H7l-.2-.2v-.4q0-.5-.4-.6.4-.1.4-.6v-.4l.2-.2h.6v-.4H7q-.5 0-.6.6m3.3.6-.2-.2v-.4q0-.5-.6-.6h-.5v.4h.5q.3 0 .2.2v.4q0 .5.4.6-.4.1-.4.6v.4l-.2.2h-.5v.4h.5q.6 0 .6-.6v-.4l.2-.2h.2v-.8zm3.8.5h-.7v-.3h1l.2-.2v-.5l-.2-.2-.3-.1h-.7v2.4h-.3V116h1l.5.1.3.3.1.4v.4l-.4.3zm1.6-.6v1.7h-.3v-2h.3zm.7-.3v.3h-.4l-.2.1v.2l-.1.2H15v-.3l.1-.3.2-.2zm.2 1v-.4l.2-.4.3-.2h.7l.3.2.2.4v.8l-.2.3-.3.2-.3.1h-.4l-.3-.3-.2-.3zm.3 0v.3l.1.2.2.2h.5l.2-.2v-.2l.1-.3v-.3l-.1-.3-.4-.2h-.3l-.2.2v.3zm1.9-1h.3v2.5l-.2.2h-.5v-.2h.2l.2-.1zm0-.5v-.2h.3v.2l-.1.1zm1.7 2.5h-.4l-.4-.6-.1-.4v-.5l.3-.3a1 1 0 0 1 1-.2l.2.2.1.3v.6h-1.4v-.3h1.1v-.3l-.2-.2H20l-.4.1-.1.2v.9l.5.2h.3l.2-.2.2.1-.1.2-.3.1zm2-.3h.2l.2-.2v-.2h.4q0 .3-.2.4l-.6.3h-.4l-.3-.3-.2-.3v-.8l.2-.4.3-.2h.8l.2.3.2.4h-.4v-.3l-.2-.1h-.5l-.2.1v1.1l.2.2zm2-1.7v.2h-1.1v-.2zm-.7-.5h.3v2.1h.1l.1.1h.1v.3h-.4l-.2-.2zm2.8 2.5h-.6v-.3h.6l.4-.1q.3-.1.3-.4l.1-.5v-.6l-.2-.3-.3-.2h-.9v-.3h1.1l.3.3.3.4v1.2a1 1 0 0 1-.6.7zm-.4-2.7v2.7h-.4V116zm3.2 2.3v-1.2l-.2-.1H28v.2h-.4v-.2l.2-.2.3-.1h.7l.3.2v1.5l.1.2H29v-.3m0-.8v.2h-.7l-.1.2v.3l.1.2h.2l.5-.2v-.2l.2.2v.1l-.4.3-.3.1h-.4l-.2-.3-.1-.3v-.3l.2-.2.3-.1h.8m1.7-.8v.2h-1v-.2zm-.7-.5h.3v2.1h.2v.1h.2v.3H30l-.1-.2v-2.3m2.3 2.1v-1.2l-.2-.1h-.6v.2H31v-.2l.2-.2.3-.1h.7l.2.2.1.4v1.3h-.3zm0-.8v.2h-.7l-.2.2v.3l.2.2h.2l.4-.2.1-.2.2.2-.1.1-.4.3-.3.1h-.3l-.3-.3v-.6l.2-.2.3-.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#9a9ca5",
    d: "M6.6 128.1H6v-.3h.7v-.1l.1-.2v-.2h-.1l-.2-.1h-.4v1.6h-.4v-2h.8l.4.1.3.6v.3l-.3.2zm1.7.8h-.4l-.3-.5v-.6l.1-.3.2-.1h.6l.2.1.1.3v.4h-1v-.2h.8v-.2l-.1-.1H8v.7l.1.1h.4l.1-.1.2.2-.1.1-.2.1zm.7-.8v-.3l.2-.3.2-.1h.6l.3.1v.3l.1.3v.3l-.1.2-.3.2h-.6l-.2-.2-.1-.2zm.4 0v.3l.2.1h.3l.1-.2v-.5l-.1-.1h-.4zm1.7-.5v1.8h-.4v-2h.3zm1 .5-.1.3-.1.2-.5.3h-.2l-.2-.2v-.3l-.1-.3v-.3l.1-.3.2-.1h.5l.2.1v.3zm-.5 0v-.3a.2.2 0 0 0-.3-.2h-.1l-.1.1v.8h.4l.1-.2zm1-1.4v2.1h-.3v-2zm1 2.2h-.2l-.4-.5v-.6l.1-.3.3-.1h.5l.2.1.2.3v.4h-1.2v-.2h.8v-.2l-.1-.1h-.4v.7l.2.1h.3l.2-.1.2.2-.2.1-.2.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M6.4 136.5q.3 0 .4-.4 0-.3-.4-.4-.3 0-.4.4 0 .3.4.4m.2.2h-.2l-.5.1q-.3.1-.3.4v.3h.9v-.3zm3-.2q.2 0 .3-.4 0-.3-.4-.4-.3 0-.4.4 0 .3.4.4m.7.7q0-.3-.2-.4h-.8l.1.4v.3h1zm-1.5-.5a2 2 0 0 0-1.7 0q-.3.1-.3.5v.3H9v-.3q0-.4-.3-.5m-1.6.4.2-.1h1.2l.1.1zm.8-1.6.2.2q0 .3-.2.2t-.2-.2.2-.2m0-.3a.6.6 0 1 0 0 1.1.6.6 0 0 0 0-1.1m6.2 1.5h.4l-.2.4-.3.3-.6.1H13l-.3-.3-.2-.4v-1.3l.2-.4.3-.2.5-.1.5.1.3.3.2.5H14v-.3l-.3-.2-.3-.1h-.3l-.3.2-.1.3v1.1l.1.3.2.2h.7l.2-.2zm1.2-2v2.8h-.4v-2.8zm.9.8v2h-.4v-2zm-.4-.5.2-.1h.1l.1.2v.1zm1.7 2.5h-.3l-.5-.5v-.9q0-.3.2-.3l.6-.3h.4l.2.3.2.3v.5h-1.5v-.3H18v-.3l-.2-.2h-.5l-.2.2-.1.2v.6l.1.3.2.1h.6l.2-.2.2.2-.2.1-.2.2zM19 136v1.6h-.3v-2h.3zm0 .5h-.2v-.3l.2-.3.6-.3h.3l.2.1.1.3v1.6H20V136l-.2-.2h-.2l-.4.2zm2.6-.9v.3h-1v-.3zm-.7-.5h.3v2.2h.4v.3h-.5l-.1-.2-.1-.3zm2.3 2v-.2H23l-.3-.2h-.3l-.2-.2-.2-.1v-.5l.2-.1.2-.2h.7l.3.3v.3h-.3v-.2h-.2l-.2-.1h-.2l-.1.1v.3l.2.1h.2l.4.2.2.2v.3l-.1.4H23l-.3.1h-.4l-.3-.3v-.3h.3v.2l.2.1h.6zm-16.8 9.7v-.2l.1-.1 1.1-.3.1-.4h-.1q-.8 0-1.3.4-.3 0-.3.4v.6h1.8l-.1-.4zm1.2-1.2a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6m0-1.2q.4 0 .4.4a.4.4 0 0 1-.8 0q0-.4.4-.4m2.1 2 .2-.2-.2-.4-.3.1-.2-.1v-.3h-.4v.3l-.3.1h-.3l-.2.3.2.2v.2l-.2.2.2.3h.5v.4h.5v-.3l.2-.2.3.1.2-.3zm-.7.4a.4.4 0 0 1-.4-.4q0-.3.4-.4.3 0 .4.4 0 .3-.4.4m5.1-.8h.4l-.2.5-.3.3-.6.1H13l-.3-.3-.2-.4v-1.3l.2-.4.3-.2.5-.1h.5l.3.4.2.5H14v-.4l-.3-.2h-.6l-.3.2-.1.3v1l.1.3.2.2.3.1h.4l.2-.3zm1.1-.8v1.7H15v-2h.3zm.6-.3v.3h-.3l-.2.1v.2l-.1.2H15v-.3l.1-.3.2-.2zm1.1 2h-.3l-.5-.6v-.9l.2-.3a1 1 0 0 1 1-.2l.2.2.2.3v.6h-1.5v-.3h1.2v-.3l-.2-.2h-.3l-.4.1v.3l-.1.3v.3l.1.2.5.2h.3l.2-.2.2.1-.2.2-.2.2zm1.7-.4.5-1.6h.2v.3l-.5 1.7h-.2zm-.3-1.6.4 1.6v.4h-.2l-.6-2zm1.5 1.6.4-1.6h.4l-.6 2h-.2zm-.4-1.6.5 1.6v.4h-.2l-.5-1.7v-.3zM9.1 155h-.7v.4H9zm0 .7h-.7v.2H9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M9.5 154h-1v-.5q0-.3-.3-.4h-.4q-.3 0-.4.4v.6h-1q-.3 0-.4.4v2.1q0 .3.4.4h3.1q.4 0 .4-.4v-2.1q0-.4-.4-.4m-1.7-.5h.4v1h-.4zm1.7 3.1h-3v-2.1h.9q0 .4.4.4h.4q.3 0 .4-.4h1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M7.4 155.7a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6m.4.2H7q-.2 0-.2.3H8q0-.3-.2-.3m6.2-.3-.1-.2-.1-.1-.2-.1-.3-.1-.4-.2-.2-.1-.2-.3v-.2l.2-.6.3-.1h.8l.4.4v.3H14v-.2l-.2-.2H13l-.2.1v.4l.1.1.2.2h.3l.4.2.3.2.1.2v.6l-.2.2-.3.1H13l-.3-.1-.3-.3v-.3h.3v.2l.2.2h.8l.2-.1zm1.5-1.3v.2h-1v-.2zm-.7-.5h.3v2.1h.4v.3H15l-.1-.1-.1-.3zm2.3 2.1v-1.2l-.2-.2h-.5l-.1.2v.1h-.4v-.2l.2-.2.2-.1h.8l.2.2.1.4v1.3h-.3zm0-.9v.3h-.8v.2l-.1.1v.2l.1.1h.3l.4-.1.1-.2.1.1v.2l-.4.3h-.6l-.3-.2v-.6l.2-.2.3-.1zm1.3 1.2h-.3v-2.5l.3-.2.4-.1h.2v.3h-.4l-.1.2v2.3m.5-2v.3h-1.1v-.2zm.8 2h-.3v-2.5l.3-.2.4-.1h.2v.3H20l-.1.2zm.5-2v.3H19v-.2z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "l",
    width: 390,
    height: 15,
    x: 55,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#l)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m",
    width: 390,
    height: 15,
    x: 55,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M422.6 8.9h.4v-.5h-.4zm.2-3.7a2.3 2.3 0 1 0 0 4.6 2.3 2.3 0 0 0 0-4.6m0 4.2a1.9 1.9 0 1 1 0-3.8 1.9 1.9 0 0 1 0 3.8m0-3.3a1 1 0 0 0-1 1h.5q.1-.5.5-.5t.5.4c0 .5-.7.4-.7 1.2h.4c0-.5.8-.6.8-1.2q-.1-.9-1-1m9.4-1-2.1.9v1.4a3 3 0 0 0 2 2.8 3 3 0 0 0 2.2-2.8V5.9zm1.6 2.3q0 .6-.3 1.2l-.3-.4a1.2 1.2 0 1 0-.4.4l.4.4q-.4.5-1 .7-1.6-.6-1.7-2.3V6.2l1.7-.8 1.6.8zm-1.6.9a.7.7 0 1 1 0-1.4.7.7 0 0 1 0 1.4m12.2-.7a2.8 2.8 0 1 0-5.6 0 2.8 2.8 0 0 0 5.6 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0b0b0b",
    d: "M442 8v-.2l-.2-.2h-.2l-.3-.2h-.2l-.2-.7.2-.1.2-.2h.7q0 .2.2.3V7h-.2v-.2l-.2-.1h-.5l-.1.2v.2l.2.1.2.1.3.1.2.2.2.1v.4l-.2.2-.2.1h-.8l-.2-.3V8h.2l.1.3h.6z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    filter: "url(#o)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 391.2,
    height: 233.4,
    x: 53,
    y: 15,
    fill: "#1c1c1c",
    rx: 3.8,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 390.7,
    height: 233,
    x: 53.2,
    y: 15.2,
    stroke: "url(#p)",
    strokeWidth: 0.5,
    rx: 3.5,
    shapeRendering: "crispEdges"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#9a9ca5",
    d: "M60.3 21.4v5.3h-.7v-5.3zm1.7 0v.5h-4.1v-.5zm2 5.4-.8-.2a2 2 0 0 1-1-1v-1.8l.5-.6a2 2 0 0 1 1.9-.4l.5.4.3.6.1.8v.3h-3v-.6h2.3v-.5l-.4-.4-.5-.2a1 1 0 0 0-.8.4l-.2.5v1.3l.2.4.4.3.5.1.6-.1.4-.4.4.3-.3.4-.5.3zm3-3.3v3.2h-.7v-4h.6zm-.2 1h-.3l.1-.7.3-.6.5-.4.7-.1h.5a1 1 0 0 1 .7.7l.1.6v2.7h-.7v-3.1l-.4-.3h-.9l-.3.3-.2.5zm2.6-.3-.5.1.1-.6.3-.5.5-.4.7-.1h.6l.4.3.3.4v3.3h-.6V24l-.1-.5-.3-.3h-.9l-.3.2-.1.3zm4.1-.7v4.7H73v-5.5h.6zm2.7 1.2v.9l-.4.6-.5.4-.6.2q-.4 0-.7-.2-.2 0-.5-.3l-.3-.6-.2-.7v-.5l.2-.7q0-.4.3-.6l.5-.4.7-.1.6.1q.3 0 .5.4l.3.6zm-.7 0V24l-.2-.4a1 1 0 0 0-.8-.5l-.5.1-.3.2-.2.4-.1.4v1l.2.4q0 .3.3.4l.6.1.4-.1q.3 0 .4-.3l.2-.5zm2.3-3.6v5.6h-.7V21zm3.4 5v-2.5l-.3-.3-.5-.1H80l-.3.3-.2.3H79v-.4l.4-.4.5-.2.6-.1.8.1.5.4q.3.3.2.8v2.2l.2.4h-.8V26m.2-1.8v.5h-1.2l-.4.1-.3.3v.6l.3.3h.4a1 1 0 0 0 1-.4l.1-.4.3.4-.1.3-.8.7h-.6l-.7-.1-.5-.4-.1-.6.1-.6.4-.4.5-.2.8-.1zm3.2-1.6v.5h-2.1v-.5zm-1.4-1h.7V26l.2.1h.6v.6h-1l-.4-.4v-4.6m3.9 5h-.8a2 2 0 0 1-1-1v-1l.1-.9.4-.6a2 2 0 0 1 2-.4l.4.4.3.6.1.8v.3h-3v-.6H88v-.5l-.4-.4-.5-.2a1 1 0 0 0-.8.4l-.2.5v1.3l.2.4.4.3.5.1.6-.1.5-.4.4.3-.4.4-.4.3zm4.6-1v-.3l-.3-.3-.6-.1-.6-.2-.4-.2-.3-.4-.1-.4v-.4l.4-.4.4-.3h.6l.9.1.5.5.2.6H92l-.1-.3-.3-.3h-.9l-.3.2v.5l.1.1.3.2.5.1q.5 0 .8.3.3 0 .4.3l.2.6a1 1 0 0 1-.4.8l-.5.3h-.6l-1-.1-.5-.5-.2-.6h.7l.2.4.3.2h1l.2-.2z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "q",
    width: 382,
    height: 12,
    x: 57.7,
    y: 32.4,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.7 32.4h382v12h-382z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7 32.4h381.8v11.3H57.7z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.5 43.7v-.2H57.7v.4h381.8z",
    mask: "url(#q)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M64.2 37.3v.6l-.3.4-.3.2H63l-.4-.2-.2-.4v-1l.2-.4.3-.2.4-.1h.4l.3.3.2.4zm-.4.2V37l-.1-.3-.2-.1H63l-.2.1v.3l-.1.3v.5l.1.3.2.1h.5l.2-.1v-.3zm1.2-.3v1.4h-.4v-1.8h.4zm.5-.4v.4h-.3l-.2.2v.2h-.1V37l.2-.1zm.3-.7h.4v2.5h-.4zm1.5 1.6v.4l-.2.2-.2.2h-.6l-.2-.1V38l-.2-.3v-.2l.1-.3.1-.3.2-.1.3-.1h.3l.2.2.2.3zm-.4 0v-.4l-.2-.1h-.4l-.2.2v.7l.2.1h.5v-.3zm1.2-.9v1.8h-.4v-1.8zm-.5-.4.1-.2h.3v.3h-.3zm1.7.4v.3h-1v-.3zm-.7-.4h.4v1.8h.3v.4h-.5l-.1-.2v-2m1 1.3v-.4l.1-.2.3-.2.3-.1h.4l.2.3.2.2v.8l-.2.2-.6.3H70l-.3-.3-.1-.2zm.3 0v.2l.1.2.1.1h.5l.1-.3v-.6l-.4-.2h-.2l-.1.2v.2zm3.3-1.5v2.4h-.4v-2.4zm.8 0v.4H72v-.4zm.9 2.4h-.4l-.4-.5v-.8l.2-.3.2-.1.3-.1h.3l.3.2.1.3v.5h-1.3v-.3h1v-.2l-.2-.1-.2-.1h-.2v.2l-.2.1v.6l.1.1.2.1h.2l.4-.1.2.2-.1.1-.2.1zm1.4-1.4v1.4H76v-1.8h.3zm0 .4H76v-.3l.2-.3.2-.1.3-.1h.2l.2.1v.2l.1.3v1.2H77v-1.4h-.6zm1 0H77v-.3l.2-.3.5-.2h.2l.2.1.1.2v1.5H78v-1.4h-.6v.2zm1.9-.4v2h-.4v-2.4h.3zm1 .5v.6l-.3.2h-.6l-.2-.1-.1-.3v-.8l.1-.3.5-.2h.3l.2.2.1.3zm-.3 0v-.4a.3.3 0 0 0-.4-.2h-.2v.1l-.2.2v.7l.2.1h.5v-.3zm1.2-1.6v2.5h-.4V36zm1.4 2.1v-1h-.2l-.1-.1H82l-.1.1v.1h-.4v-.2l.2-.1.2-.2h.6l.3.3v1.3l.1.1h-.4v-.3m0-.7v.2h-.4l-.2.1v.4h.5l.1-.2.1.2v.1l-.2.1-.4.2h-.3l-.2-.3v-.5l.1-.1.3-.2zm1.6-.7v.3h-1v-.3zm-.7-.4h.4v1.8h.3v.4h-.5l-.2-.2zm1.8 2.2h-.4l-.4-.5v-.8l.2-.3.2-.1.3-.1h.3l.3.2.1.3v.5h-1.3v-.3h1v-.2l-.2-.1-.2-.1H85v.2l-.2.1v.6l.1.1.2.1h.2l.4-.1.2.2-.1.1-.2.1zm2-.5V38l-.2-.1h-.2l-.3-.1-.2-.1v-.2l-.1-.2v-.2l.1-.1.3-.2h.6l.2.3.1.2h-.4L87 37h-.4v.3l.1.1h.2l.3.1.3.2v.3l-.2.3-.2.2h-.7l-.2-.3V38h.3v.2h.2l.1.1h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M58.2 43.2h33.7v.5H58.2z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M98.2 37.8h.4q0 .3-.2.4l-.3.3h-.8l-.3-.2-.2-.4v-1.1l.2-.3.3-.2.4-.1.4.1q.3 0 .3.3l.2.4h-.4l-.1-.3-.2-.1h-.5l-.1.1-.1.3v1l.2.1h.5l.2-.1zm1.8.4v-1.4h.4v1.8h-.4zm0-.4h.2v.3l-.2.3-.2.1H99l-.1-.3V37h.3v1.3h.5q.2 0 .2-.2zm1.7.3v-.2h-.3l-.3-.1-.2-.1-.1-.2v-.4l.1-.1.2-.2h.7l.2.3.1.2h-.4l-.1-.2h-.4v.3l.1.1h.2l.3.1.2.2.1.3-.2.3-.2.2h-.7l-.2-.3-.1-.3h.4v.2zm1.6-1.3v.3h-1v-.3zm-.7-.4h.4v1.8h.2v.4h-.4l-.2-.2zm.9 1.3v-.4l.2-.2.3-.2.3-.1h.3l.3.3.1.2.1.4v.4l-.2.2-.3.2h-.6l-.3-.2-.2-.2zm.4 0v.4l.4.2.3-.2V38l.1-.2v-.4l-.4-.2-.3.2-.1.2zm2-.5v1.4h-.5v-1.8h.4zm-.1.4h-.2v-.3l.2-.3.2-.1.3-.1h.2l.2.1.1.2v1.5h-.3v-1.4h-.6l-.1.2zm1 0v-.3l.1-.3.5-.2h.3l.2.1v.2l.1.3v1.2h-.4v-1.4h-.6v.3"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M61.4 53.4h-.2q.3-.5.3-1a1.5 1.5 0 1 0-.5 1.1v.3l1.2 1.1.3-.3zm-1.4 0a1 1 0 1 1 0-2.1 1 1 0 0 1 0 2.1"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#9a9ca5",
    d: "m67 53.2-.1-.2-.1-.1-.2-.1-.3-.1-.4-.1-.2-.2-.2-.2v-.3l.2-.5.3-.2h.8l.4.4v.4H67v-.3l-.2-.2H66l-.2.2v.3l.1.2h.2l.3.2.4.1.3.2.1.2v.6l-.2.2-.3.2H66l-.3-.2-.3-.2V53h.3v.2l.2.2h1zm1.5.7h-.3l-.5-.6v-.9l.2-.3a1 1 0 0 1 1-.2l.2.2.2.3v.6h-1.5v-.3H69v-.3l-.2-.2h-.3l-.4.1-.1.3v.6l.1.2.2.2h.6l.2-.2.2.1-.2.2-.2.2zm2.4-.4v-1.2l-.2-.1h-.6v.2h-.4v-.2l.2-.2h.3l.3-.1h.4l.2.3.1.3v1.2l.1.1H71zm0-.8v.2h-.5l-.2.1-.1.1v.5h.3l.5-.2v-.2l.2.2v.1l-.5.4H70l-.2-.3-.1-.3V53l.2-.2h.3l.4-.1zm1.2-.5V54h-.3v-2h.3zm.7-.3v.3h-.4l-.2.1v.2l-.1.2H72v-.3l.1-.3.2-.2zm1 1.7h.3l.2-.2v-.2h.4q0 .3-.2.4l-.6.3h-.4l-.3-.3-.2-.3v-.8q0-.3.2-.3l.3-.3h.8l.2.3.2.4h-.4v-.2l-.2-.2h-.5l-.2.2v1l.2.2zm1.6-2.5v2.8h-.3V51zm0 1.7h-.2v-.4l.2-.3.6-.2h.3l.2.1v.2l.1.4v1.3h-.3v-1.6l-.2-.1H76l-.4.1zm1.8.9.2-.1h.1l.1.2v.1l-.2.1h-.2zm1 0 .2-.1h.2v.3l-.2.1h-.1zm1 0 .2-.1h.2v.3l-.2.1h-.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#616467",
    strokeWidth: 0.2,
    d: "M57.7 57.6h51.6"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7 61.5h381.8v13.1H57.7z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.5 74.6v-.2H57.7v.5h381.8z",
    mask: "url(#v)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7 61.5h184v13.1h-184z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M67.8 69.2h-.3l-.4-.5-.1-.3V68l.2-.3.3-.2h.6l.2.2.2.3v.5h-1.3v-.3h1L68 68l-.1-.2h-.4l-.1.1v.2l-.1.2v.3l.1.2.2.1h.2l.4-.2.2.2-.2.2-.2.1zm-3.2-1.4v1.4h-.4v-1.7h.3zm-.1.5v-.4l.1-.2.3-.2h.6l.2.3v1.4h-.4V68l-.1-.1h-.4l-.1.1zm1-.1V68l.2-.2.5-.3h.2l.2.2v.2l.1.3v1.1h-.4V68l-.1-.1h-.4l-.1.2zm-2.2.7v-1l-.1-.1h-.4v.2h-.5v-.2l.2-.2.3-.1h.6l.2.2.1.3v1.2h-.3V69m.1-.7v.2h-.6l-.1.3v.1l.1.1h.2l.3-.1v-.2l.2.2v.1l-.2.2-.4.1h-.3l-.2-.2-.1-.3v-.2l.2-.2.3-.1zm-1.6-1.4v2.3h-.4l-1-1.7v1.7H60V67h.4l1 1.7V67z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M241.7 61.5h46.9v13.1h-47z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "m268 68.7.5-1.5h.4l-.7 2v.1l-.1.2h-.2l-.2.1h-.2v-.3h.2l.1-.1.1-.1zm-.2-1.5.4 1.3v.4h-.2l-.6-1.7zm-1.1.3V69h-.4v-1.7h.4zm.5-.3v.3h-.3l-.2.2v.2h-.1v-.5l.3-.2zm-2.9.8v-.3l.2-.3.3-.2h.7l.2.2.2.3v.7l-.2.3-.6.2h-.3l-.4-.5zm.4 0v.3l.1.2h.1l.2.1.4-.1v-.9l-.4-.1h-.2v.1l-.2.2zm-1.1-.8h.4v1.7l-.1.4-.3.2h-.9l-.2-.2.2-.2.2.1h.5l.1-.1v-1.5zm-1.2.9v-.4l.2-.3.5-.3.3.1.2.2.1.2.1.4v.4l-.2.3-.5.2-.5-.2-.1-.3zm.4 0v.2l.1.2h.1l.2.1h.2l.2-.2v-.8l-.2-.1h-.4v.1l-.2.2zm-1.3.9-.4-.1-.4-.5v-.7l.2-.3.2-.2h.6l.3.2.1.2v.6h-1.3v-.3h1v-.2l-.2-.2h-.4v.1l-.2.2v.5l.1.2.2.1h.2l.4-.2.2.2-.1.2h-.2zm-1.1-1.8v.3h-1v-.3zm-.7-.4h.4v1.8h.3v.3h-.5l-.2-.2zm-1 1.8v-1l-.1-.1h-.4v.2h-.5v-.2l.2-.2.3-.1h.6l.2.2.1.3V69h-.3v-.3m0-.7.1.2h-.6v.2h-.1v.2l.1.1h.2l.3-.1v-.2l.2.2v.1l-.2.2-.4.1h-.3l-.2-.2-.1-.3v-.2l.2-.2.3-.1zm-1.9.1h.4l-.1.5-.3.2-.5.1h-.4l-.3-.3-.2-.3v-1.1l.2-.4.3-.2h.9l.3.3.1.4h-.4v-.2l-.2-.2h-.5l-.2.2-.1.2v1.1l.2.2h.6l.1-.2zm-2.6-.9v.3h-1v-.3zm-.7-.4h.4v1.8h.2l.1.3h-.5l-.2-.2zm-1.2 1.8h.2l.1-.1v-.2h.5l-.1.3-.3.3h-.7l-.2-.2-.2-.3v-.7l.2-.3.2-.2h.7l.3.3v.3h-.3v-.2l-.4-.1h-.2v.1l-.1.2v.7h.1zm-1.7.4-.4-.1-.4-.5v-.7l.2-.3.2-.2h.7l.2.2.1.2v.6h-1.2v-.3h1l-.1-.2-.1-.2h-.4l-.1.1-.1.2v.7l.2.1h.2l.5-.2.2.2-.2.2h-.2zm-1.6-1.8h.4v2.2l-.3.1-.3.1h-.2v-.3h.2l.2-.1zm0-.5h.3l.1.1v.2h-.4zm-2 1.4v-.3l.2-.3.3-.2h.6l.3.2.2.3v.7l-.2.3-.6.2h-.3l-.4-.5zm.4 0v.5h.2l.2.1h.2l.1-.1v-.2l.1-.2v-.5l-.4-.1h-.2l-.1.1v.2zm-1.1-.5V69h-.4v-1.7h.4zm.5-.3v.3h-.3l-.2.2v.2h-.1v-.3l.1-.2.2-.2zm-2.1.8h-.6v-.3h.9l.1-.2v-.4l-.1-.1-.3-.1h-.5v2h-.4v-2.3h1.4l.2.3.1.4v.4l-.3.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M288.5 61.5H312v13.1h-23.4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M301 67.9v1.3h-.4v-1.7h.4zm0 .4h-.2V68l.2-.3.3-.2h.5l.1.1.1.2v1.4h-.3V68h-.1l-.2-.1-.3.1zm-2.3.1V68l.2-.3.2-.2h.7l.3.2.1.3v.7l-.1.3-.3.2h-.7l-.2-.2-.2-.3zm.4 0v.4l.4.2.3-.2v-.2l.1-.2V68l-.1-.1-.3-.2-.3.2-.1.1zm-.8-.9v1.7h-.4v-1.7zm-.4-.4v-.2h.4v.3zm-.8 1.7-.1-.1h-.3l-.2-.2h-.2l-.1-.2v-.4l.1-.2h.2l.3-.1h.4l.2.2v.3h-.3l-.1-.2h-.4v.3l.3.1.3.1.2.2.1.3-.2.3-.2.1h-.7l-.2-.2-.1-.3h.3l.1.2zm-1.8-1v1.4h-.4v-1.7h.4zm.6-.3v.4h-.4l-.2.2v.1-.5l.2-.2zm-1.9 1.8h-.4l-.5-.5V68l.2-.3.3-.2h.6l.2.2.2.3v.5h-1.3v-.3h1l-.1-.2-.1-.2h-.4l-.1.1-.1.2v.7l.2.1h.2l.5-.1.2.2-.2.1-.2.1zm-2.1-.5.6-1.9h.5l-.9 2.3h-.3zm-.6-1.9.6 2 .1.3h-.3L291 67z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M312 61.5h46.9v13.1h-47z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M334.1 69v-2.2h.4v2.5h-.3zm-1.1-.6v-.3q0-.2.2-.3l.2-.2h.6l.2.2v.2l.2.4-.1.4-.1.3-.5.2-.5-.2-.2-.3zm.4 0v.4l.2.2h.4l.1-.2V68l-.2-.1h-.3l-.1.1-.1.2zm-1.4.9h-.3l-.4-.5-.1-.3V68l.2-.3.3-.2h.6q.2 0 .2.2l.2.2v.5h-1.3v-.2h1l-.1-.3-.1-.1h-.5v.3l-.1.2v.3l.1.2h.2l.2.1.4-.2.2.2-.1.2h-.3zm-1.2-1.7v1.7h-.4v-1.7zm-.4-.5.2-.1h.2v.3l-.2.1h-.2zm-.7 2.2h-.4v-2l.1-.2.2-.2.3-.1h.3v.3h-.4v2.2m.4-1.7v.2h-1v-.2zm-1.5 0v1.7h-.4v-1.7zm-.4-.5.2-.1h.2v.3l-.2.1h-.1zm-.8 1.9v-2.2h.4v2.5h-.4zm-1.1-.6v-.3l.1-.3.3-.2h.5l.2.2.1.2.1.4v.4l-.2.3-.5.2-.5-.2-.1-.3zm.3 0v.3l.1.1.2.2h.3l.2-.2V68l-.2-.1h-.3l-.2.1v.4m-2.3 0v-.3q0-.2.2-.3l.2-.2h.7l.3.2.1.3v.7l-.1.3-.6.2h-.4l-.4-.5zm.3 0v.3l.1.2h.2l.2.1h.1l.2-.1V68l-.3-.2h-.2l-.2.2v.4M322 68v1.3h-.4v-1.7h.4zm0 .4h-.2V68l.2-.2.2-.2h.7l.1.3v1.4h-.3V68l-.2-.1h-.5zm1-.1h-.2V68l.2-.2.2-.2h.6l.2.3v1.3h-.3V68l-.1-.1h-.4l-.2.2zm-2.6-.7v.2h-1v-.2zm-.7-.5h.4V69h.1l.1.1h.1v.3h-.4l-.2-.2v-2m-.9 1.6-.2-.2h-.2l-.2-.1-.2-.1-.2-.2V68l.2-.2.2-.1h.6l.3.2v.3h-.3V68h-.6v.2l.1.1h.2l.4.2.2.1v.3l-.1.4h-.3l-.2.1h-.4l-.3-.3v-.2h.3v.1l.2.1h.4zm-1.9.2v-1.1h-.5v.2h-.4v-.2l.2-.2.2-.1h.6l.3.2V69l.1.2h-.4v-.4m.1-.8v.3h-.6v.4l.2.1.3-.1.1-.2.1.2v.1l-.3.3h-.6l-.2-.2v-.5l.1-.2.3-.1zm-1.4.9v.3h-1.2V69zm-1-2v2.3h-.5V67z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M358.9 61.5h46.9v13.1h-47z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M372.5 69.3h-.4l-.4-.5V68l.1-.2.3-.2h.6l.3.2.1.2v.5h-1.3v-.3h1V68l-.2-.1h-.4l-.2.3v.5l.1.1.2.2h.2l.4-.2.2.2-.1.1-.2.2zm-1.1-.3v.3H370V69zm0-1.2-1.2 1.5h-.2V69l1-1.5h.3zm-.2-.3v.4H370v-.4zm-1.6 0v1.8h-.4v-1.8zm-.5-.4.1-.2h.3v.3zm-.7 1.7h-.1l-.3-.2h-.2l-.2-.1-.2-.2v-.4l.2-.1.2-.1h.6l.3.2v.3h-.3V68h-.2l-.1-.1h-.2l-.1.1v.2l.2.1h.1l.4.2.2.1v.3l-.1.4h-.2l-.3.1h-.4l-.3-.3v-.3h.3v.2l.2.1h.5zm-2.9.5h-.3l-.4-.5-.1-.3V68l.2-.2.3-.2h.6q.2 0 .2.2l.2.2v.5H365v-.3h1l-.1-.2-.1-.1h-.5v.3l-.1.2v.3l.1.1.2.2h.1l.5-.2.2.2-.2.1-.2.2zm-1.2-2.5v2.5h-.4v-2.5zm-.9.7v1.8h-.4v-1.8zm-.4-.4v-.2h.4v.3zm-1.4-.1v2.3h-.4v-2.4zm1 1v.3h-1.1V68zm0-1v.3h-1.1v-.4z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M405.7 61.5h18.8v13.1h-18.8zm18.8 0h15v13.1h-15z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "M",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7 74.6h381.8v12.2H57.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "z",
    width: 4,
    height: 5,
    x: 60,
    y: 78,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0f9d58",
    d: "M62.4 78.8H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3V80l-.6-.5z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "A",
    width: 4,
    height: 5,
    x: 60,
    y: 78,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M61.4 80.7v1.2h1.4v-1.2zm.6 1h-.4v-.2h.4zm0-.3h-.4v-.2h.4zm0-.3h-.4v-.3h.4zm.6.6h-.4v-.2h.4zm0-.3h-.4v-.2h.4zm0-.3h-.4v-.3h.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "B",
    width: 4,
    height: 5,
    x: 60,
    y: 78,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#B)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "m62.5 79.8 1 1v-1z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "D",
    width: 4,
    height: 5,
    x: 60,
    y: 78,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#D)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87ceac",
    d: "M62.4 78.8v.8q0 .3.3.3h.8z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "E",
    width: 4,
    height: 5,
    x: 60,
    y: 78,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#E)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M61 78.8q-.3 0-.3.3 0-.2.3-.2h1.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "F",
    width: 4,
    height: 5,
    x: 60,
    y: 78,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#F)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.2,
    d: "M63.2 82.6H61l-.3-.3q0 .3.3.3zq.2 0 .3-.3 0 .3-.3.3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "G",
    width: 4,
    height: 5,
    x: 60,
    y: 78,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#G)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.1,
    d: "m62.7 79.9-.3-.3q0 .3.3.3h.8z"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M62.4 78.8H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3V80z"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M78.1 79.9v.3h-1v-.3zm-.7-.5h.4v1.8h.1l.1.1h.1v.3h-.5l-.1-.2-.1-.3zm-1.1 2.2h-.4l-.4-.5v-.7q0-.2.2-.3l.2-.2h.7l.2.2.1.2v.6h-1.3v-.3h1v-.2l-.2-.2h-.2l-.2.1-.1.2v.7h.2l.2.1h.3l.1-.2.3.2-.2.2-.2.1zm-1.6-1.7h.4v1.7l-.1.4-.3.2a1 1 0 0 1-.9 0l-.2-.2.2-.2.2.1h.5l.1-.1v-1.5zm-1.2.9v-.4l.2-.3.2-.2h.6l.2.2.1.3.1.3v.4l-.2.3-.2.2h-.3l-.5-.2-.1-.3zm.5 0v.3l.2.2h.3l.2-.2v-.7l-.2-.2h-.3l-.2.1zm-1.2.5v-2h.4v2.4h-.4zm-1.2-.4v-.4l.2-.3.2-.2h.6l.2.2.1.3v.7l-.1.3-.2.2H72l-.2-.2-.1-.3zm.5 0v.3l.2.2h.3l.2-.2v-.7h-.1l-.1-.2h-.2l-.3.1v.4m-1.2.5V80h.4v1.7h-.4zm0-.4h.2v.4l-.2.2-.2.2h-.5l-.2-.1-.1-.2V80h.3v1l.1.1h.1l.1.1h.3V81zm-2.3-.2H68v-.3h.8a.3.3 0 0 0 .2-.4v-.1l-.2-.1h-.6v2h-.5v-2.4H69l.3.1.1.2v.6l-.2.2h-.3zm0 1H68l.2-.3h.7l.2-.2v-.4H69l-.3-.1h-.4v-.3h.6l.4.2.2.2v.6l-.3.2zm-1.1 0v.3H66v-.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M258.8 80.6v1.3h-.3v-1.7h.3zm-.1.4h-.1v-.3l.2-.3.5-.2h.2l.2.1.1.2V82h-.3v-1.3l-.1-.1h-.6zm-2.2 0v-.3l.2-.3.2-.2h.7l.2.2.2.3v.7l-.2.3-.5.3-.4-.1-.4-.5zm.3 0v.3l.1.2.2.2h.4l.1-.2.1-.2v-.7l-.2-.1h-.4l-.2.1v.2zm-.8-.8v1.7h-.3v-1.7zm-.3-.5.2-.1h.1v.3h-.2zm-.4.5v.2h-.9v-.2zm-.6-.4h.3v1.8l.1.1h.2v.2h-.4l-.1-.1zm-1.3 1.9.4-.1v-.2h.3v.3l-.7.3-.3-.1-.2-.2-.2-.3v-.7l.2-.3.2-.2h.7l.2.3.1.3h-.2l-.1-.2-.4-.2h-.2l-.1.2-.1.2v.7l.2.2zm-1.5-.2v-1.3h.4v1.7h-.3zm.1-.3v.3l-.1.2-.2.2h-.6l-.3-.3v-1.4h.3v1.4l.2.1h.4l.2-.3zm-1.9.4v-2.1h.3v2.4h-.3zm-1.2-.5v-.4l.2-.3.5-.2h.3l.2.2.2.2v.9l-.2.2-.2.2h-.6l-.2-.2-.1-.3zm.3 0v.2l.1.2.2.2h.2l.4-.2v-.9l-.2-.1h-.4l-.2.1zM247 81v-.3l.2-.3.3-.2h.6l.3.2.1.3.1.3v.4l-.2.3-.6.3-.3-.1-.3-.2-.1-.3zm.3 0v.3l.1.2.2.2h.4l.2-.2v-.2l.1-.2v-.3l-.1-.2-.2-.1h-.4l-.2.1zm-1.1-.5v1.4h-.3v-1.7h.3zm.5-.3v.3h-.4l-.1.2v.2h-.2v-.3l.2-.2.1-.2zm-2 .8h-.6v-.2h.9l.1-.3v-.4l-.1-.2h-.9v2h-.3v-2.3h1.3l.3.3.1.4-.1.4-.3.2z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 78,
    fill: "#2f2f2f",
    rx: 2.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 78,
    stroke: "#616467",
    strokeWidth: 0.2,
    rx: 2.7
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M299.7 80.5v.8l-.2.3-.2.2h-.5l-.2-.1-.1-.2-.1-.3v-1.1l.1-.3.2-.1h.6l.3.2v.3zm-.3.4v-.8l-.1-.2h-.5l-.2.3v1.2l.2.1.2.1h.2l.1-.2.1-.2zm-1.9.8v-.2h.3v.3zm-.8-2.1v2.2h-.3V80l-.6.2v-.3zm-1.7 2.1v-.2h.2v.3zm-1-2.1v2.2h-.2V80l-.6.2v-.3zm54.8 1.7V81h-.2l-.2-.1-.3-.1-.2-.1-.1-.2v-.1l.1-.4.2-.1h.7l.2.2v.3h-.2v-.1l-.2-.2h-.4l-.1.1v.3h.2l.2.1.3.1.2.2v.2l-.1.4-.2.1h-.7l-.2-.2-.1-.3h.3v.2h.7zm-2.9-2h.3v2.4h-.3zm1.5 1.5v.4l-.2.3-.2.2h-.6l-.2-.2-.2-.2v-.9l.2-.2.2-.2h.6l.2.2.1.3zm-.3 0v-.2l-.1-.2-.4-.2h-.2l-.1.1-.1.2v.8l.2.1.2.1h.2l.2-.2V81m-2.2.7h-.3l-.4-.5v-.7l.2-.3.5-.2h.3l.2.2.2.3v.4h-1.3v-.2h1v-.3l-.2-.1-.2-.1-.3.2-.1.2v.7l.2.2h.5l.2-.2.2.1-.2.2-.2.1zm-2.9-.7.4-1.6h.3l-.2.6-.5 1.7h-.2zm-.5-1.6.4 1.6v.7h-.2l-.5-2.3zm1.8 1.6.3-1.6h.3l-.5 2.3h-.3zm-.6-1.6.4 1.6.2.7h-.2l-.5-1.7-.1-.6zm-2.8.6v1.7h-.3V80zm-.3-.5h.3v.2h-.2m-2.7.6v1.4h-.3V80h.3zm0 .5h-.2v-.3q0-.2.2-.3l.2-.2h.5l.3.3v1.4h-.2v-1.3l-.2-.2h-.4l-.2.2zm1-.2v-.2l.1-.2.3-.2h.5l.2.1v.2l.1.3v1.1h-.3v-1.4h-.1l-.2-.1h-.2l-.1.1-.1.2zm-2.1.8v-1.1h-.2l-.2-.1h-.2l-.1.1v.2h-.3v-.2l.1-.2.3-.1h.6l.2.2v1.1l.1.2v.2h-.3zm0-.7v.2h-.6l-.1.2v.3h.3l.4-.1V81l.1.2v.1l-.3.3h-.6l-.2-.2V81l.1-.2.3-.1zm-2.8-1.3v2.3h-.3v-2.3zm1.4 0-1 1-.5.6v-.3l.4-.4.8-1zm-.3 2.3-.8-1.1.2-.3 1 1.4zm-2.6-.7v.2h-1.7V81l1-1.6h.3l-.3.5-.7 1zm-.3-1.6v2.3h-.3v-2.3zm-1.7 2.1v.2H328v-.2l.8-.8q0-.2.2-.3l.1-.2v-.4l-.1-.1-.3-.1h-.2l-.2.2v.3h-.3v-.4l.3-.3h.8l.3.2v.8l-.2.2-.2.2-.6.7zm-1.9-1.1v.8l-.2.3-.2.2h-.8l-.1-.3-.1-.3V80l.1-.3.3-.2h.5l.4.3v.3zm-.3.4v-1l-.2-.1-.2-.1h-.2l-.2.2v1.5l.2.2h.4v-.2l.2-.2zm-1.5.7v.2h-1.6v-.2l.8-.8.2-.3.1-.2v-.4l-.1-.1-.2-.1h-.3l-.2.2v.3h-.3v-.4l.3-.3h.8l.3.2v.8l-.2.2-.2.2-.6.7zm-2.8-.1v.5l-.3.3-.1-.1.1-.3v-.4zm-1.2-2v2.3h-.3v-2l-.6.3v-.3zm-3.4 1v1.3h-.3V80h.3zm0 .4h-.2l.1-.3.1-.3.6-.2h.4v.3l.1.3v1.1h-.3v-1.3l-.1-.2h-.2l-.4.2-.1.2zm-1.1.6v-1.1h-.1l-.2-.1h-.2l-.2.1v.2h-.3v-.2l.2-.2.2-.1h.6l.3.2v1.3l.1.2h-.3zm0-.7.1.2h-.7l-.1.2v.2l.1.1h.2l.4-.1V81l.2.2v.1l-.4.3h-.6l-.2-.2V81l.2-.2.2-.1zm-2 .3v-1.6h.3V81l-.1.4-.3.3h-.7l-.3-.3v-.3h.2v.2l.2.2h.5l.1-.2zm55.1-.2h-.5v-.3h.7l.2-.1V80l-.2-.2h-.7v2h-.3v-2.2h1.1l.2.1.2.2v.5l-.2.2-.3.1zm0 1h-.7l.2-.2h.8l.1-.2V81l-.1-.2h-.7v-.3h.6v.1l.4.1.1.2.1.3-.1.4-.3.2zm-2.6-2.2v2.3h-.3v-2.3zm1.4 0-1 1-.5.6V81l.4-.5.8-.8zm-.3 2.3-.8-1.2.2-.2 1 1.4zm-3.8-1.3h.5l.1-.2.1-.2v-.3h-.2l-.2-.1h-.2l-.2.2v.2h-.3l.3-.6h.8l.2.2.1.4v.2l-.2.2-.2.1h-.6zm0 .2v-.2h.6l.3.2.1.2v.5l-.2.2-.2.2h-.6l-.2-.2-.2-.4h.3v.2l.2.1h.4l.2-.1V81l-.2-.1h-.5m-1.9-.1h-.3l.2-1.2h1.2v.2h-1v.7l.1-.1h.5l.2.2.2.2v.7l-.2.2-.2.2h-.6l-.2-.1-.2-.2v-.3h.2l.1.2.2.1h.5l.1-.2v-.6l-.2-.1zm-1.3-1.2V82h-.3v-2l-.6.2V80z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#J)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "K",
    width: 5,
    height: 5,
    x: 408,
    y: 78,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 78.8h-4.2v3.8h4.2z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#K)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m409.1 82 .2.4.1.1.7-1.1h-1.3v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m410.9 80-.7-1.1-.1.2-1.3 2v.3h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m412.3 82.5.2-.1v-.2l.4-.6v-.2h-1.2l.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m410.9 80 .6-1.1h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M411.7 81.4H410l-.7 1.1h2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m412.3 80.1-.6-1q0-.2-.2-.2L411 80l.8 1.4h1.3v-.2z"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#L)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M429.4 79.5h.5v.5h-.5zm0 1h.5v1.4h-.5zm.2-2.1a2.3 2.3 0 1 0 0 4.7 2.3 2.3 0 0 0 0-4.7m0 4.2a1.9 1.9 0 1 1 0-3.8 1.9 1.9 0 0 1 0 3.8"
  })))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.5 86.8v-.2H57.7v.4h381.8z",
    mask: "url(#M)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#N)"
  }, _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "ad",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7 86.8h381.8V99H57.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#O)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Q",
    width: 4,
    height: 4,
    x: 60,
    y: 91,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0f9d58",
    d: "M62.4 91H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3v-2.4l-.6-.5z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "R",
    width: 4,
    height: 4,
    x: 60,
    y: 91,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#R)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M61.4 92.9V94h1.4v-1.2zm.6 1h-.4v-.2h.4zm0-.3h-.4v-.2h.4zm0-.4h-.4V93h.4zm.6.7h-.4v-.2h.4zm0-.3h-.4v-.2h.4zm0-.4h-.4V93h.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "S",
    width: 4,
    height: 4,
    x: 60,
    y: 91,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#S)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "m62.5 92 1 1v-1z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "U",
    width: 4,
    height: 4,
    x: 60,
    y: 91,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#U)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87ceac",
    d: "M62.4 91v.8l.3.3h.8z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "V",
    width: 4,
    height: 4,
    x: 60,
    y: 91,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#V)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M61 91q-.3 0-.3.3 0-.2.3-.2h1.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "W",
    width: 4,
    height: 4,
    x: 60,
    y: 91,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#W)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.2,
    d: "M63.2 94.8H61l-.3-.3q0 .3.3.3zq.2 0 .3-.3z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "X",
    width: 4,
    height: 4,
    x: 60,
    y: 91,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#X)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.1,
    d: "m62.7 92-.3-.2q0 .3.3.3h.8z"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M62.4 91H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3v-2.4z"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M114.4 93.8h-.3l-.5-.5v-.7l.2-.3.3-.2h.6q.2 0 .2.2l.2.2v.6h-1.3v-.3h1l-.1-.3h-.1l-.2-.1h-.2l-.1.1v.2l-.1.2v.3l.1.2h.6l.2-.1.2.2-.2.2h-.2zm-1.5-.5-.2-.2h-.2l-.2-.1-.2-.1-.2-.1v-.4l.2-.2.2-.1h.6q.2 0 .3.2v.3h-.3v-.1l-.2-.1h-.3l-.1.1v.1l.2.1h.1l.4.2.2.1v.3l-.1.4h-.9l-.3-.2v-.3h.3v.2l.2.1h.4zm-1.9.1v-1h-.4v.2h-.5v-.2l.2-.2.2-.1h.7l.3.5v1.2h-.4zm.1-.7v.3h-.5l-.1.3v.2h.4l.1-.2h.1l.1.1-.2.3-.4.1h-.3l-.2-.2V93q0-.2.2-.2l.2-.1zm-3-1.4h.5v2.5h-.5zm1.6 1.6v.4l-.2.3-.2.2h-.6l-.2-.2-.1-.3v-.8l.1-.2.2-.2h.6l.2.2.1.3zm-.5 0v-.4h-.1l-.2-.1h-.3v.2l-.1.2v.5l.2.1h.4l.1-.2zm-1.9.5v-.9l-.1-.1h-.4v.2h-.5v-.2l.2-.2.2-.1h.7l.2.2.1.3v1.2h-.4zm0-.7v.3h-.5v.4l.1.1h.2l.2-.2.1.1-.2.3-.4.1h-.3l-.2-.2V93l.2-.2.2-.1zM106 92v.4h-1V92zm-.7-.4h.4v1.8h.3v.4h-.5l-.2-.2zm-1 1.8v-1h-.4l-.1.2h-.4v-.2q0-.2.2-.2l.2-.1h.6l.3.2v1.3l.1.2h-.4zm.1-.7v.3h-.6v.4l.2.1h.2l.1-.2.2.1-.2.3-.4.1h-.3l-.2-.2V93l.1-.2.3-.1zm-2.6 1.1h-.5v-.4h.9l.2-.3v-.9l-.1-.2-.2-.1h-.8v-.4h1l.3.3.2.3.1.5v.5l-.6.6zm-.2-2.3v2.3h-.5v-2.3zm-1.3 1.8-.1-.2h-.2l-.3-.1-.2-.1-.1-.1v-.4l.1-.2.2-.1h.7l.3.2v.3h-.4v-.1l-.1-.1h-.4v.2l.1.1h.2l.3.2.3.1v.3l-.1.4h-.3l-.3.1h-.4l-.2-.3-.1-.3h.4v.2l.2.1h.4zm-1-1.3v.4h-1V92zm-.8-.4h.5v1.8h.3v.4h-.5l-.2-.2zm-1.6.8v1.4h-.4v-1.7h.4zm0 .5h-.2v-.4l.2-.2.5-.3h.2l.2.2v.2l.1.3v1.1h-.4v-1.3l-.1-.1h-.2l-.3.1zm-1.3.5V92h.4v1.7h-.4zm0-.4h.2v.3l-.2.3-.2.2H95l-.2-.1v-.2l-.1-.3V92h.4v1.3h.5l.1-.1zm-3 0v-.4l.2-.3.3-.2h.7l.2.2.2.3v.7l-.2.3-.2.2h-.7l-.3-.2-.1-.3zm.4 0v.2l.1.1.2.2h.3l.1-.2.1-.1v-.7l-.4-.1-.3.1zm-1.4.6.2-.3h.4l-.1.3-.3.2-.3.1h-.4l-.2-.2-.2-.3v-.7l.2-.3.2-.2h.7l.3.2v.4h-.3v-.2h-.2l-.2-.1h-.1l-.1.1-.1.2v.6l.2.1zm-1.8 0h.2l.1-.3h.4v.3l-.3.2-.4.1h-.3l-.3-.2-.1-.3v-.7l.1-.3.3-.2h.7l.2.2.1.4h-.4v-.2H90l-.2-.1h-.2v.1l-.1.2v.6l.1.1zm-2-1.7-.6 2h-.5l.9-2.3h.3zm.6 2-.7-2v-.3h.3l.8 2.3zm0-.9v.4h-1.3V93zm-2.3.4L86 93l-.2-.1-.2-.1-.2-.1v-.4l.2-.2.2-.1h.7l.2.2v.3h-.3v-.1l-.2-.1h-.3v.3h.2l.4.2.2.1.1.3-.2.4h-.9l-.3-.2v-.3h.3l.1.2.1.1h.4zm-2 .5h-.4l-.4-.5v-.7l.2-.3.2-.2h.7l.2.2.2.2v.6h-1.4v-.3h1v-.3h-.2l-.1-.1-.3.1-.1.2v.5l.1.2h.6l.2-.1.2.2-.2.2h-.2zm-.9-1.9v.4h-1V92zm-.7-.4h.4v1.8h.3v.4h-.5l-.2-.2zm-1 1.8v-1H81l-.1.2h-.4v-.2l.1-.2.3-.1h.6l.4.5v1.2h-.4zm0-.7.1.3H81v.4l.2.1h.2l.1-.2.2.1-.2.3-.4.1h-.3l-.2-.2V93l.1-.2.3-.1zm-3.1-1.2h1.3l.3.3v.7l-.2.2-.2.1-.2.1h-.7v-.3h.8l.1-.2V92l-.1-.1h-.7v1.9h-.4zm1.3 2.3-.5-1h.4l.6 1zM78.1 92v.4h-1V92zm-.7-.4h.4v1.8h.3v.4h-.5l-.1-.2-.1-.3zm-1.1 2.2h-.4l-.4-.5v-.7q0-.2.2-.3l.2-.2h.7l.2.2.1.2v.6h-1.3v-.3h1v-.3h-.2l-.2-.1-.2.1-.1.2v.7h.7l.1-.1.3.2-.2.2h-.2zM74.7 92h.4v1.7l-.1.4q0 .2-.3.3a1 1 0 0 1-.9 0l-.2-.2.2-.3.2.2h.5l.1-.1v-1.5zm-1.2 1v-.4l.2-.3.2-.2h.6l.2.2.1.2.1.4v.4l-.2.3-.2.2h-.3l-.5-.2-.1-.3zm.5 0v.3l.2.1h.3l.2-.1v-.8l-.2-.1h-.3l-.2.1zm-1.2.5v-2h.4v2.4h-.4zm-1.2-.5v-.3l.2-.3.2-.2h.6l.2.2.1.2v.8l-.1.3-.2.2H72l-.2-.2-.1-.3zm.5 0v.4l.2.1h.3l.2-.1v-.7l-.1-.1-.1-.1h-.2l-.3.1zm-1.2.5V92h.4v1.7h-.4zm0-.4h.2v.3l-.2.3-.2.2h-.5l-.2-.1-.1-.2V92h.3v1.2l.1.1h.5v-.1zm-2.3-.2H68v-.4h.8l.2-.3V92h-.8v1.9h-.5v-2.3H69l.3.1.1.2v.6l-.2.2h-.3zm0 1H68l.2-.4h.7l.2-.1V93l-.1-.1h-.7v-.4h.6v.2h.4l.2.2v.7l-.3.2zm-1.1 0v.3H66v-.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M258.8 92.8V94h-.3v-1.7h.3zm-.1.4h-.1v-.3l.2-.3.5-.2h.2l.2.1.1.2V94h-.3v-1.3l-.1-.2h-.2l-.4.2v.2zm-2.2.1v-.4l.2-.3.2-.2h.7l.2.2.2.3v.7l-.2.3-.5.3-.4-.1-.4-.5zm.3 0v.2l.1.2.2.2h.4l.1-.2.1-.2v-.7l-.2-.2h-.4l-.2.2v.2zm-.8-.9V94h-.3v-1.7zm-.3-.5h.3v.2h-.2m-.5.3v.2h-.9v-.2zm-.6-.4h.3v1.8h.1l.1.1h.1v.2h-.4l-.1-.1v-2m-1.3 2 .4-.3v-.1h.3v.3l-.7.3-.3-.1-.2-.2-.2-.3V93l.2-.3.2-.2h.7l.2.3.1.3h-.2l-.1-.2-.4-.2h-.2l-.1.2-.1.2v.7l.2.2zm-1.5-.3v-1.3h.4V94h-.3zm.1-.3v.3l-.1.2-.2.2h-.6l-.3-.3v-1.4h.3v1.4h.2l.1.1h.3l.2-.3zm-1.9.4v-2.1h.3V94h-.3zm-1.2-.5v-.4l.2-.3.5-.2h.3l.2.2.2.2v.9l-.2.2-.2.2h-.6l-.2-.2-.1-.3zm.3 0v.2l.1.2.2.2h.2l.4-.2v-1h-.2l-.2-.1h-.2l-.2.2v.4m-2.3.1v-.4l.2-.3.3-.2h.6l.3.2.1.3.1.3v.4l-.2.3-.6.3-.3-.1-.3-.2-.1-.3zm.3 0v.2l.1.2.2.2h.4l.2-.2v-.2l.1-.2V93l-.1-.2-.2-.2h-.4l-.2.2zm-1.1-.5V94h-.3v-1.7h.3zm.5-.3v.3h-.4l-.1.2v.2h-.2v-.3l.2-.2.1-.2zm-2 .8h-.6V93h.6l.3-.1.1-.2v-.4l-.1-.2h-.9v2h-.3v-2.3h1.3l.3.3.1.4-.1.4-.3.2z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 90.2,
    fill: "#2f2f2f",
    rx: 2.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 90.2,
    stroke: "#616467",
    strokeWidth: 0.2,
    rx: 2.7
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M299.7 92.7v.8l-.2.3-.2.2h-.5l-.2-.1-.1-.2-.1-.3v-1.1l.1-.3.2-.2h.6l.3.3v.3zm-.3.4v-.9h-.1l-.1-.2h-.4v.2l-.2.2v1.2h.2l.2.2h.2l.1-.2.1-.2zm-1.9.7.2-.1h.1v.3h-.2zm-.4-1.1v.8l-.2.3-.2.2h-.5l-.2-.1-.1-.2-.1-.3v-1.1l.1-.3.2-.2h.6l.3.3v.3zm-.3.4v-.9h-.1l-.1-.2h-.3l-.2.2v1.4l.2.2h.3l.1-.2.1-.2zm-1.8.7.1-.1h.1v.3h-.2zm-1-2V94h-.2v-1.8l-.6.2V92zm54.8 1.6-.2-.2h-.2l-.3-.1-.2-.1-.1-.2v-.2l.1-.3.2-.1h.7l.2.2v.3h-.2v-.2h-.2l-.2-.1h-.2l-.1.1v.2l.2.1.2.1.3.1.2.2v.2l-.1.4-.2.1h-.7l-.2-.3-.1-.2h.3v.2h.7zm-2.9-2h.3V94h-.3zm1.5 1.6v.4l-.2.3-.2.2h-.6l-.2-.2-.2-.2v-.9l.2-.2.2-.2h.6l.2.2.1.3zm-.3 0v-.2l-.1-.2-.4-.2h-.2l-.1.1-.1.2v.7l.2.2h.4l.2-.1v-.4m-2.2.9-.3-.1-.4-.5v-.7q0-.3.2-.3l.5-.3.3.1.2.2.2.3v.4h-1.3V93h1v-.3l-.2-.1-.2-.1-.3.1-.1.3v.7l.2.1h.5l.2-.1.2.1-.2.2h-.2zm-2.9-.8.4-1.6h.3l-.2.6-.5 1.7h-.2zm-.5-1.6.4 1.6v.7h-.2l-.5-2.3zm1.8 1.6.3-1.6h.3l-.5 2.3h-.3zm-.6-1.6.4 1.6.2.7h-.2l-.5-1.7-.1-.6zm-2.8.6v1.7h-.3v-1.7zm-.3-.5h.3v.2h-.2m-2.7.7V94h-.3v-1.7h.3zm0 .5h-.2v-.4l.2-.2.2-.2h.5l.3.3V94h-.2v-1.4h-.2l-.2-.1h-.2l-.2.2zm1-.2v-.2l.1-.2.3-.2h.7v.3l.1.3V94h-.3v-1.4h-.1l-.2-.1h-.2l-.1.1-.1.1zm-2.1.8v-1.1h-.2l-.2-.1h-.2l-.1.1v.2h-.3v-.2l.1-.2.3-.1h.6l.2.2v1.1l.1.2v.2h-.3zm0-.7v.2h-.6l-.1.1v.4h.3l.4-.1v-.2l.1.2v.1l-.3.3h-.6l-.2-.2v-.5l.1-.2.3-.1zm-2.8-1.3V94h-.3v-2.3zm1.4 0-1 1-.5.6V93l.4-.5.8-.8zm-.3 2.3-.8-1.1.2-.3 1 1.4zm-2.6-.8v.3h-1.7v-.2l1-1.6h.3l-.3.4-.7 1.1zm-.3-1.5V94h-.3v-2.3zm-1.7 2.1v.2H328v-.2l.8-.9.2-.2.1-.2V92l-.1-.2h-.5l-.2.2v.3h-.3v-.4l.3-.3h.8l.3.2v.8l-.2.2-.2.2-.6.7zm-1.9-1.1v.8l-.2.3-.2.2h-.6l-.2-.1-.1-.2-.1-.3v-1.2l.1-.3.3-.2h.5l.4.3v.3zm-.3.4v-1l-.2-.1-.2-.1h-.2l-.2.1v1.7h.6l.2-.3zm-1.5.7v.2h-1.6v-.2l.8-.9.2-.2.1-.2V92l-.1-.2h-.5l-.2.2v.3h-.3v-.4l.3-.3h.8l.3.2v.8l-.2.2-.2.2-.6.7zm-2.8-.1v.5l-.3.3-.1-.1.1-.3v-.4zm-1.2-2V94h-.3v-2l-.6.2V92zm-3.4.9V94h-.3v-1.7h.3zm0 .5h-.2l.1-.4.1-.2.6-.3h.2l.2.2v.2l.1.3V94h-.3v-1.4h-.1l-.2-.1-.4.2-.1.1zm-1.1.6v-1.1h-.1l-.2-.1h-.2l-.2.1v.2h-.3v-.2l.2-.2.2-.1h.6l.3.2v1.3l.1.2h-.3zm0-.7.1.2h-.7l-.1.1v.3l.1.1h.2l.4-.1v-.2l.2.2v.1l-.4.3h-.6l-.2-.2v-.5l.2-.2.2-.1zm-2 .3v-1.6h.3v1.6l-.1.4-.3.3h-.7l-.3-.3v-.3h.2v.2l.2.1h.5l.1-.1zm55.3-.2h-.6v-.3h.7l.2-.1v-.4l-.2-.2h-.7v2h-.3v-2.3h1.1l.3.2.1.2v.5l-.2.2zm0 1h-.7l.1-.2h.8l.2-.2v-.4l-.2-.2h-.7v-.3h.6v.1l.4.1.2.2v.7l-.3.2zm-2.7-2.3v2.4h-.3v-2.4zm1.4 0-1 1.1-.5.6V93l.4-.5.8-.9zm-.2 2.4-1-1.2.3-.2 1 1.4zm-2.8-.7-.1.4-.3.2-.4.1h-.3l-.3-.3-.1-.4.2-.4.2-.1.3-.1h.4l.3.3zm-.3 0v-.2l-.2-.2h-.5l-.1.2-.1.2v.3l.2.1h.5l.1-.1zm.2-1v.3l-.3.2h-.7l-.3-.2V92l.3-.2h.7l.2.2zm-.3 0V92l-.2-.1h-.4l-.1.1v.5l.1.1h.4zm-2-.7v2.4h-.3v-2l-.6.2V92zm-1.3 2.1v.3H361V94l.8-.9.2-.3.1-.2v-.3l-.1-.2h-.5l-.2.2v.2h-.3v-.3l.3-.3h.8l.3.2v.7l-.2.3-.2.2-.6.6z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Z)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ab",
    width: 5,
    height: 4,
    x: 408,
    y: 91,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 91h-4.2v3.8h4.2z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ab)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m409.1 94.2.2.4.1.1.7-1.1h-1.3v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m410.9 92.2-.7-1.1-.1.1-1.3 2.2v.2h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m412.3 94.7.2-.1v-.2l.4-.6v-.2h-1.2l.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m410.9 92.2.6-1.1h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M411.7 93.6H410l-.7 1.1h2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m412.3 92.3-.6-1q0-.2-.2-.2l-.6 1.1.8 1.4h1.3v-.2z"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M429.4 91.7h.5v.5h-.5zm0 1h.5V94h-.5zm.2-2.1a2.3 2.3 0 1 0 0 4.7 2.3 2.3 0 0 0 0-4.7m0 4.2a1.9 1.9 0 1 1 0-3.8 1.9 1.9 0 0 1 0 3.8"
  })))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.5 99v-.2H57.7v.4h381.8z",
    mask: "url(#ad)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae)"
  }, _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "au",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7 99h381.8v12.2H57.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ah",
    width: 4,
    height: 4,
    x: 60,
    y: 103,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ag"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ah)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0f9d58",
    d: "M62.4 103.2H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3v-2.5l-.6-.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ai",
    width: 4,
    height: 4,
    x: 60,
    y: 103,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ag"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ai)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M61.4 105v1.3h1.4V105zm.6 1.1h-.4v-.2h.4zm0-.3h-.4v-.2h.4zm0-.4h-.4v-.2h.4zm.6.7h-.4v-.2h.4zm0-.3h-.4v-.2h.4zm0-.4h-.4v-.2h.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aj",
    width: 4,
    height: 4,
    x: 60,
    y: 103,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ag"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aj)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "m62.5 104.2 1 1v-1z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "al",
    width: 4,
    height: 4,
    x: 60,
    y: 103,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ag"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#al)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87ceac",
    d: "M62.4 103.2v.8l.3.2h.8z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "am",
    width: 4,
    height: 4,
    x: 60,
    y: 103,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ag"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#am)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M61 103.2q-.3 0-.3.3 0-.2.3-.3h1.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "an",
    width: 4,
    height: 4,
    x: 60,
    y: 103,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ag"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#an)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.2,
    d: "M63.2 107H61l-.3-.3q0 .3.3.3zq.2 0 .3-.3z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ao",
    width: 4,
    height: 4,
    x: 60,
    y: 103,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ag"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ao)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.1,
    d: "m62.7 104.2-.3-.2zh.8z"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ap)",
    d: "M62.4 103.2H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3v-2.5z"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M97.9 106h-.4l-.4-.5v-.7l.1-.3.3-.2h.6q.2 0 .3.2l.1.2v.6h-1.3v-.3h1v-.3H98l-.2-.1h-.2v.1l-.1.2v.6l.2.2h.4l.2-.2.2.2-.1.2h-.2zm-1.9-.3h.2l.2-.3h.4l-.1.3-.3.2-.3.1h-.4l-.2-.2-.2-.3v-.7l.2-.3.2-.2h.7l.3.2v.4h-.3v-.2h-.2l-.2-.1-.1.1-.1.2v.6l.2.1zm-1.5-.1v-.9l-.1-.1H94v.2h-.5v-.2l.2-.2.2-.1h.7l.3.5v1.2h-.3l-.1-.2zm0-.7v.3H94v.4l.1.1h.2l.2-.2.1.1-.1.3-.4.1h-.3l-.3-.2v-.5l.2-.2.2-.1zm-2.5-.4v2h-.4v-2.3h.4zm1.2.5v.4l-.2.3-.2.2h-.6l-.2-.2-.1-.3v-.8l.1-.2.2-.2h.6l.2.2.1.2zm-.4 0v-.2l-.1-.2h-.1l-.2-.1h-.2l-.2.2v.7l.2.1h.4l.1-.2zm-1.9.4-.2-.2h-.2l-.2-.1-.2-.1-.2-.1v-.4l.2-.2.2-.1h.6q.2 0 .3.2v.3H91v-.1l-.2-.1h-.3l-.1.1v.1l.2.1h.1l.4.2.2.1v.3l-.1.4h-.9l-.3-.2v-.3h.3v.2l.2.1h.4zm-2.3-2v2.5H88v-2.5zm1 .8-.7.8-.4.4-.1-.3.3-.4.4-.5zm-.4 1.7-.5-.8.3-.3.7 1zm-1.9-1.4v1.4H87v-1.7h.4zm.6-.4v.4h-.4v.1l-.2.2v.1-.6l.2-.1zm-2.9.8v-.3l.2-.3.2-.2h.7l.3.2.1.3v.7l-.1.3-.3.2h-.7l-.2-.2-.2-.3zm.4 0v.4l.2.1h.5v-.9l-.3-.1-.3.1-.1.2zm-2.6.4.4-1.8h.3v.4L83 106h-.3zm-.3-1.8.3 1.8v.5h-.2l-.6-2.3zm1.5 1.8.4-1.8h.4l-.5 2.3H84zm-.4-1.8.5 1.9v.4h-.3l-.5-2v-.3zm-1.8.6v.3h-1v-.3zm-.7-.5h.4v1.8h.4v.4h-.6l-.1-.2v-2M80 106h-.4l-.4-.5v-.7q0-.2.2-.3l.2-.2h.7l.2.2.1.2v.6h-1.3v-.3h1v-.3H80l-.2-.1h-.1l-.1.1-.1.2v.6l.2.2h.5l.1-.2.3.2-.2.2h-.2zm-1.8 0h-.4l-.4-.5v-.7q0-.2.2-.3l.2-.2h.7l.2.2.1.2v.6h-1.3v-.3h1v-.3h-.2l-.2-.1H78l-.2.1v.8l.2.2h.4l.2-.2.2.2-.1.2h-.2zm-2.2-2.5v2.5h-.5v-2.5zm-.1 1.6v-.4l.1-.2.2-.2h.6l.2.3v1.3h-.3v-1.2l-.2-.1h-.3l-.1.1-.1.2zm-1.2.3v-.2l-.2-.1-.2-.1-.3-.1-.3-.2-.2-.2v-.2l.2-.5.3-.1h.8l.3.3v.3h-.4v-.2h-.1l-.3-.1h-.2l-.1.1v.4h.2l.2.1.3.2.3.1.2.5v.3l-.2.2h-1.3l-.2-.3v-.3h.4v.2l.2.2h.5zm-1.7-1.9v2.5h-.4v-2.5zm-.8 0v2.5h-.5v-2.5zm-1.3 2.1v-.9l-.2-.1h-.3l-.1.2h-.4v-.2l.2-.2.2-.1h.6l.4.5v1.2H71zm0-.7v.3h-.5l-.1.2v.2l.2.1h.2l.1-.2.2.1-.2.3-.4.1h-.3l-.2-.2v-.5l.1-.2.3-.1zm-1.9.2h.5l-.2.4q0 .3-.3.3l-.5.1h-.4l-.3-.3-.2-.3v-1.1l.2-.4.7-.3.5.1.3.3.2.4H69v-.2l-.2-.2h-.5l-.2.2v1.3l.2.1h.5l.1-.1zm-1.6.8v.3H66v-.3z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M258.8 105v1.3h-.3v-1.7h.3zm-.1.4h-.1v-.4l.2-.2.5-.3h.2l.2.2.1.2v1.4h-.3V105l-.1-.2h-.2l-.4.2zm-2.2.1v-.4l.2-.3.2-.2h.7l.2.2.2.3v.7l-.2.3-.5.2h-.4l-.4-.5zm.3 0v.2l.1.2.2.1.2.1.3-.2.1-.2v-.7l-.2-.2h-.4l-.2.2v.2zm-.8-.9v1.7h-.3v-1.7zm-.3-.5h.3v.2h-.2m-.5.4v.2h-.9v-.2zm-.6-.4h.3v1.8h.3v.3h-.4l-.1-.1v-2m-1.3 1.9h.2l.2-.2v-.1h.3v.2l-.7.3h-.3l-.2-.2-.2-.3v-.7l.2-.3.2-.2h.7l.2.3.1.3h-.2l-.1-.2-.1-.2h-.5l-.1.2-.1.2v.7l.2.1zm-1.5-.1v-1.4h.4v1.7h-.3zm.1-.5v.4l-.1.2-.2.2h-.6l-.3-.3v-1.4h.3v1.4h.6l.2-.2zm-1.9.5v-2.2h.3v2.5h-.3zm-1.2-.5v-.4l.2-.3.5-.3.3.1.2.2.2.2v.9l-.2.2-.5.2h-.3l-.2-.2-.1-.3zm.3 0v.2l.1.2.2.1h.4l.2-.1v-1l-.4-.1h-.2l-.2.2zm-2.3.1v-.4l.2-.3.3-.2h.6l.3.2.1.3.1.3v.4l-.2.3-.6.2h-.3l-.3-.2-.1-.3zm.3 0v.2l.1.2.2.1.2.1.4-.2v-.2l.1-.2v-.3l-.1-.2-.4-.2h-.2l-.2.2v.4m-1.1-.6v1.5h-.3v-1.7h.3zm.5-.2v.2h-.3l-.1.1-.1.2v.2h-.2v-.3l.2-.2.1-.2zm-2 .8h-.6v-.3h.9l.1-.2v-.4l-.1-.2h-.9v2h-.3V104h1.3l.3.3.1.4-.1.4-.3.2z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 102.4,
    fill: "#2f2f2f",
    rx: 2.7
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 102.4,
    stroke: "#616467",
    strokeWidth: 0.2,
    rx: 2.7
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M299.7 105v.7l-.2.3-.2.2h-.5l-.3-.3-.1-.3v-1.1l.1-.3.2-.2h.6l.3.3v.3zm-.3.3v-.9l-.1-.1h-.5l-.2.3v1.1l.2.2h.5l.1-.3zm-1.9.7.2-.1h.1v.2h-.2m-.9-2.1v2.2h-.3v-1.9l-.6.2v-.2zm-1.7 2 .1-.1h.1v.2h-.2m-1-2.1v2.2h-.2v-1.9l-.6.2v-.2zm54.8 1.6-.2-.2h-.2l-.3-.1-.2-.1-.1-.2v-.2l.1-.3.2-.1h.7l.2.2v.3h-.2v-.2h-.2l-.2-.1h-.2l-.1.1v.2l.2.1h.2l.3.2.2.2v.2l-.1.4h-.2l-.3.1h-.4l-.2-.3-.1-.2h.3v.2h.7zm-2.9-2h.3v2.5h-.3zm1.5 1.6v.4l-.2.3-.2.2h-.6l-.2-.2-.2-.3v-.8l.2-.3.2-.1h.6l.2.2.1.2zm-.3 0v-.2l-.1-.2-.2-.2h-.4l-.1.1-.1.2v.7l.2.2h.4l.2-.1zm-2.2.9h-.3l-.4-.5v-.8l.2-.2.8-.2q.2 0 .2.2l.2.2v.5h-1.3v-.2h1v-.3l-.2-.2h-.2l-.3.1-.1.2v.8l.4.2h.3l.2-.3.2.2-.2.2h-.2zm-2.9-.7.4-1.6h.3l-.2.6-.5 1.7h-.2zm-.5-1.6.4 1.6v.7h-.2l-.5-2.3zm1.8 1.6.3-1.6h.3l-.5 2.3h-.3zm-.6-1.6.4 1.6.2.7h-.2l-.5-1.7-.1-.6zm-2.8.6v1.7h-.3v-1.7zm-.3-.5h.3v.2h-.2zm-2.6.8v1.4h-.3v-1.7h.3zm0 .5h-.2v-.4l.2-.2.2-.2h.7l.1.3v1.4h-.2v-1.4h-.2l-.2-.1h-.2l-.2.2zm1-.2v-.2l.1-.3.5-.2h.3l.3.4v1.3h-.3v-1.3h-.1l-.2-.1h-.2l-.1.1-.1.1zm-2.1.8v-1.1h-.2l-.2-.1h-.2l-.1.1v.1h-.3v-.1l.1-.2.3-.1h.6l.2.2v1.1l.1.2v.2h-.3zm0-.8v.2h-.5l-.1.1-.1.1v.4h.3l.4-.1v-.2l.1.1v.2l-.3.3h-.6l-.2-.2v-.5l.1-.2.3-.1h.6m-2.8-1.3v2.3h-.3v-2.3zm1.4 0-1 1-.5.6v-.3l.4-.5.8-.8zm-.3 2.3-.8-1.1.2-.3 1 1.4zm-2.6-.8v.2h-1.7v-.1l1-1.6h.3l-.3.4-.7 1.1zm-.3-1.5v2.3h-.3v-2.3zm-1.7 2v.3H328v-.2l.8-.9.2-.2.1-.2v-.4l-.1-.2h-.5l-.2.2v.2h-.3v-.3l.3-.3h.8l.3.2v.8l-.2.2-.2.2-.6.6zm-1.9-1.1v.9l-.2.3-.2.2h-.6l-.2-.1-.1-.2-.1-.3v-1.2l.1-.4.3-.1h.7l.2.3v.2zm-.3.4v-.9l-.2-.1v-.1h-.4l-.2.1v1.7h.6l.2-.3zm-1.5.7v.3h-1.6v-.2l.8-.9.2-.2.1-.2v-.4l-.1-.2h-.5l-.2.2v.2h-.3v-.3l.3-.3h.8l.3.2v.8l-.2.2-.2.2-.6.6zm-2.8-.1v.6l-.3.3-.1-.2.1-.3v-.4zm-1.2-2v2.4h-.3v-2l-.6.2v-.2zm-3.4 1v1.4h-.3v-1.7h.3zm0 .5h-.2l.1-.4.1-.2.6-.3h.2l.2.2v.2l.1.3v1h-.3v-1.3h-.1l-.2-.1-.4.2-.1.1zm-1.1.6v-1.1h-.1l-.2-.1h-.2l-.2.1v.1h-.3v-.1l.2-.2.2-.1h.6l.3.2v1.3l.1.2h-.3zm0-.8.1.2h-.5l-.2.1-.1.1v.3l.1.1h.2l.4-.1v-.2l.2.1v.2l-.4.3h-.6l-.2-.2v-.5l.2-.2.2-.1h.7m-2 .3v-1.6h.3v1.6l-.1.4q0 .2-.3.2l-.3.1h-.4l-.3-.3v-.4h.2v.3l.2.1h.5l.1-.1zm53.4-.2h-.6v-.3h.8l.1-.2v-.4h-.1l-.3-.1h-.4v2h-.4V104h1.1l.3.2.1.2v.5l-.2.2h-.3zm0 1h-.7l.1-.2h.8l.2-.2v-.4l-.2-.2h-.7v-.3h.6l.1.1.3.1.2.2v.7l-.3.2zm-2.6-2.2v2.3h-.4v-2.4zm1.4 0-1 1-.5.6-.1-.3.4-.5.8-.9zm-.3 2.3-.9-1.2.2-.2 1 1.4zm-3.8-1.3h.2l.2-.1.2-.1v-.5l-.1-.1h-.5l-.1.1-.1.2h-.3l.1-.3.2-.2.4-.1h.4l.2.3.1.4v.1l-.1.2-.3.2h-.5zm0 .2v-.2h.6l.2.2.1.2v.5l-.1.2-.3.1h-.8l-.2-.3v-.3h.3v.3l.2.1h.5l.1-.1v-.5l-.2-.2zm-1.9-.2h.2l.2-.1.2-.1v-.5l-.1-.1h-.5l-.2.3h-.3l.1-.3.3-.2.3-.1h.4l.3.3v.5l-.1.2-.2.2h-.6zm0 .2v-.2h.6l.2.2.1.2v.5l-.1.2-.3.1h-.8l-.1-.3-.1-.3h.3v.3l.2.1h.5l.1-.1v-.5l-.2-.2z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aq)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ar)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "as",
    width: 5,
    height: 4,
    x: 408,
    y: 103,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 103.2h-4.2v3.8h4.2z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#as)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m409.1 106.4.2.4.1.1.7-1.1h-1.3v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m410.9 104.4-.7-1.1-.1.1-1.3 2.1v.3h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m412.3 107 .2-.2v-.2l.4-.6v-.2h-1.2l.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m410.9 104.4.6-1.1h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M411.7 105.8H410l-.7 1.1h2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m412.3 104.5-.6-1q0-.2-.2-.2l-.6 1.1.8 1.4h1.3v-.2z"
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#at)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M429.4 104h.5v.4h-.5zm0 .9h.5v1.4h-.5zm.2-2.2a2.3 2.3 0 1 0 0 4.7 2.3 2.3 0 0 0 0-4.7m0 4.3a1.9 1.9 0 1 1 0-3.8 1.9 1.9 0 0 1 0 3.8"
  })))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.5 111.2v-.2H57.7v.4h381.8z",
    mask: "url(#au)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#av)"
  }, _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "aM",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7 111.2h381.8v12.2H57.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aw)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ay",
    width: 4,
    height: 5,
    x: 60,
    y: 115,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ax"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ay)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f4b400",
    d: "M62.4 115.4H61q-.3 0-.3.3v3.2q0 .2.3.3h2.2l.3-.3v-2.5l-.6-.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "az",
    width: 4,
    height: 5,
    x: 60,
    y: 115,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ax"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#az)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M62.7 117.1h-1.2v1.4h1.2zm0 1h-1.1v-.6h1z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aA",
    width: 4,
    height: 5,
    x: 60,
    y: 115,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ax"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aB)",
    d: "m62.5 116.4 1 .9v-.9z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aC",
    width: 4,
    height: 5,
    x: 60,
    y: 115,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ax"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fada80",
    d: "M62.4 115.4v.8l.3.2h.8z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aD",
    width: 4,
    height: 5,
    x: 60,
    y: 115,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ax"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aD)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M61 115.4q-.3 0-.3.3 0-.3.3-.3h1.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aE",
    width: 4,
    height: 5,
    x: 60,
    y: 115,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ax"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bf360c",
    fillOpacity: 0.2,
    d: "M63.2 119.1H61l-.3-.2q0 .2.3.3zl.3-.3z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aF",
    width: 4,
    height: 5,
    x: 60,
    y: 115,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ax"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aF)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bf360c",
    fillOpacity: 0.1,
    d: "m62.7 116.4-.3-.2zh.8z"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aG)",
    d: "M62.4 115.4H61q-.3 0-.3.3v3.2q0 .2.3.3h2.2l.3-.3v-2.5z"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M95 118.2h-.4l-.5-.5v-.8l.2-.2.3-.2h.6l.2.1.2.3v.5h-1.3v-.3h1l-.1-.2-.1-.1h-.4l-.1.1v.8l.2.1h.4l.2-.1.2.2-.1.1-.3.2zm-1.9-.3h.2v-.2l.1-.1h.4v.3l-.3.2-.4.1h-.3l-.3-.3-.1-.2v-.8l.1-.2.3-.2h.7l.2.2.1.4h-.4v-.2l-.1-.1h-.4v.1l-.1.2v.6l.1.1zm-1.5-.1v-.9l-.2-.1h-.3l-.1.1h-.4v-.2l.2-.1.2-.1h.6l.4.5v1.1h-.4zm0-.7v.3h-.5l-.1.1v.3h.5v-.2l.2.2-.2.3-.4.1h-.3l-.2-.2v-.6l.1-.1.3-.1zm-2.5-.4v2h-.4v-2.4h.4zm1.2.5v.4l-.2.3-.2.1-.3.1h-.3l-.2-.2-.1-.3-.1-.3v-.5l.2-.3.2-.1h.6l.2.1.1.3zm-.5 0v-.4l-.2-.1h-.4v.2l-.1.2v.5l.2.1h.4l.1-.3zm-1.8.4h-.2l-.2-.1-.3-.1-.2-.1-.1-.2v-.4l.1-.1.3-.1h.6q.2 0 .3.2v.3H88v-.2h-.5v.2l.1.1h.2l.3.1.3.2v.3l-.1.4H88l-.3.1h-.4l-.2-.3-.1-.3h.4v.2h.2l.1.1h.2l.1-.1zm-2.4-2v2.5h-.4v-2.5zm1.1.7-.7.9-.4.4-.2-.3.3-.4.5-.6zm-.4 1.8-.5-.8.2-.3.8 1zm-1.9-1.4v1.4H84v-1.8h.4zm.5-.4v.4h-.3l-.1.1v.1l-.1.2h-.1v-.3l.1-.3.2-.1zm-2.9.9v-.4l.2-.2.3-.2h.7l.2.2.2.2v.8l-.2.3-.2.1-.4.1h-.3l-.3-.2-.1-.3zm.4 0v.2l.1.2.2.1h.4l.1-.3v-.6a.3.3 0 0 0-.4-.2l-.3.2zm-2.7.4.5-1.9h.2v.4l-.4 2h-.3zm-.3-1.9.4 2v.4h-.3l-.5-2.4zm1.5 2 .4-2h.5l-.6 2.4H81zm-.3-2 .4 2v.4l-.5-2zm-2.3.6h.4v1.7l-.1.4-.3.3h-.9l-.1-.2.1-.3.2.2h.5l.1-.2v-1.5zm-1.2 1 .1-.4.1-.2.3-.2h.5l.2.1.2.3v.8l-.2.3-.5.2-.5-.2-.1-.3zm.5-.1v.4l.2.1h.4v-.1l.1-.3v-.5l-.2-.1H78l-.1.1-.1.2zm-1.8-.5v1.4h-.5v-1.8h.4zm-.1.4v-.3l.2-.3.5-.2h.2l.2.2v.2l.1.3v1h-.4v-1l-.2-.1H76v.2zm-.8-.8v1.8h-.4v-1.8zm-.5-.4.1-.2h.4v.3l-.2.1h-.2zm-.3.4v.3h-1v-.3zm-.7-.4h.4v1.7l.1.1h.2v.4h-.5l-.1-.2-.1-.3zm-.9 1.7-.2-.1-.3-.1-.2-.1-.1-.2v-.4l.1-.1.2-.1h.7q.2 0 .3.2v.3h-.4v-.2H72v.2l.1.1h.2l.3.1.3.2v.3l-.1.4h-.3l-.3.1H72l-.2-.3-.1-.3h.4v.2h.2l.1.1h.2l.1-.1zm-1.8.1v-1h-.4l-.1.1h-.5l.1-.2.1-.1.3-.1h.6l.4.5v1.1H71zm0-.7.1.3h-.6v.4h.5v-.2l.2.2-.2.3-.4.1H70l-.2-.2v-.6l.1-.1.3-.1h.6m-1.9.2h.5l-.1.4-.3.3-.5.1h-.4l-.3-.3-.2-.3v-1.1l.2-.4.7-.3.5.1.3.3.1.4H69v-.2l-.2-.2h-.5l-.2.1v.3l-.1.3v.5l.1.3.2.1h.5l.1-.1zm-1.5.8v.3H66v-.3z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M255.2 118.5h-.3l-.4-.5v-.8q0-.2.2-.3l.5-.2h.3l.2.2.2.3v.5h-1.3v-.3h1v-.2l-.2-.2h-.5l-.1.3v.8h.2l.2.1h.3l.2-.2.2.1-.2.2-.2.1zm-1.8-.3.5-1.5h.3l-.6 1.7h-.2zm-.4-1.5.5 1.5v.2h-.1l-.7-1.7zm-.6 0v1.7h-.3v-1.7zm-.3-.4v-.2h.3v.2zm-.4.4v.2h-1v-.2zm-.6-.4h.3v1.9h.2v.2h-.3l-.2-.1zm-.9 1.9V117l-.2-.1h-.5v.2h-.4v-.2l.2-.2h.2l.3-.1h.3l.3.2v1.4l.1.1h-.3zm0-.8v.2h-.7v.2l-.1.1v.2h.1l.2.1.4-.2v-.1l.2.1v.2l-.4.2h-.5l-.3-.2v-.5l.2-.2h.2l.4-.1zm-2.2 1.1h-.3l-.4-.5v-.8l.2-.3.5-.2h.3l.3.2.1.3v.5h-1.3v-.3h1v-.2l-.1-.2h-.6l-.1.3v.6l.1.2h.2l.2.1h.2l.2-.2.2.1-.1.2-.2.1zm-1.5-1.5v1.4h-.3v-1.7h.3zm.6-.3v.3h-.4l-.2.2v.2h-.1v-.2l.1-.3.2-.2zm-1.6 1h.3l-.1.4-.3.3h-.8l-.3-.2-.2-.4v-1.1l.2-.3q0-.2.3-.2l.4-.1h.4l.3.4.1.4h-.3v-.3l-.3-.2h-.5q-.2 0-.2.2l-.1.2v1.2l.3.2h.5l.2-.2z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 114.6,
    fill: "#2f2f2f",
    rx: 2.7
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 114.6,
    stroke: "#616467",
    strokeWidth: 0.2,
    rx: 2.7
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M299.7 117.1v.8l-.2.3-.2.1h-.7l-.1-.2-.1-.3v-1.1l.1-.3.2-.2h.6l.3.3v.2zm-.3.4v-.9l-.1-.1h-.5l-.2.3v1.1l.2.2h.5l.1-.3zm-1.9.7h.3v.2h-.2m-.5-1.3v.8l-.2.3-.2.1h-.7l-.1-.2-.1-.3v-1.1l.1-.3.2-.2h.6l.3.3v.2zm-.3.4v-.9l-.1-.1h-.1l-.2-.1h-.1l-.2.1v1.6h.6l.1-.3zm-1.8.7h.2v.2h-.2m-1-2.2v2.2h-.2v-1.9l-.6.2v-.2zm54.8 1.6-.2-.1h-.2l-.3-.2h-.2l-.1-.2v-.2l.1-.3.2-.1h.7l.2.2v.3h-.2v-.2l-.2-.1h-.5v.3l.2.1h.2l.3.2.2.2v.4l-.1.2h-.2l-.3.1h-.4l-.2-.3-.1-.3h.3v.2l.2.1h.5zm-2.9-2h.3v2.5h-.3zm1.5 1.6v.4l-.2.3-.2.1-.3.1h-.3l-.2-.2-.2-.3v-.8l.2-.3.2-.1h.6l.2.2.1.2zm-.3 0v-.2l-.1-.2-.4-.2h-.2l-.1.1-.1.2v.7l.2.2h.4l.2-.1v-.5m-2.2.9h-.3l-.4-.5v-.8l.2-.3.5-.2h.3l.2.3.2.2v.4h-1.3v-.1h1v-.3l-.2-.2h-.4l-.1.1-.1.2v.8l.2.1h.5l.2-.2.2.2-.2.1-.2.2zm-2.9-.7.4-1.7h.3l-.2.7-.5 1.7h-.2zm-.5-1.7.4 1.6v.8h-.2l-.5-2.4zm1.8 1.6.3-1.6h.3l-.5 2.4h-.3zm-.6-1.6.4 1.7.2.7h-.2l-.5-1.7-.1-.7zm-2.8.6v1.8h-.3v-1.8zm-.3-.4h.3v.2h-.2zm-2.6.8v1.4h-.3v-1.8h.3zm0 .4h-.2v-.3l.2-.3.2-.1h.5l.3.2v1.5h-.2v-1.4l-.2-.1h-.4l-.2.1zm1-.1v-.2l.1-.3.3-.1h.7v.3l.1.2v1.2h-.3v-1.4l-.1-.1h-.4l-.2.2zm-2.1.8v-1l-.2-.2h-.5v.2h-.3v-.2l.1-.1.3-.1h.6l.2.2v1.1l.1.2v.2h-.3zm0-.8v.2h-.5l-.1.1-.1.1v.4h.5l.2-.1v-.2l.1.1v.2l-.3.3h-.6l-.2-.2v-.5l.1-.2.3-.1zM333 116v2.3h-.3v-2.4zm1.4 0-1 1-.5.6v-.3l.4-.5.8-.9zm-.3 2.3-.8-1.2.2-.2 1 1.4zm-2.6-.8v.2h-1.7v-.1l1-1.7h.3l-.3.5-.7 1zm-.3-1.6v2.4h-.3v-2.4zm-1.7 2.1v.3H328v-.2l.8-.9.2-.3.1-.1v-.4l-.1-.2h-.5l-.2.2v.2h-.3v-.3l.3-.3h.8l.3.2v.8q-.2 0-.2.2l-.2.2-.6.6zm-1.9-1v.8l-.2.3-.2.2h-.6l-.2-.1-.1-.2-.1-.3v-1.3l.1-.3.3-.1h.5l.4.2v.3zm-.3.3v-.9l-.2-.1v-.1h-.4l-.2.1v1.7h.6v-.1l.2-.2zm-1.5.7v.3h-1.6v-.2l.8-.9.2-.3.1-.1v-.4l-.1-.2h-.5l-.2.2v.2h-.3v-.3l.3-.3h.8l.3.2v.8q-.2 0-.2.2l-.2.2-.6.6zm-2.8 0v.5l-.3.2h-.1l.1-.4v-.4zm-1.2-2v2.3h-.3v-2l-.6.2v-.2zm-3.4 1v1.3h-.3v-1.8h.3zm0 .3h-.2l.1-.3.1-.3.6-.2h.2l.2.2v.2l.1.2v1.2h-.3v-1.4l-.1-.1h-.2l-.4.1-.1.2zm-1.1.7v-1l-.1-.2h-.6v.2h-.3v-.2l.2-.1.2-.1h.6l.3.2v1.3l.1.2h-.3zm0-.8.1.2h-.5l-.2.1-.1.1v.3l.1.1h.4l.2-.1v-.2l.2.1v.2l-.2.1-.2.2h-.6l-.2-.2v-.5l.2-.2.2-.1zm-2 .3v-1.7h.3v1.7l-.1.4-.3.2-.3.1h-.4l-.3-.3v-.4h.2v.3l.2.1h.5l.1-.1zm53.4-.2h-.6v-.3h.8l.1-.1v-.5h-.1l-.3-.1h-.4v2h-.4V116h1.1l.3.2.1.2v.5l-.2.2-.3.1zm0 1h-.7l.1-.2h.8l.2-.2v-.4l-.2-.2h-.7v-.3h.6l.1.1.3.1.2.2v.7l-.3.2zm-2.6-2.3v2.4h-.4V116zm1.4 0-1 1.1-.5.6-.1-.3.4-.5.8-.9zm-.3 2.4-.9-1.2.2-.2 1 1.4zm-2.7-.8v.2H363v-.2l1-1.6h.3l-.3.5-.6 1zm-.3-1.6v2.4h-.3V116zm-1.6 2.1v.3H361v-.2l.8-.9.2-.3.1-.2v-.4l-.1-.1h-.5l-.2.2v.2h-.3v-.3l.3-.3.5-.1h.3l.3.3v.7l-.2.2-.2.2-.6.7z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aJ)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "aK",
    width: 5,
    height: 5,
    x: 408,
    y: 115,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 115.4h-4.2v3.8h4.2z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m409.1 118.6.2.3.1.2.7-1.1h-1.3v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m410.9 116.6-.7-1.1-.1.1-1.3 2.1v.3h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m412.3 119.1.2-.2.4-.7v-.2h-1.2l.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m410.9 116.6.6-1.1h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M411.7 118H410l-.7 1.1h2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m412.3 116.7-.6-1q0-.2-.2-.2l-.6 1.1.8 1.4h1.3v-.3z"
  }))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aL)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M429.4 116.1h.5v.5h-.5zm0 1h.5v1.4h-.5zm.2-2.2a2.3 2.3 0 1 0 0 4.7 2.3 2.3 0 0 0 0-4.7m0 4.3a1.9 1.9 0 1 1 0-3.8 1.9 1.9 0 0 1 0 3.8"
  })))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.5 123.4v-.3H57.7v.5h381.8z",
    mask: "url(#aM)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aN)"
  }, _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "bc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7 123.4h381.8v12.2H57.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aO)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "aQ",
    width: 4,
    height: 5,
    x: 60,
    y: 127,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aP"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0f9d58",
    d: "M62.4 127.6H61q-.3 0-.3.2v3.3q0 .2.3.2h2.2q.2 0 .3-.2v-2.5l-.6-.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aR",
    width: 4,
    height: 5,
    x: 60,
    y: 127,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aP"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aR)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M61.4 129.4v1.3h1.4v-1.3zm.6 1h-.4v-.1zm0-.2h-.4v-.3h.4zm0-.4h-.4v-.2h.4zm.6.7h-.4v-.2h.4zm0-.3h-.4v-.3h.4zm0-.4h-.4v-.2h.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aS",
    width: 4,
    height: 5,
    x: 60,
    y: 127,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aP"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aS)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aT)",
    d: "m62.5 128.5 1 1v-.9z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aU",
    width: 4,
    height: 5,
    x: 60,
    y: 127,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aP"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aU)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87ceac",
    d: "M62.4 127.6v.8l.3.2h.8z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aV",
    width: 4,
    height: 5,
    x: 60,
    y: 127,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aP"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aV)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M61 127.6q-.3 0-.3.2zh1.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aW",
    width: 4,
    height: 5,
    x: 60,
    y: 127,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aP"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.2,
    d: "M63.2 131.3H61l-.3-.2q0 .2.3.2zq.2 0 .3-.2z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aX",
    width: 4,
    height: 5,
    x: 60,
    y: 127,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aP"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aX)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.1,
    d: "m62.7 128.6-.3-.2zh.8z"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aY)",
    d: "M62.4 127.6H61q-.3 0-.3.2v3.3q0 .2.3.2h2.2q.2 0 .3-.2v-2.5z"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M105.4 130.4h-.3l-.3-.2-.2-.3v-.8l.2-.3.3-.1.3-.1h.3l.2.2.2.3v.5h-1.3v-.3h1l-.1-.2-.1-.1h-.5v.9l.2.1h.4l.2-.1.2.2-.1.1-.3.2zm-1.8-.4h.2l.1-.2h.4v.3l-.3.2-.4.1h-.3l-.3-.3-.1-.2v-.8l.1-.2.3-.2.3-.1h.4l.2.3.1.4h-.4v-.2l-.1-.1h-.4v.1l-.1.2v.6l.1.1zm-1.6 0v-1h-.4l-.1.1h-.4v-.2l.2-.1.2-.2h.6l.3.3v1.1l.1.2v.1h-.4zm.1-.7v.3h-.5l-.1.1v.3h.5v-.2l.2.2-.2.3-.4.1h-.3l-.2-.3v-.5l.1-.1.3-.2zm-2.6-.3v2h-.4v-2.4h.4zm1.2.5v.4l-.2.2-.2.2-.3.1h-.3l-.2-.2-.1-.3-.1-.3v-.5l.2-.3.2-.1.3-.1h.3l.2.2.1.3zm-.5 0v-.4l-.3-.2h-.2l-.1.2v.1l-.1.2v.5l.2.1h.3l.1-.1.1-.2zm-1.9.4-.2-.2h-.3l-.2-.1-.1-.2v-.4l.1-.1.2-.2h.7l.3.3v.3h-.4v-.2h-.1l-.2-.1H98l-.1.1v.2h.1l.2.1.3.1.3.2v.3l-.1.3-.3.2h-.7l-.2-.3-.1-.3h.4v.2h.6zm-2.3-2v2.5h-.4v-2.5zm1.1.7-.7.9-.4.4-.2-.3.3-.4.5-.6zm-.4 1.8-.5-.8.2-.3.8 1zM95 129v1.4h-.5v-1.8h.4zm.4-.4v.4H95l-.1.1-.1.1v.2h-.1v-.3l.1-.3.2-.1.2-.1zm-2.9.9v-.4l.2-.2.3-.2.3-.1h.4l.2.3.2.2v.8l-.2.2-.2.2-.4.1H93l-.3-.3-.1-.2zm.4 0v.2l.1.2.2.1h.3l.1-.1.1-.2v-.6a.3.3 0 0 0-.4-.2l-.3.2zm-2.7.5.5-2h.2v.4l-.4 2h-.3zm-.3-2 .4 2v.4H90l-.5-2.4zm1.5 1.9.4-1.9h.5l-.6 2.4h-.3zm-.3-1.9.4 2v.4h-.2l-.5-2v-.4zm-2.6 2.2.4-1.6h.5l-.7 2v.2l-.2.1-.1.1H88v-.3h.3l.1-.2zm-.3-1.6.4 1.3v.5h-.2l-.6-1.8zm-.6 0v.3h-1v-.3zm-.7-.4h.4v1.7l.1.1h.2v.4h-.5l-.1-.2-.1-.3zm-.7 2.2h-.5v-2l.1-.3.2-.2h.6v.3h-.3l-.1.1zm.3-1.8v.3h-1v-.3zm-1.7 1.4v-1h-.5l-.1.1h-.4v-.2l.2-.1.2-.2h.6l.4.6v1.1H85zm0-.7v.3h-.5l-.1.1v.3h.5v-.2l.2.2-.2.3-.4.1H84l-.2-.3v-.5l.1-.1.3-.2zM83 129v1.4h-.5v-1.8h.4zm.5-.4v.4h-.4v.1l-.2.1v.2-.6l.2-.1.2-.1zm-1.7 1h.4l-.1.4-.4.3-.4.1H81l-.3-.3-.2-.4v-1q0-.3.2-.4l.3-.2.4-.1.4.1q.3 0 .4.3v.4H82v-.2l-.2-.2h-.5l-.1.1-.1.3v1l.2.2h.5l.2-.2zm-2.3-1h.4v2.1l-.4.3H79l-.2-.2.2-.3.2.2h.4l.1-.2.1-.2zm-1.1 1v-.5l.2-.3.5-.2h.3l.1.2.2.3v.8l-.2.3-.2.1-.2.1H79l-.2-.3-.2-.2zm.4-.1v.4l.2.1h.4l.1-.1v-.8l-.2-.1H79l-.1.1v.2zm-1.9-.5v1.4h-.4v-1.8h.4zm0 .4v-.3l.2-.3.5-.2h.2l.2.1v.2l.1.4v1h-.4v-1.2l-.1-.1h-.5zm-.9-.8v1.8zm-.4-.4v-.2h.4v.3l-.2.1h.2zm-.9.8v1.4h-.3v-1.8h.4zm.6-.4v.4H75l-.2.1v.3h-.2v-.3l.2-.3.1-.1.3-.1zm-2 1.8H73l-.5-.5v-.8l.2-.3.3-.1.3-.1h.3l.2.2.2.3v.5h-1v-.3h1l-.1-.2-.1-.1h-.5v.3l-.1.2v.3l.1.1.2.1h.4l.2-.1.2.2-.2.1-.2.2zm-1.1-1.8v.3h-1v-.3zm-.7-.4h.4v1.7l.1.1h.2v.4H72l-.1-.2-.1-.3zm-.9 1.8v-1h-.5l-.1.1h-.4v-.2l.2-.1.2-.2h.6l.4.6v1.1zm0-.7v.3h-.5l-.1.1v.3h.5v-.2l.2.2-.2.3-.4.1h-.3l-.2-.3v-.5l.1-.1.3-.2zm-1.9.3h.5l-.2.4-.3.3-.5.1h-.4l-.3-.3-.2-.4v-1l.2-.4.3-.2.4-.1.5.1.3.3.2.4H69v-.2l-.2-.2h-.5l-.2.1v1.3l.2.2h.5l.1-.2zm-1.6.8v.3H66v-.3z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M258.8 129.3v1.4h-.3v-1.8h.3zm-.1.4h-.1v-.3l.2-.2.5-.3h.2l.2.2.1.2v1.4h-.3v-1.4h-.1l-.2-.1-.4.1zm-2.2.1v-.3q0-.3.2-.3l.2-.2h.7q.2 0 .2.2.2 0 .2.3v.7l-.2.3-.5.2h-.4l-.4-.5zm.3 0v.3l.1.2.2.1h.2l.3-.1.1-.2v-.7l-.2-.2h-.4q-.2 0-.2.2v.2zm-.8-.8v1.7h-.3v-1.8zm-.3-.5h.3v.2h-.2zm-.4.5v.2h-.9v-.3zm-.6-.5h.3v1.8l.1.1h.2v.3h-.4l-.1-.2zm-1.3 2h.2l.2-.2v-.2h.3v.3l-.7.3h-.3l-.2-.2-.2-.3v-.7q0-.2.2-.3l.2-.2h.7l.2.2.1.3h-.2l-.1-.1-.1-.2h-.5l-.1.2-.1.2v.7l.2.1zm-1.5-.2v-1.4h.4v1.8h-.3zm.1-.4v.3l-.1.3-.2.2h-.6l-.3-.3v-1.5h.3v1.4l.2.1h.4l.2-.2zm-1.9.4v-2h.3v2.4h-.3zm-1.2-.5v-.4l.2-.2.5-.3h.3l.2.2.2.3v.8l-.2.3-.5.2h-.3l-.2-.2-.1-.3zm.3 0v.3l.1.2.2.1h.4l.2-.2v-.9l-.4-.1h-.2l-.2.2zm-2.3 0v-.3l.2-.3.3-.2h.6l.3.2.1.3.1.3v.4l-.2.3-.6.2h-.3l-.3-.2-.1-.3zm.3 0v.3l.1.2.2.1h.2l.4-.1v-.2l.1-.3v-.2l-.1-.2-.4-.2h-.2l-.2.2zm-1.1-.6v1.5h-.3v-1.8h.3zm.5-.3v.3h-.3l-.1.1-.1.2v.1h-.2v-.2l.2-.3.1-.1zm-2 .9h-.6v-.3h.9l.1-.2v-.5l-.1-.1-.3-.1h-.6v2h-.3v-2.2h1.3l.3.3.1.4-.1.3q0 .2-.3.3z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 126.8,
    fill: "#2f2f2f",
    rx: 2.7
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 126.8,
    stroke: "#616467",
    strokeWidth: 0.2,
    rx: 2.7
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M299.7 129.3v.8l-.2.3-.2.1h-.5l-.3-.2-.1-.3v-1.2l.1-.2.2-.2h.6l.3.3v.2zm-.3.4v-.9l-.1-.1-.1-.1h-.4v.1l-.2.2v1.2l.2.2h.4l.1-.1.1-.2zm-1.9.7h.3v.2h-.2m-.5-1.2v.8l-.2.3-.2.1h-.5l-.3-.2-.1-.3v-1.2l.1-.2.2-.2h.8v.3l.2.2zm-.3.4v-.9l-.1-.1-.1-.1h-.3l-.2.1v1.6h.5l.1-.1.1-.2zm-1.8.7h.2v.2zm-1-2.1v2.2h-.2v-1.9l-.6.2v-.2zm54.8 1.6-.2-.1h-.2l-.3-.2h-.2l-.1-.2v-.2l.1-.3.2-.2h.7l.2.3v.2h-.2v-.1l-.2-.1h-.5v.3l.2.1h.2l.3.2.2.1v.3l-.1.4h-.2l-.3.1h-.4l-.2-.3-.1-.3h.3v.2l.2.1h.5zm-2.9-2h.3v2.5h-.3zm1.5 1.6v.4l-.2.2-.2.2-.3.1h-.3l-.2-.2-.2-.3v-.8l.2-.3.2-.1.3-.1h.3l.2.2.1.3zm-.3 0v-.3l-.1-.2-.2-.1h-.5l-.1.2v.8l.2.2h.4l.2-.1v-.5m-2.2.9h-.3l-.4-.5v-.8l.2-.3.8-.1.2.1.2.3v.5h-1.3v-.3h1v-.2l-.2-.2h-.2l-.3.1-.1.2v.8l.4.2.3-.1.2-.2.2.2-.2.1-.2.1zm-2.9-.7.4-1.7h.3l-.2.7-.5 1.7h-.2zm-.5-1.7.4 1.6v.8h-.2l-.5-2.4zm1.8 1.6.3-1.6h.3l-.5 2.4h-.3zm-.6-1.6.4 1.7.2.7h-.2l-.5-1.7-.1-.7zm-2.8.6v1.8h-.3v-1.8zm-.3-.4v-.2h.3v.2l-.1.1zm-2.6.7v1.5h-.3v-1.8h.3zm0 .5h-.2v-.3l.2-.3.2-.1.3-.1h.2l.2.1.1.2v1.5h-.2V129l-.2-.1h-.4l-.2.1zm1-.1v-.2l.1-.3.5-.2h.3l.3.3v1.5h-.3V129l-.1-.1h-.5l-.1.2zm-2.1.9V129l-.2-.1h-.5v.2h-.3v-.2l.1-.1.3-.2h.6l.2.3v1.1l.1.2v.1zm0-.8v.2h-.5l-.1.1-.1.1v.4h.3l.4-.2v-.1l.1.1v.2l-.3.3h-.6l-.2-.3v-.5l.1-.1.3-.1zm-2.8-1.4v2.4h-.3V128zm1.4 0-1 1.1-.5.6v-.3l.4-.5.8-.9zm-.3 2.4-.8-1.2.2-.2 1 1.4zm-2.6-.8v.2h-1.7v-.2l1-1.6h.3l-.3.5-.7 1zm-.3-1.6v2.4h-.3V128zm-1.7 2.1v.3H328v-.2l.8-.9.2-.3.1-.2v-.3l-.1-.2h-.5l-.2.2v.2h-.3v-.3l.3-.3.4-.1h.4l.3.3v.7l-.2.2-.2.2-.6.7zm-1.9-1.1v.9l-.2.3-.2.1-.3.1h-.3l-.2-.1-.1-.2-.1-.3v-1.3l.1-.3.3-.1.3-.1h.2l.2.1.2.2v.3zm-.3.4v-.9l-.2-.2h-.4l-.2.1v1.6l.2.1h.4v-.1l.2-.2zm-1.5.7v.3h-1.6v-.2l.8-.9.2-.3.1-.2v-.3l-.1-.2h-.5l-.2.2v.2h-.3v-.3l.3-.3.5-.1h.3l.3.3v.7l-.2.2-.2.2-.6.7zm-2.8-.1v.6l-.3.2h-.1l.1-.4v-.4zm-1.2-2v2.4h-.3v-2l-.6.2v-.3zm-3.4 1v1.4h-.3v-1.8h.3zm0 .4h-.2l.1-.3.1-.3.6-.2h.2l.2.1v.2l.1.3v1.2h-.3V129l-.1-.1h-.2l-.4.1-.1.2zm-1.1.7V129l-.1-.1h-.6v.2h-.3v-.2l.2-.1.2-.2h.6l.3.3v1.3l.1.1h-.3zm0-.8.1.2h-.5l-.2.1-.1.1v.3l.1.1h.2l.4-.2v-.1l.2.1v.2l-.4.3h-.6l-.2-.3v-.5l.2-.1.2-.1zm-1.9.3V128h.3v1.7l-.1.4-.3.2-.3.1h-.4l-.3-.3v-.4h.2v.3l.2.1h.5l.1-.2zm53.3-.2h-.6v-.3h.7l.2-.2v-.4h-.2l-.2-.1h-.5v2h-.3v-2.3h1.1l.2.2q.2 0 .2.2v.5l-.2.2h-.3zm0 1h-.8l.2-.2h.8l.2-.2v-.4l-.2-.2h-.7v-.3h.6v.1l.4.1.2.2v.6l-.4.3zm-2.7-2.3v2.3h-.3v-2.3zm1.4 0-1 1.1-.5.6v-.4l.4-.4.8-.9zm-.3 2.3-.8-1 .2-.3 1 1.3zm-3.9-.2h.4l.3-.3.1-.2v-1.2l-.2-.1h-.5l-.1.3v.6h.2l.2.1.3-.1.2-.4h.1v.3l-.4.4h-.6l-.2-.2v-1.1l.3-.2h.6l.3.3.1.3v1.2l-.3.3-.3.2h-.5zm-1.2-2.1v2.3h-.3v-2l-.6.3v-.3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aZ)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bb",
    width: 5,
    height: 5,
    x: 408,
    y: 127,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 127.6h-4.2v3.7h4.2z"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m409.1 130.8.2.3.1.2.7-1.2h-1.3v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m410.9 128.8-.7-1.1-.1.1-1.3 2.1v.2h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m412.3 131.3.2-.2v-.1l.4-.6v-.3h-1.2l.2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m410.9 128.8.6-1.1-.2-.1h-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M411.7 130.1H410l-.7 1.2h2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m412.3 128.9-.6-1q0-.3-.2-.2l-.6 1.1.8 1.3h1.3v-.2z"
  }))))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M429.4 128.3h.5v.5h-.5zm0 1h.5v1.3h-.5zm.2-2.2a2.3 2.3 0 1 0 0 4.7 2.3 2.3 0 0 0 0-4.7m0 4.2a1.9 1.9 0 1 1 0-3.7 1.9 1.9 0 0 1 0 3.7"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.5 135.6v-.3H57.7v.5h381.8z",
    mask: "url(#bc)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bd)"
  }, _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "bk",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7 135.6h381.8v12.2H57.7z"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#be)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#673ab7",
    d: "M62.5 139.8H61l-.3.2v3.3l.3.2h2.3q.3 0 .3-.2v-2.4l-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M61.8 142.5h1v-.1zm0-1.1v.2h1v-.2zm-.2 0-.1.2-.1-.1zm0 .6-.1.1-.1-.1.1-.2zm0 .5-.1.1-.1-.1.1-.2zm.2-.4h1v-.2h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bf)",
    d: "m62.6 140.8 1 1v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b39ddb",
    d: "M62.5 139.8v.8q0 .2.3.3h.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "m61 139.8-.3.2zh1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311b92",
    fillOpacity: 0.2,
    d: "M63.3 143.5H61l-.3-.3q0 .3.3.3zq.3 0 .3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311b92",
    fillOpacity: 0.1,
    d: "m62.8 140.9-.3-.3q0 .2.3.3h.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bg)",
    d: "M62.5 139.8H61l-.3.2v3.3l.3.2h2.3q.3 0 .3-.2v-2.4z"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M94.5 141.2v1.3H94v-1.7h.4zm0 .4h-.2v-.3l.2-.3.2-.2h.5l.2.1v.2l.1.3v1.1h-.4v-1.3h-.6zm1 0h-.2v-.3l.2-.3.2-.2h.5l.2.1v.2l.1.3v1.1h-.4v-1.3h-.5l-.1.2zm-2.2-.4v1.3h-.5v-1.7h.4zm.5-.4v.4h-.4l-.2.2v.2-.6l.2-.2zm-2.9.9v-.4l.2-.3.2-.2h.7l.3.2.1.3v.7l-.1.3-.3.2h-.7l-.2-.2-.2-.3zm.4 0v.4l.2.1h.3l.2-.1v-.8l-.3-.2-.3.2-.1.2zm-1.7-1.5v2.3h-.4v-2.3zm1 1v.4h-1.1v-.4zm0-1v.4h-1.1v-.4zm-2.3 1v1.3H88v-1.7h.4zm.6-.4v.4h-.5v.2l-.1.2h-.1v-.3l.1-.3.2-.2h.3m-1.9 1.8h-.4l-.4-.5v-.8l.2-.3.2-.2h.7l.2.2.1.3v.5h-1.3v-.3h1v-.2l-.2-.1h-.5v.9l.2.1h.4q.2 0 .2-.2l.2.3-.1.1-.2.1zm-1.6-.4V140h.4v2.4h-.4zm-1.2-.5v-.4l.2-.3.2-.2h.3l.5.2.1.3v.8l-.1.2-.2.2h-.3l-.5-.2-.1-.3zm.5 0v.4l.2.1h.3l.2-.2v-.6l-.1-.2h-.6zm-1.2-.5v1.3H83v-1.7h.4zm.6-.4v.4h-.4l-.2.2v.2-.6l.2-.2zm-1.4.5v.6l-.2.4-.3.2h-.8l-.3-.2-.3-.4v-1.1l.2-.3.4-.2.4-.1h.4l.3.3.2.3zm-.4.1v-.4l-.1-.3-.2-.1h-.5l-.1.1-.1.3v1l.2.2h.5l.2-.2zm-2.1-.6h.3v1.7l-.1.4-.3.2-.6.1H79l-.2-.2.2-.3.2.2h.5l.1-.2v-1.5zm-1.3.9v-.4l.2-.3.2-.2h.6l.2.2.1.3.1.3v.5l-.2.2-.5.3-.5-.3-.1-.3zm.5 0v.4l.2.1h.4v-.2l.1-.2v-.6h-.6l-.1.3zm-1.8-.5v1.3H77v-1.7h.4zm-.1.4v-.3l.2-.3.4-.2h.3l.1.1.2.2v1.4H78v-1.3h-.6v.2zm-.8-.8v1.7H76v-1.7zm-.5-.4.1-.2h.4v.3zm-.8.8v1.3h-.4v-1.7h.4zm.6-.4v.4h-.4l-.2.2v.2-.6l.2-.2zm-2 1.8h-.4l-.4-.5v-.8l.2-.3.2-.2h.7l.2.2.2.3v.5h-1.4v-.3h1v-.2l-.2-.1h-.4l-.1.2v.7l.2.1h.5l.2-.2.2.3-.2.1-.2.1zm-1.1-1.8v.3h-1v-.3zm-.7-.4h.4v1.8h.3v.3h-.5l-.2-.1zm-1 1.8v-1H71l-.2-.1h-.1l-.1.2H70v-.2l.2-.2h.9l.4.5v1.1h-.4zm0-.7v.2h-.4v.1l-.1.1v.3h.4l.1-.1v-.1l.2.2-.2.2-.2.1h-.5l-.2-.2-.1-.2v-.3l.2-.2h.3l.3-.1zm-1.8.3h.4l-.1.4-.3.3h-.9l-.3-.2-.2-.4v-1.1l.2-.3.7-.3h.5l.3.4.1.4h-.4v-.3l-.2-.1h-.5l-.2.1v.3l-.1.3v.5l.1.2.2.2h.5l.1-.2zm-1.6.7v.4h-1.5v-.4z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M258.8 141.5v1.4h-.3V141h.3zm-.1.4h-.1v-.3l.2-.3.5-.2h.2l.2.1.1.2v1.5h-.3v-1.4l-.1-.1h-.2l-.4.1zm-2.2.1v-.4l.2-.2.2-.2.4-.1.5.3.2.2v.8l-.2.3-.2.1-.3.1h-.4l-.2-.2-.2-.3zm.3 0v.3l.1.2.2.1h.4l.1-.1.1-.2v-.8l-.2-.1h-.4l-.2.1v.2zm-.8-.9v1.8h-.3V141zm-.3-.4h.3v.2h-.2zm-.4.4v.3h-.9v-.3zm-.6-.4h.3v1.9h.3v.3h-.4l-.1-.2v-2m-1.3 2 .4-.2v-.2h.3v.3l-.3.2-.4.1h-.3l-.2-.3-.2-.2v-.8l.2-.2.2-.2.3-.1h.4l.2.3.1.3h-.2l-.1-.2-.1-.1h-.5l-.1.1-.1.2v.8l.2.1zm-1.5-.2V141h.4v1.8h-.3zm.1-.4v.3l-.1.3-.2.1-.3.1h-.3l-.1-.1-.2-.2V141h.3v1.4l.2.1h.4l.2-.2zm-1.9.4v-2h.3v2.4h-.3zm-1.2-.5v-.4l.2-.3.5-.2h.3l.2.2.2.3v.8l-.2.3-.2.1h-.6l-.2-.1-.1-.3zm.3 0v.3l.1.2.2.1h.2l.4-.2v-.9l-.2-.1h-.2l-.4.1zm-2.3 0v-.4l.2-.2.3-.2.3-.1h.3l.3.3.1.2.1.4v.4l-.2.3-.3.1-.3.1h-.3l-.3-.2-.1-.3zm.3 0v.3l.1.2.2.1h.4l.2-.1v-.2l.1-.3v-.3l-.1-.2-.4-.2-.2.1-.2.1zm-1.1-.6v1.5h-.3V141h.3zm.5-.3v.3h-.3l-.2.2v.2h-.2v-.2l.2-.3.1-.1zm-2 .9h-.6v-.3h.9l.1-.2v-.5l-.1-.1-.3-.1h-.6v2h-.3v-2.3h.9l.4.1.3.3.1.3-.1.4-.3.3z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 139,
    fill: "#2f2f2f",
    rx: 2.7
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 139,
    stroke: "#616467",
    strokeWidth: 0.2,
    rx: 2.7
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M299.7 141.5v.8l-.2.3-.2.1h-.7l-.1-.2-.1-.3V141l.1-.3.2-.1h.6l.3.2v.3zm-.3.4v-.9l-.1-.1-.1-.1h-.4v.1l-.2.2v1.2l.2.1v.1h.4l.1-.1.1-.2zm-1.9.7h.3v.2h-.2zm-.4-1.1v.8l-.2.3-.2.1h-.7l-.1-.2-.1-.3V141l.1-.3.2-.1h.6l.3.2v.3zm-.3.4v-.9l-.1-.1-.1-.1h-.3l-.2.1v1.5l.2.1h.3l.1-.1.1-.2zm-1.8.7h.2v.2zm-1-2v2.1h-.2V141l-.6.2v-.2zm54.8 1.6-.2-.1-.2-.1h-.3l-.2-.2-.1-.1v-.2l.1-.4h.2l.3-.1h.4l.2.3v.2h-.2v-.1l-.2-.1h-.5v.3l.2.1h.2l.3.2.2.1v.5l-.1.1-.2.1h-.7l-.2-.2-.1-.3h.3v.2l.2.1h.5zm-2.9-2h.3v2.5h-.3zm1.5 1.6v.4l-.2.2-.2.2h-.6l-.2-.1-.2-.3v-.8l.2-.3.2-.2h.6l.2.2.1.3zm-.3 0v-.3l-.1-.2-.4-.2h-.2l-.1.2-.1.1v.8l.2.2h.4l.2-.2v-.4m-2.2.9h-.3l-.4-.5v-.8l.2-.3.5-.2h.3l.2.2.2.3v.5h-1.3v-.3h1v-.2l-.2-.2h-.4l-.1.1-.1.2v.8l.2.1h.5l.2-.2.2.2-.2.1-.2.1zm-2.9-.7.4-1.7h.3l-.2.7-.5 1.7h-.2zm-.5-1.7.4 1.6v.8h-.2l-.5-2.4zm1.8 1.6.3-1.6h.3l-.5 2.4h-.3zm-.6-1.6.4 1.6.2.8h-.2l-.5-1.7-.1-.7zm-2.8.7v1.7h-.3v-1.8zm-.3-.5v-.2h.3v.2l-.1.1zm-2.6.8v1.4h-.3v-1.8h.3zm0 .4h-.2v-.3l.2-.3.2-.2h.5l.3.3v1.5h-.2v-1.4l-.2-.1h-.4l-.2.1zm1-.1v-.3l.1-.2.3-.2h.5l.2.1v.2l.1.3v1.2h-.3v-1.4l-.1-.1h-.4l-.2.2zm-2.1.8v-1.1l-.2-.1h-.5v.2h-.3v-.2l.1-.1.3-.2h.6l.2.2v1.2l.1.2v.1h-.3zm0-.8v.2h-.6l-.1.2v.3l.3.1h.2l.2-.2v-.1l.1.1v.2l-.3.2h-.6l-.2-.2v-.5l.1-.2h.3l.3-.1zm-2.8-1.3v2.4h-.3v-2.4zm1.4 0-1 1.1-.5.6v-.4l.4-.4.8-.9zm-.3 2.4-.8-1.2.2-.2 1 1.4zm-2.6-.8v.2h-1.7v-.2l1-1.6h.3l-.3.5-.7 1zm-.3-1.6v2.4h-.3v-2.4zm-1.7 2.1v.3H328v-.3l.8-.8.2-.3.1-.2v-.4l-.1-.1h-.5l-.2.2v.2h-.3v-.4l.3-.2.4-.1h.4l.3.3v.7l-.2.2-.2.2-.6.7zm-1.9-1.1v.8l-.2.4-.2.1h-.8l-.1-.3-.1-.2v-1.3l.1-.3.3-.2h.5l.4.3v.3zm-.3.4v-.9l-.2-.2h-.6v1.7l.2.1h.4v-.1l.2-.3zm-1.5.7v.3h-1.6v-.3l.8-.8.2-.3.1-.2v-.4l-.1-.1h-.5l-.2.2v.2h-.3v-.4l.3-.2.5-.1h.3l.3.3v.7l-.2.2-.2.2-.6.7zm-2.8-.1v.5l-.3.3-.1-.1.1-.3v-.4zm-1.2-2v2.4h-.3v-2l-.6.2v-.3zm-3.4 1v1.4h-.3v-1.8h.3zm0 .4h-.2l.1-.3.1-.3.6-.2h.2l.2.1v.2l.1.3v1.2h-.3v-1.4l-.1-.1h-.2l-.4.1-.1.2zm-1.1.7v-1.1l-.1-.1h-.6v.2h-.3v-.2l.2-.1.2-.2h.6l.3.2v1.4l.1.1h-.3zm0-.8.1.2h-.7l-.1.2v.3h.1l.2.1h.2l.2-.2v-.1l.2.1v.2l-.2.1-.2.1h-.6l-.2-.2v-.5l.2-.2h.2l.3-.1zm-1.8.4v-1.7h.3v1.7l-.1.4-.3.2h-.7l-.3-.2v-.4h.2v.2l.2.2h.5l.1-.2zm51.4-.3h-.6v-.2h.7l.2-.2v-.4l-.1-.1h-.8v2h-.3v-2.3h1.1l.3.1.1.2v.6l-.2.2zm0 1.1h-.7l.1-.2h.8l.2-.2v-.5l-.2-.1h-.7v-.3h.7l.3.2.2.2v.6l-.3.3zm-2.7-2.3v2.3h-.3v-2.3zm1.5 0-1 1-.6.7v-.4l.4-.4.8-.9zm-.3 2.3-.9-1.1.2-.3 1 1.4zm-3.3-2.3v2.3h-.3v-2l-.6.3v-.3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bh)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bi)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bj",
    width: 5,
    height: 5,
    x: 408,
    y: 139,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 139.8h-4.2v3.7h4.2z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bj)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m409.1 143 .2.3.1.2.7-1.2h-1.3v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m410.9 141-.7-1.2-.1.2-1.3 2.1v.2h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m412.3 143.5.2-.2v-.1l.4-.7v-.2h-1.2l.2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m410.9 141 .6-1.2h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M411.7 142.3H410l-.7 1.2h2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m412.3 141-.6-1-.2-.2-.6 1.2.8 1.3h1.3v-.2z"
  }))))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M429.4 140.5h.5v.5h-.5zm0 1h.5v1.3h-.5zm.2-2.2a2.3 2.3 0 1 0 0 4.7 2.3 2.3 0 0 0 0-4.7m0 4.2a1.9 1.9 0 1 1 0-3.7 1.9 1.9 0 0 1 0 3.7"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.5 147.8v-.3H57.7v.5h381.8z",
    mask: "url(#bk)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bl)"
  }, _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "bB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7 147.8h381.8v12.1H57.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bm)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bo",
    width: 4,
    height: 5,
    x: 60,
    y: 151,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bn"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bo)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M62.4 152H61q-.3 0-.3.2v3.3q0 .2.3.2h2.2l.2-.2V153l-.5-.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bp",
    width: 4,
    height: 5,
    x: 60,
    y: 151,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bn"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bp)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bq)",
    d: "m62.5 153 1 .9v-1z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "br",
    width: 4,
    height: 5,
    x: 60,
    y: 151,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bn"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#br)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M61.4 154.7h1.4v-.2h-1.4zm0 .3h1v-.1zm0-1.2v.2h1.4v-.2zm0 .6h1.4v-.2h-1.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bs",
    width: 4,
    height: 5,
    x: 60,
    y: 151,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bn"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bs)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a1c2fa",
    d: "M62.4 152v.7q0 .3.3.3h.7z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bt",
    width: 4,
    height: 5,
    x: 60,
    y: 151,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bn"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bt)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M61 152q-.3 0-.3.2zh1.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bu",
    width: 4,
    height: 5,
    x: 60,
    y: 151,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bn"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bu)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    fillOpacity: 0.2,
    d: "M63.2 155.7H61l-.3-.3q0 .3.3.3zl.2-.2z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bv",
    width: 4,
    height: 5,
    x: 60,
    y: 151,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bn"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bv)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    fillOpacity: 0.1,
    d: "m62.7 153-.3-.3q0 .3.3.3h.7z"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bw)",
    d: "M62.4 152H61q-.3 0-.3.2v3.3q0 .2.3.2h2.2l.2-.2V153z"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M103.8 154.8h-.4l-.3-.3-.1-.2v-.8l.1-.3.3-.2h.6l.3.2.1.3v.5h-1.3v-.3h1v-.2l-.2-.1h-.4l-.1.2v.7l.2.1h.4l.2-.2.2.3-.1.1-.2.1zm-1.8-.4.2-.2h.4l-.1.3-.3.2h-.7l-.2-.2-.2-.3v-.7l.2-.3.2-.2h.7l.3.3v.3h-.3v-.1l-.2-.1h-.4l-.1.3v.6l.2.1zm-1.6 0v-1h-.1l-.2-.1h-.1l-.1.1v.1h-.5v-.2l.2-.2h.9l.2.1.1.4v1.1h-.3v-.1zm0-.7v.2h-.4l-.1.1v.4h.3l.2-.1v-.1l.1.2-.1.2-.4.2h-.3l-.3-.3v-.5l.2-.2h.2l.4-.1zm-2.4-.4v2.1h-.5V153h.4zm1 .6v.6l-.3.2h-.6l-.2-.2-.1-.2v-.8l.1-.3.2-.2h.6l.2.2.1.3zm-.3 0v-.3l-.1-.1-.1-.1H98l-.2.2v.6l.2.2h.4v-.1l.1-.2zm-1.9.4-.2-.1h-.2l-.2-.1-.2-.2-.2-.1v-.4l.2-.2h.2l.3-.1h.3l.3.2v.3h-.3v-.1h-.2l-.1-.1h-.2l-.1.2v.1h.2l.1.1.4.1.2.2v.2l-.1.4-.2.1H96l-.3-.2v-.3h.3v.2h.6zm-2.3-2v2.4H94v-2.4zm1 .7-.7.9-.4.4-.1-.4.3-.4.4-.5zm-.4 1.7-.5-.8.3-.2.7 1zm-1.9-1.3v1.3h-.4V153h.4zm.6-.4v.4h-.4l-.2.2v.2-.6l.2-.2zm-3 .9.1-.4.2-.3.2-.2h.7l.3.2.1.3v.7l-.1.3-.3.2h-.7l-.2-.2q-.2 0-.2-.3zm.5 0v.4l.2.1h.3l.2-.1v-.8l-.3-.2-.3.2-.1.1zm-2.6.4.4-1.9h.3v.4l-.5 2h-.3zm-.3-1.9.4 1.9v.4h-.3l-.6-2.3zm1.5 1.9.4-1.9h.4l-.5 2.3h-.3zm-.4-1.9.5 1.9v.4h-.3l-.5-1.9v-.4zm-2.2 1.9-.2-.1H87l-.2-.1-.2-.2-.2-.1v-.4l.2-.2h.2l.3-.1h.4l.2.2v.3h-.3v-.1H87l-.1-.1h-.2v.3l.2.1.4.1.2.2v.2l-.1.4-.2.1h-.7l-.3-.2v-.3h.3l.1.2h.5zm-3.4-.9v1.3h-.5V153h.4zm-.1.4v-.3l.1-.3.5-.2h.3l.1.1.1.2v1.4h-.3v-1.3H84v.2zm1 0v-.3l.1-.3.3-.2h.5l.2.1v.2l.1.3v1.1h-.4v-1.3H85v.3m-3.9-.3v1.3h-.5V153h.4zm-.1.4v-.3l.1-.3.6-.2h.2l.1.1.2.2v1.4h-.4v-1.3H81v.2zm1 0v-.3l.2-.3.2-.2h.5l.2.1v.2l.1.3v1.1h-.4v-1.3H82v.3m-3.4.2v-.4l.2-.3.2-.2h.7l.3.2.1.3.1.4v.3q0 .2-.2.3l-.3.2H79l-.2-.2-.2-.3zm.4 0v.4l.2.1h.4v-.1l.2-.2v-.5l-.1-.1-.3-.2-.3.2v.1zm-1.1.1h.4l-.1.4-.3.3H77l-.3-.2-.2-.4V153l.2-.3.7-.3h.5q0 .2.3.4l.1.4h-.4l-.1-.3-.2-.1h-.4l-.2.1-.1.3v1l.2.2h.5l.2-.2zm-1.8-1v.3h-1v-.3zm-.7-.4h.4v1.8h.4v.3h-.6l-.1-.1v-2m-1.6.8v1.3h-.5V153h.4zm-.1.4v-.3l.2-.3.5-.2h.2l.2.1v.2l.1.3v1.1h-.4v-1.3H74v.2zm-1.4 1h-.3l-.5-.5v-.8l.2-.3.2-.2h.7l.2.2.2.3v.5h-1.3v-.3h.9v-.2l-.1-.1H72v.2l-.1.3v.2l.1.2.2.1h.4l.2-.2.2.3-.2.1-.2.1zm-1.2-1.8v1.7h-.4V153zm-.5-.4.1-.2h.4v.3h-.4zm-.4-.3v2.4h-.4v-2.4zM69 154h.5l-.1.4-.3.3h-.9l-.3-.2-.2-.4V153l.2-.3.7-.3h.5l.3.4.1.4h-.4l-.1-.3-.1-.1h-.5l-.2.1-.1.3v1l.2.2h.5l.2-.2zm-1.6.7v.4H66v-.4z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M255.2 155h-.3l-.4-.5v-.7q0-.2.2-.3l.2-.2h.6l.2.2.2.3v.4h-1.3v-.2h1v-.3l-.2-.1-.2-.1-.3.2-.1.2v.7l.4.2h.3l.2-.2.2.1-.2.2h-.2zm-1.8-.3.5-1.4h.3l-.6 1.7h-.2zm-.4-1.4.5 1.5v.2h-.1l-.7-1.7zm-.6 0v1.7h-.3v-1.7zm-.3-.5h.3v.2zm-.4.4v.2h-1v-.2zm-.6-.4h.3v1.8h.2v.3h-.3l-.2-.1zm-.9 1.8v-1.1h-.2l-.2-.1h-.2l-.1.1v.2h-.4v-.2l.2-.2.2-.1h.6l.3.2v1.3l.1.2h-.3zm0-.7v.2h-.7v.1l-.1.2v.1l.1.1h.2l.4-.1v-.2l.2.2v.1l-.2.2h-.2l-.2.1h-.3l-.3-.2v-.5l.2-.2.2-.1zm-2.2 1h-.3l-.4-.5v-.7q0-.2.2-.3l.2-.2h.6l.3.2.1.3v.4h-1.3v-.2h1v-.3l-.1-.1-.3-.1-.3.2-.1.2v.5l.1.2.4.2h.2l.2-.2.2.1-.1.2h-.2zm-1.5-1.4v1.4h-.3v-1.7h.3zm.6-.3v.2h-.4v.2h-.2v.3h-.1v-.3l.1-.2.2-.2zm-1.6 1h.3l-.1.4-.3.2-.5.1h-.3l-.3-.3-.2-.3v-1.1l.2-.4.3-.2h.8l.3.3.1.4h-.3v-.3l-.3-.1-.2-.1h-.3l-.2.2-.1.3v1.1l.3.2h.5q.2 0 .2-.2z"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 151.1,
    fill: "#2f2f2f",
    rx: 2.7
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 151.1,
    stroke: "#616467",
    strokeWidth: 0.2,
    rx: 2.7
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M299.7 153.7v.7q0 .3-.2.3l-.2.2h-.5l-.3-.3-.1-.2v-1.2l.1-.3.2-.1h.6l.3.2v.3zm-.3.3v-.8l-.1-.1-.1-.1h-.4v.1l-.2.2v1.2l.2.1v.1h.4l.1-.1.1-.2zm-1.9.8h.3v.2zm-.4-1.1v.7q0 .3-.2.3l-.2.2h-.5l-.3-.3-.1-.2v-1.2l.1-.3.2-.1h.8v.2l.2.3zm-.3.3v-.8l-.1-.1-.1-.1h-.3l-.2.1v1.5l.2.1h.3l.1-.1.1-.2zm-1.8.8h.2v.2zm-1-2.1v2.2h-.2v-1.8l-.6.2v-.3zm54.8 1.7-.2-.1-.2-.1h-.3l-.2-.2-.1-.1v-.2l.1-.4h.2l.3-.1h.4l.2.2v.3h-.2v-.1l-.2-.1h-.5v.3h.2l.2.1.3.2.2.1v.3l-.1.3-.2.1h-.7l-.2-.2-.1-.3h.3v.2l.2.1h.5zm-2.9-2h.3v2.4h-.3zm1.5 1.6v.3l-.2.3-.2.2h-.6l-.2-.1-.2-.3v-.8l.2-.3.2-.2h.6l.2.2.1.3zm-.3 0v-.3l-.1-.2-.2-.1h-.5l-.1.2v.8l.2.2h.4l.2-.2v-.4m-2.2.9h-.3l-.4-.5v-.8l.2-.3.8-.2.2.2.2.3v.5h-1.3v-.3h1v-.2l-.2-.2h-.5l-.1.3v.8l.4.1h.3l.2-.2.2.1-.2.2-.2.1zm-2.9-.8.4-1.6h.3l-.2.6-.5 1.7h-.2zm-.5-1.6.4 1.6v.7h-.2l-.5-2.3zm1.8 1.6.3-1.6h.3l-.5 2.3h-.3zm-.6-1.6.4 1.6.2.7h-.2l-.5-1.7-.1-.6zm-2.8.6v1.7h-.3v-1.7zm-.3-.5.2-.1h.1v.3h-.2zm-2.6.9v1.3h-.3v-1.7h.3zm0 .4h-.2v-.3l.2-.3.2-.2h.5l.2.1.1.2v1.4h-.2v-1.3l-.2-.1h-.4l-.2.1zm1-.2v-.3l.1-.2.5-.2h.3l.3.3v1.4h-.3v-1.3l-.1-.1h-.5l-.1.2zm-2.1.8v-1l-.2-.1h-.5v.2h-.3v-.2l.1-.2h.3l.2-.1h.4l.2.2v1.2l.1.1v.2h-.3zm0-.7v.2h-.6l-.1.2v.3l.3.1.4-.2v-.1h.1v.2l-.3.3h-.6l-.2-.2v-.5l.1-.2h.3l.3-.1zm-2.8-1.3v2.3h-.3v-2.3zm1.4 0-1 1.1-.5.6v-.4l.4-.4.8-.9zm-.3 2.3-.8-1.1.2-.2 1 1.3zm-2.6-.8v.3h-1.7v-.2l1-1.6h.3l-.3.5-.7 1zm-.3-1.5v2.3h-.3v-2.3zm-1.7 2.1v.2H328v-.2l.8-.8.2-.3.1-.2v-.4l-.1-.1h-.5l-.2.1v.3h-.3v-.4l.3-.2.4-.1h.4l.3.3v.7l-.2.2-.2.2-.6.7zm-1.9-1.1v.8q0 .3-.2.3l-.2.2h-.8l-.1-.3-.1-.3V153l.1-.3.3-.2h.5l.2.1.2.2v.3zm-.3.4v-.9l-.2-.2h-.6v1.7l.2.1h.4v-.1l.2-.3zm-1.5.7v.2h-1.6v-.2l.8-.8.2-.3.1-.2v-.4l-.1-.1h-.5l-.2.1v.3h-.3v-.4l.3-.2.5-.1h.3l.3.3v.7l-.2.2-.2.2-.6.7zm-2.8-.1v.5l-.3.3-.1-.1.1-.3v-.4zm-1.2-2v2.3h-.3v-2l-.6.3v-.3zm-3.4 1v1.3h-.3v-1.7h.3zm0 .4h-.2l.1-.3.1-.3.6-.2h.2l.2.1v.2l.1.3v1.1h-.3v-1.3l-.1-.1h-.2l-.4.1-.1.2zm-1.1.6v-1l-.1-.1h-.6v.2h-.3v-.2l.2-.2h.2l.3-.1h.3l.3.2v1.3l.1.2h-.3zm0-.7.1.2h-.7l-.1.2v.3h.1l.2.1.4-.2v-.1h.2v.2l-.4.3h-.6l-.2-.2v-.5l.2-.2h.2l.3-.1zm-1.8.4v-1.7h.3v1.7l-.1.3q0 .2-.3.3h-.7l-.3-.2v-.4h.2v.2l.2.2h.5l.1-.2zm53.3-.2h-.6v-.3h.7l.2-.2v-.4l-.2-.1h-.7v2h-.3v-2.3h1.1l.2.1.2.2v.6l-.2.2h-.3zm0 1h-.8l.2-.2h.8l.2-.2v-.5l-.2-.1h-.7v-.3h.6l.4.2.2.2v.6l-.4.2zm-2.7-2.3v2.3h-.3v-2.3zm1.4 0-1 1-.5.6v-.3l.4-.5.8-.8zm-.3 2.3-.8-1.1.2-.3 1 1.4zm-2.7-1.3v.8l-.2.3-.3.2h-.5l-.4-.3v-.3l-.1-.4v-.8q0-.3.2-.3l.2-.2h.6l.3.3.1.3zm-.3.4v-.8l-.1-.2v-.1h-.2l-.2-.1h-.2v.2q-.2 0-.2.2v1.2l.2.2h.6zm-2-1.4v2.3h-.3v-2l-.6.3v-.3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bx)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#by)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bz",
    width: 5,
    height: 5,
    x: 408,
    y: 151,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 152h-4.2v3.7h4.2z"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bz)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m409.1 155.2.2.3.1.2.7-1.2h-1.3v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m410.9 153.2-.7-1.2-.1.2-1.3 2.1v.2h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m412.3 155.7.2-.2v-.1l.4-.7v-.2h-1.2l.2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m410.9 153.2.6-1.2h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M411.7 154.5H410l-.7 1.2h2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m412.3 153.2-.6-1-.2-.2-.6 1.2.8 1.3h1.3v-.2z"
  }))))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M429.4 152.7h.5v.4h-.5zm0 1h.5v1.3h-.5zm.2-2.2a2.3 2.3 0 1 0 0 4.7 2.3 2.3 0 0 0 0-4.7m0 4.2a1.9 1.9 0 1 1 0-3.7 1.9 1.9 0 0 1 0 3.7"
  })))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.5 160v-.3H57.7v.5h381.8z",
    mask: "url(#bB)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bC)"
  }, _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "bS",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7 160h381.8v12H57.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bD)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bF",
    width: 4,
    height: 4,
    x: 60,
    y: 164,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bE"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bF)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M62.4 164.2H61q-.3 0-.3.2v3.3l.3.2h2.2l.2-.2v-2.5l-.5-.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bG",
    width: 4,
    height: 4,
    x: 60,
    y: 164,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bE"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bH)",
    d: "m62.5 165.1 1 1v-1z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bI",
    width: 4,
    height: 4,
    x: 60,
    y: 164,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bE"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M61.4 166.9h1.4v-.2h-1.4zm0 .3h1v-.1zm0-1.2v.2h1.4v-.2zm0 .5h1.4v-.1z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bJ",
    width: 4,
    height: 4,
    x: 60,
    y: 164,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bE"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bJ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a1c2fa",
    d: "M62.4 164.2v.7q0 .3.3.3h.7z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bK",
    width: 4,
    height: 4,
    x: 60,
    y: 164,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bE"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M61 164.2q-.3 0-.3.2 0-.2.3-.2h1.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bL",
    width: 4,
    height: 4,
    x: 60,
    y: 164,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bE"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bL)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    fillOpacity: 0.2,
    d: "M63.2 167.9H61l-.3-.3q0 .3.3.3zl.2-.2z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bM",
    width: 4,
    height: 4,
    x: 60,
    y: 164,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bE"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bM)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    fillOpacity: 0.1,
    d: "m62.7 165.2-.3-.3q0 .3.3.3h.7z"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bN)",
    d: "M62.4 164.2H61q-.3 0-.3.2v3.3l.3.2h2.2l.2-.2v-2.5z"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "m91.5 167-.4-.1-.4-.4v-.8l.1-.3.3-.2h.7l.2.2.1.3v.5h-1.3v-.3h1v-.2l-.2-.2h-.2l-.3.2v.8h.2l.2.1h.2l.2-.2.2.2-.1.2-.2.1zm-1.8-.4v-.2h.5l-.1.4-.3.2h-.7l-.2-.2-.2-.3v-.7l.2-.3.2-.2h.7l.3.3v.3H90v-.1l-.2-.2h-.3l-.1.2v.1l-.1.2v.5h.2zm-1.6 0v-1H88l-.2-.1h-.2v.2H87v-.2l.2-.2h.9l.3.5v1.1h-.3v-.1zm0-.7v.2h-.4l-.1.1v.4h.3l.2-.1v-.1l.1.1v.2l-.3.2h-.5l-.2-.2-.1-.3v-.2l.2-.2h.2l.4-.1zm-2.4-.4v2.1h-.4v-2.4h.3zm1 .5v.7l-.3.2h-.6l-.2-.2v-.2l-.2-.4.1-.4.1-.3.2-.2h.6l.2.2.2.3zm-.3 0v-.2l-.1-.1-.1-.2h-.4v.1l-.1.2v.6l.1.2h.2l.3-.1zm-1.8.4-.2-.1h-.2l-.2-.2h-.2l-.2-.2v-.4l.2-.2h.2l.3-.1h.4l.2.2v.3h-.3v-.1l-.2-.1H84v.3l.2.1.4.1.2.2.1.2-.2.4-.2.1h-.7l-.3-.2v-.3h.3l.1.1.1.1h.4zm-2.3-2v2.4h-.4v-2.4zm1 .7-.7.8-.4.5-.1-.4.3-.4.5-.5zm-.4 1.7-.5-.8.3-.3.7 1.1zm-1.8-1.3v1.3h-.5v-1.7h.4zm.5-.4v.4H81l-.2.2v.2-.6l.2-.2zm-2.9.8v-.3l.2-.3.2-.2h.7l.3.2.1.3v.7l-.1.3-.3.2H79l-.2-.2-.2-.3zm.4 0v.5h.2l.2.1h.1l.2-.1v-.8l-.3-.2-.3.2-.1.1zm-2.6.5.4-1.9h.3v.4l-.5 2h-.3zm-.3-1.9.4 1.9v.4h-.3l-.6-2.3zm1.5 1.9.4-1.9h.4l-.5 2.3h-.3zm-.4-1.9.5 1.9v.4h-.3l-.5-2v-.3zm-2.2 1v1.3h-.5v-1.7h.4zm.5-.4v.4H75v.4h-.2v-.4l.2-.2.1-.2zm-2.9.8v-.3l.2-.3.2-.2h.7l.3.2.1.3.1.3v.4l-.2.3-.3.2H73l-.2-.2-.2-.3zm.4 0v.5h.2l.2.1h.2v-.1l.2-.2v-.5l-.1-.1-.3-.2-.3.2v.1zm-.8-1.5v2.4h-.4v-2.4zm-2.4 1.5v-.3l.2-.3.2-.2h.7l.3.2.2.3v.7l-.2.3-.3.2h-.7l-.2-.2-.2-.3zm.4 0v.5h.2l.2.1h.2v-.1l.2-.2v-.5l-.1-.1-.3-.2-.3.2v.1zm-1.2.2h.5l-.1.4-.3.3h-.9l-.3-.2-.2-.4v-1.1l.2-.3.3-.3h.9l.3.4.1.4h-.4l-.1-.3-.1-.1h-.5l-.2.1-.1.2v1.1l.2.2h.5l.2-.2zm-1.6.8v.3H66v-.4z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M255.2 167.2h-.3l-.4-.5v-.8l.2-.2.5-.3.3.1.2.2.2.2v.5h-1.3v-.2h1v-.3l-.2-.2h-.2l-.3.1-.1.2v.8l.2.1h.5l.2-.1h.2q0 .2-.2.3h-.2zm-1.8-.2.5-1.5h.3l-.6 1.7h-.2zm-.4-1.5.5 1.4v.3h-.1l-.7-1.7zm-.6 0v1.7h-.3v-1.7zm-.3-.5h.3v.2h-.2zm-.4.5v.2h-1v-.2zm-.6-.5h.3v1.9h.2v.3h-.3q-.2 0-.2-.2zm-.9 1.9v-1.1h-.2l-.2-.1h-.2l-.1.1v.1h-.4v-.1l.2-.2.2-.1h.6l.3.2v1.3l.1.2h-.3zm0-.8v.3h-.7v.1l-.1.2v.1l.1.1h.2l.4-.1v-.2l.2.2v.1l-.4.3h-.5l-.3-.2v-.5l.2-.2.2-.1h.7m-2.2 1h-.3l-.4-.5v-.8l.2-.2.5-.3.3.1.3.2.1.2v.5h-1.3v-.2h1v-.3l-.1-.2h-.3l-.3.1-.1.2v.6l.1.2.2.1h.4l.2-.1h.2l-.1.3h-.2zm-1.5-1.5v1.5h-.3v-1.7h.3zm.6-.2v.2h-.4v.1l-.2.2v.2h-.1v-.3l.1-.2.2-.2zm-1.6 1h.3l-.1.4-.3.2-.5.1h-.3l-.3-.3-.2-.3v-1.1q0-.3.2-.4l.3-.2h.8l.3.3.1.4h-.3v-.3l-.3-.2h-.5l-.2.2-.1.3v1.1l.3.2h.5q.2 0 .2-.2z"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 163.3,
    fill: "#2f2f2f",
    rx: 2.7
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 163.3,
    stroke: "#616467",
    strokeWidth: 0.2,
    rx: 2.7
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M299.7 165.9v.7q0 .3-.2.3l-.2.2h-.7l-.1-.3-.1-.2v-1.2l.1-.3.2-.1h.6l.3.2v.3zm-.3.3v-.8l-.1-.2h-.5l-.2.3v1.2l.2.1.2.1h.2l.1-.1.1-.3zm-1.9.8.2-.1h.1v.3zm-.4-1.1v.7q0 .3-.2.3l-.2.2h-.7l-.1-.3-.1-.2v-1.2l.1-.3.2-.1h.6l.3.2v.3zm-.3.3v-.8l-.1-.2h-.6v1.6h.2l.1.1h.2l.1-.1.1-.3zm-1.8.8.1-.1h.1v.3zm-1-2v2.1h-.2v-1.8l-.6.2v-.3zm54.8 1.6v-.2h-.2l-.2-.1-.3-.1-.2-.1-.1-.1v-.2l.1-.4.2-.1h.7l.2.2v.3h-.2v-.1l-.2-.1h-.5v.3h.2l.2.1.3.1.2.2v.5l-.1.1-.2.1h-.7l-.2-.2-.1-.3h.3v.2h.7zm-2.9-2h.3v2.4h-.3zm1.5 1.5v.4l-.2.3-.2.2h-.6l-.2-.2-.2-.2v-.9l.2-.2.2-.2h.6l.2.2.1.3zm-.3 0v-.2l-.1-.2-.4-.2h-.2l-.1.2-.1.1v.8l.2.1.2.1h.2l.2-.2v-.4m-2.2.8h-.3l-.4-.4v-.8l.2-.3.5-.2h.3l.2.2.2.3v.4h-1.3v-.2h1v-.2l-.2-.2h-.5l-.1.3v.7l.2.2h.5l.2-.2.2.1-.2.2-.2.1zm-2.9-.7.4-1.6h.3l-.2.6-.5 1.7h-.2zm-.5-1.6.4 1.6v.7h-.2l-.5-2.3zm1.8 1.6.3-1.6h.3l-.5 2.3h-.3zm-.6-1.6.4 1.6.2.7h-.2l-.5-1.7-.1-.6zm-2.8.6v1.7h-.3v-1.7zm-.3-.5.2-.1h.1v.3h-.2zm-2.6.8v1.4h-.3v-1.7h.3zm0 .5h-.2v-.3l.2-.3.2-.2h.5l.3.3v1.4h-.2v-1.3l-.2-.1h-.6zm1-.2h-.1v-.2l.1-.2.3-.2h.5l.2.1v.2l.1.3v1.1h-.3v-1.3l-.1-.2h-.4zm-2.1.8v-1l-.2-.2h-.4l-.1.1v.2h-.3v-.2l.1-.2h.3l.2-.1h.4l.2.2v1.1l.1.2v.2h-.3zm0-.7v.2h-.6l-.1.2v.3l.3.1h.2l.2-.2v-.2l.1.2v.1l-.3.3h-.6l-.2-.2v-.5l.1-.2h.3l.3-.1zm-2.8-1.3v2.3h-.3v-2.3zm1.4 0-1 1-.5.6v-.3l.4-.4.8-1zm-.3 2.3-.8-1.1.2-.3 1 1.4zm-2.6-.8v.3h-1.7v-.2l1-1.6h.3l-.3.5-.7 1zm-.3-1.5v2.3h-.3v-2.3zm-1.7 2.1v.2H328v-.2l.8-.8.2-.3.1-.2v-.4l-.1-.1h-.5l-.2.1v.3h-.3v-.4l.3-.2.4-.1h.4l.3.3v.7l-.2.2-.2.2-.6.7zm-1.9-1.1v.8l-.2.3-.2.2h-.8l-.1-.3-.1-.3v-1.2l.1-.3.3-.2h.5l.4.3v.3zm-.3.4v-1h-.2v-.2h-.4l-.2.2v1.6h.2l.2.1h.2v-.2q.2 0 .2-.2zm-1.5.7v.2h-1.6v-.2l.8-.8.2-.3.1-.2v-.4l-.1-.1h-.5l-.2.1v.3h-.3v-.4l.3-.2.5-.1h.3l.3.3v.7l-.2.2-.2.2-.6.7zm-2.8-.1v.5l-.3.3-.1-.1.1-.3v-.4zm-1.2-2v2.3h-.3v-2l-.6.3v-.3zm-3.4 1v1.3h-.3v-1.7h.3zm0 .4h-.2l.1-.3.1-.3.6-.2h.2l.2.1v.2l.1.3v1.1h-.3v-1.3l-.1-.1h-.6l-.1.3zm-1.1.6v-1l-.1-.2h-.4l-.2.1v.2h-.3v-.2l.2-.2h.2l.3-.1h.3l.3.2v1.3l.1.2h-.3zm0-.7.1.2h-.7l-.1.2v.3h.1l.2.1h.2l.2-.2v-.2l.2.2v.1l-.2.2-.2.1h-.6l-.2-.2v-.5l.2-.2h.2l.3-.1zm-1.9.3v-1.6h.3v1.6l-.1.4-.3.3h-.7l-.3-.2v-.4h.2v.2l.2.2h.5l.1-.2zm53.3-.2h-.6v-.2h.7l.2-.2v-.4l-.2-.1h-.7v2h-.3V165h1.1l.2.1.2.2v.6l-.2.2zm0 1.1h-.8l.2-.2h.8l.2-.2v-.5l-.2-.1h-.7v-.3h.6l.4.2.2.2v.6l-.4.2zm-2.7-2.3v2.3h-.3V165zm1.4 0-1 1-.5.6v-.3l.4-.4.8-1zm-.3 2.3-.8-1.1.2-.3 1 1.4zm-2.7-.2v.2H363v-.2l.8-.8q0-.2.2-.3l.1-.2v-.4l-.2-.2h-.4l-.2.2v.3h-.3v-.4l.3-.3h.8l.2.2.1.4v.2l-.1.2-.1.2-.2.2-.6.7zm-2.4-2.1v2.3h-.3v-2l-.6.3v-.3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bO)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bP)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bQ",
    width: 5,
    height: 4,
    x: 408,
    y: 164,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 164.2h-4.2v3.7h4.2z"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m409.1 167.4.2.3.1.1.7-1.1h-1.3v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m410.9 165.4-.7-1.2-.1.2-1.3 2v.3h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m412.3 167.8.2-.1v-.1l.4-.7v-.2h-1.2l.2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m410.9 165.4.6-1.2h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M411.7 166.7H410l-.7 1.1.3.1h2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m412.3 165.4-.6-1-.2-.2-.6 1.2.8 1.3h1.3v-.2z"
  }))))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bR)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M429.4 164.9h.5v.4h-.5zm0 .9h.5v1.4h-.5zm.2-2.1a2.3 2.3 0 1 0 0 4.7 2.3 2.3 0 0 0 0-4.7m0 4.2a1.9 1.9 0 1 1 0-3.7 1.9 1.9 0 0 1 0 3.7"
  })))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.5 172.1v-.2H57.7v.5h381.8z",
    mask: "url(#bS)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bT)"
  }, _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "ck",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7 172.1h381.8v12.2H57.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bU)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bW",
    width: 4,
    height: 5,
    x: 60,
    y: 176,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bV"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f4b400",
    d: "M62.4 176.3H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3v-2.4l-.6-.5z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bX",
    width: 4,
    height: 5,
    x: 60,
    y: 176,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bV"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bX)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M62.7 178h-1.2v1.4h1.2zm0 1h-1.1v-.6h1z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bY",
    width: 4,
    height: 5,
    x: 60,
    y: 176,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bV"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bY)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bZ)",
    d: "m62.5 177.3 1 1v-1z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ca",
    width: 4,
    height: 5,
    x: 60,
    y: 176,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bV"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ca)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fada80",
    d: "M62.4 176.3v.8q0 .3.3.3h.8z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cb",
    width: 4,
    height: 5,
    x: 60,
    y: 176,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bV"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M61 176.3q-.3 0-.3.3 0-.2.3-.2h1.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cc",
    width: 4,
    height: 5,
    x: 60,
    y: 176,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bV"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bf360c",
    fillOpacity: 0.2,
    d: "M63.2 180H61l-.3-.2q0 .3.3.3zq.2 0 .3-.3 0 .3-.3.3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cd",
    width: 4,
    height: 5,
    x: 60,
    y: 176,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bV"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bf360c",
    fillOpacity: 0.1,
    d: "m62.7 177.4-.3-.3q0 .3.3.3h.8z"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ce)",
    d: "M62.4 176.3H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3v-2.4z"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M95.9 179.1h-.4l-.4-.5v-.7l.2-.3.2-.2h.7l.2.2.1.3v.5h-1.3v-.3h1v-.2l-.2-.2h-.3l-.1.1-.1.2v.7h.2l.2.1h.3l.1-.2.3.2-.2.2-.2.1zm-1.9-.3h.2l.2-.3h.4l-.1.3-.3.3h-.7l-.2-.2-.2-.3v-.7l.2-.3.2-.2h.7l.3.3v.3h-.3v-.2h-.2l-.1-.1h-.2l-.1.2v.8zm-1.5-.1v-.9l-.1-.1H92v.2h-.5v-.2l.2-.2.3-.1h.6l.3.6v.9l.1.2h-.4zm0-.6v.2h-.4l-.2.2v.2h.1l.2.1h.2v-.1l.1-.2.2.2-.2.3-.4.1h-.3l-.2-.2-.1-.3v-.2l.2-.2.2-.1zm-2.7-.4v2h-.3v-2.3h.4zm1.2.5v.4l-.2.3-.2.2h-.5l-.2-.2-.2-.3v-.7l.2-.3.2-.2h.5l.2.2.2.3zm-.4 0v-.2l-.1-.2h-.1l-.2-.1H90v.1l-.1.2v.6l.1.2h.4l.1-.1zm-1.8.3-.3-.1h-.2l-.2-.2-.1-.1v-.6l.3-.1h.7l.2.2.1.3h-.4v-.1l-.1-.1h-.4v.3h.3l.3.2q.2 0 .2.2l.1.2-.2.4-.2.1h-.7l-.3-.3v-.2h.4v.1l.1.1h.4zm-2.3-1.9v2.4h-.4v-2.4zm1 .7-.7.8-.4.4-.1-.3.3-.4.5-.5zm-.4 1.7-.5-.8.3-.3.7 1.1zm-1.8-1.4v1.4h-.5v-1.7h.4zm.5-.3v.4h-.5v.3h-.2v-.3l.2-.2.1-.2zm-2.9.9v-.4l.2-.3.2-.2h.7l.3.2.1.3.1.3v.4l-.2.3-.3.2h-.7l-.2-.2-.2-.3zm.4 0v.4h.2l.2.1h.2v-.1l.2-.2v-.5l-.1-.2-.3-.1-.3.2v.1zm-2.6.4.4-2h.3v.5l-.5 2h-.2zm-.3-2 .4 2v.4h-.3l-.5-2.3zm1.5 2 .4-2h.4l-.5 2.4H82zm-.4-2 .5 2v.4h-.3l-.4-2v-.3zm-2.4 2.4h-.4l-.4-.5-.1-.3v-.4l.2-.3.3-.2h.6l.3.2.1.3v.5h-1.3v-.3h1l-.1-.2-.1-.2h-.4v.1l-.1.2v.7h.2l.2.1h.2l.2-.2.2.2-.1.2-.2.1zm-1.9-.3.4-1.4h.4l-.6 1.7h-.2zm-.3-1.4.4 1.4v.3H77l-.6-1.7zm-.7 0v1.7h-.5v-1.7zm-.5-.5h.4l.1.1v.2h-.4zm-.3.5v.3h-1v-.3zm-.7-.4h.4v1.7l.2.1h.1v.3H75l-.2-.2zm-1 1.7v-1h-.5v.2h-.5l.1-.2.1-.2.3-.1h.6l.4.6v1.1H74v-.4m0-.6v.2h-.5v.4l.2.1h.2l.1-.1v-.2l.2.2-.2.3-.4.1H73l-.2-.2v-.5l.1-.2.3-.1h.6m-2 1h-.3l-.4-.5-.1-.3v-.4l.2-.3.3-.2h.6l.3.2.1.3v.5h-1.3v-.3h1l-.1-.2-.1-.2h-.4v.1l-.1.2v.7h.2l.2.1h.2l.2-.2.2.2-.1.2-.3.1zm-1.5-1.4v1.4h-.4v-1.7h.4zm.5-.3v.4h-.4l-.1.2v.1h-.1v-.3l.1-.2.2-.2zm-1.8 1h.5l-.1.4-.3.2-.5.1h-.4l-.3-.2-.2-.4v-1.1l.2-.3.7-.3h.5l.3.3.1.5h-.4v-.3l-.2-.1-.3-.1h-.2l-.2.2v.2l-.1.4v.5l.1.2.2.1.2.1h.3l.1-.2zm-1.5.7v.3H66v-.3z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M255.2 179.4h-.3l-.4-.5v-.8l.2-.2.2-.2h.6q.2 0 .2.2l.2.2v.5h-1.3v-.2h1v-.3l-.2-.2h-.2l-.3.1-.1.2v.8l.4.2h.3l.2-.3.2.2-.2.1-.2.2zm-1.8-.3.5-1.4h.3l-.6 1.7h-.2zm-.4-1.4.5 1.4v.3h-.1l-.7-1.7zm-.6 0v1.7h-.3v-1.7zm-.3-.5h.3v.2h-.2zm-.4.5v.2h-1v-.2zm-.6-.5h.3v1.9h.2v.3h-.3l-.2-.2zm-.9 1.8v-1l-.2-.1h-.4l-.1.1v.1h-.4v-.2l.2-.1.2-.1h.6l.3.2v1.3l.1.2h-.3zm0-.7v.2h-.5l-.2.1v.1l-.1.2v.1l.1.1h.2l.4-.1v-.2l.2.1v.2l-.2.1-.2.2h-.5l-.3-.2v-.5l.2-.2.2-.1zm-2.2.9h-.3l-.4-.5v-.8l.2-.2.2-.2h.6l.3.2.1.2v.5h-1.3v-.2h1v-.3l-.1-.2h-.3l-.3.1-.1.2v.6l.1.2.4.2h.2l.2-.3.2.2-.1.1-.2.2zm-1.5-1.4v1.4h-.3v-1.7h.3zm.6-.4v.3h-.4v.1l-.2.2v.1h-.1v-.2l.1-.3.2-.1zm-1.6 1h.3l-.1.4q0 .2-.3.3l-.5.1h-.3l-.3-.3-.2-.3v-1.1q0-.3.2-.4l.3-.2h.8l.3.3.1.4h-.3v-.3l-.3-.2h-.5l-.2.2-.1.3v1.1l.3.2h.5l.2-.2z"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 175.5,
    fill: "#2f2f2f",
    rx: 2.7
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 175.5,
    stroke: "#616467",
    strokeWidth: 0.2,
    rx: 2.7
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M299.7 178v.8l-.2.3-.2.2h-.5l-.3-.3-.1-.3v-1.1l.1-.3.2-.1h.6l.3.2v.3zm-.3.4v-.8l-.1-.2h-.5l-.2.3v1.2l.2.1.2.1h.2l.1-.2.1-.2zm-1.9.8v-.2h.3v.3zm-.4-1.2v.8l-.2.3-.2.2h-.5l-.3-.3-.1-.3v-1.1l.1-.3.2-.1h.8v.2l.2.3zm-.3.4v-.8l-.1-.2h-.6v1.6h.2l.1.1h.2l.1-.2.1-.2zm-1.8.8v-.2h.2v.3zm-1-2.1v2.2h-.2v-1.8l-.6.2v-.3zm54.8 1.7v-.2h-.2l-.2-.1-.3-.1-.2-.1-.1-.2v-.1l.1-.4.2-.1h.7l.2.2v.3h-.2v-.1l-.2-.2h-.4l-.1.1v.3h.2l.2.1.3.1.2.2v.2l-.1.4-.2.1h-.7l-.2-.2-.1-.3h.3v.2h.2l.2.1h.2zm-2.9-2h.3v2.4h-.3zm1.5 1.5v.4l-.2.3-.2.2h-.6l-.2-.2-.2-.2v-.9l.2-.2.2-.2h.6l.2.2.1.3zm-.3 0v-.2l-.1-.2-.2-.1-.2-.1h-.2l-.1.1-.1.2v.8l.2.1.2.1h.2l.2-.2v-.4m-2.2.8h-.3l-.4-.5v-.7l.2-.3.8-.2.2.2.2.3v.4h-1.3v-.2h1v-.3l-.2-.1-.2-.1-.3.2-.1.2v.7l.4.2h.3l.2-.2.2.1-.2.2-.2.1zm-2.9-.7.4-1.6h.3l-.2.6-.5 1.7h-.2zm-.5-1.6.4 1.6v.7h-.2l-.5-2.3zm1.8 1.6.3-1.6h.3l-.5 2.3h-.3zm-.6-1.6.4 1.6.2.7h-.2l-.5-1.7-.1-.6zm-2.8.6v1.7h-.3v-1.7zm-.3-.5h.3v.2h-.2m-2.7.6v1.4h-.3v-1.7h.3zm0 .5h-.2v-.4l.2-.2.2-.2h.7l.1.3v1.4h-.2V178l-.2-.2h-.4l-.2.2zm1-.2v-.2l.1-.2.5-.2h.3l.3.3v1.4h-.3v-1.4h-.1l-.2-.1h-.2l-.1.1-.1.2zm-2.1.8v-1.2h-.2l-.2-.1h-.2l-.1.1v.2h-.3v-.2l.1-.2.3-.1h.6l.2.2v1.1l.1.2v.2h-.3zm0-.8v.2h-.6l-.1.2v.3h.3l.4-.1v-.2l.1.2v.1l-.3.3h-.6l-.2-.2v-.5l.1-.2.3-.1zm-2.8-1.3v2.3h-.3V177zm1.4 0-1 1-.5.6v-.3l.4-.4.8-1zm-.3 2.3-.8-1.1.2-.3 1 1.4zm-2.6-.8v.3h-1.7v-.2l1-1.6h.3l-.3.5-.7 1zm-.3-1.5v2.3h-.3V177zm-1.7 2.1v.2H328v-.2l.8-.8q0-.2.2-.3l.1-.2v-.4l-.1-.2h-.5l-.2.2v.3h-.3v-.4l.3-.3h.8l.3.2v.8l-.2.2-.2.2-.6.7zm-1.9-1.1v.8l-.2.3-.2.2h-.8l-.1-.3-.1-.3v-1.2l.1-.3.3-.2h.7l.2.3v.3zm-.3.4v-1l-.2-.1-.2-.1h-.2l-.2.2v1.5l.2.2h.4v-.2l.2-.2zm-1.5.7v.2h-1.6v-.2l.8-.8.2-.3.1-.2v-.4l-.1-.2h-.5l-.2.2v.3h-.3v-.4l.3-.3h.8l.3.2v.8l-.2.2-.2.2-.6.7zm-2.8-.1v.5l-.3.3-.1-.1.1-.3v-.4zm-1.2-2v2.3h-.3v-2l-.6.3v-.3zm-3.4 1v1.3h-.3v-1.7h.3zm0 .4h-.2l.1-.4.1-.2.6-.2h.4v.3l.1.3v1.1h-.3V178l-.1-.2h-.2l-.4.2zm-1.1.7v-1.2h-.1l-.2-.1h-.2l-.2.1v.2h-.3v-.2l.2-.2.2-.1h.6l.3.2v1.3l.1.2h-.3zm0-.8.1.2h-.7l-.1.2v.2l.1.1h.2l.4-.1v-.2l.2.2v.1l-.4.3h-.6l-.2-.2v-.5l.2-.2.2-.1zm-1.9.3V177h.3v1.6l-.1.4-.3.3h-.7l-.3-.2v-.4h.2v.2l.2.2h.5l.1-.2zm57-.2h-.6v-.2h.7l.2-.2v-.4l-.2-.2h-.7v2h-.3V177h1.1l.3.1.1.2v.5l-.2.2zm0 1h-.7l.1-.2h.8l.2-.2v-.4l-.2-.1-.2-.1h-.5v-.2h.6l.4.1.2.2v.7l-.3.2zm-3.7-2.3h.3l.8 2 .8-2h.3l-1 2.4h-.2zm0 0h.2v2.4h-.3zm2 0h.3v2.4h-.4zm-3.3 0v.2l-1 2.2h-.3l1-2.1h-1.3v-.2zm-2.4 2.2.2-.1h.2v.3h-.3zm-.9-2.2v2.4h-.3v-2l-.6.2v-.2zm-2.6 2.1h.5l.2-.2.1-.3v-1.2h-.2l-.2-.1-.3.1v.2l-.1.2v.2l.1.2.1.1h.6l.1-.4h.2l-.1.2-.1.3-.3.1-.2.1h-.3l-.2-.2-.2-.3v-.6l.2-.2.2-.2h.7l.2.2.1.3v1.2l-.2.3-.4.2h-.4z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cg)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ch)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ci",
    width: 5,
    height: 5,
    x: 408,
    y: 176,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 176.3h-4.2v3.8h4.2z"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ci)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m409.1 179.6.2.3.1.1.7-1.1h-1.3v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m410.9 177.5-.7-1.1-.1.2-1.3 2v.3h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m412.3 180 .2-.1v-.2l.4-.6v-.2h-1.2l.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m410.9 177.5.6-1.1h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M411.7 178.9H410l-.7 1.1h2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m412.3 177.6-.6-1q0-.2-.2-.2l-.6 1.1.8 1.4h1.3v-.2z"
  }))))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cj)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M429.4 177h.5v.5h-.5zm0 1h.5v1.4h-.5zm.2-2.1a2.3 2.3 0 1 0 0 4.7 2.3 2.3 0 0 0 0-4.7m0 4.2a1.9 1.9 0 1 1 0-3.8 1.9 1.9 0 0 1 0 3.8"
  })))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.5 184.3v-.2H57.7v.4h381.8z",
    mask: "url(#ck)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cl)"
  }, _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "cA",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7 184.3h381.8v12.2H57.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cm)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "co",
    width: 4,
    height: 5,
    x: 60,
    y: 188,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cn"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#co)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0f9d58",
    d: "M62.4 188.5H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3v-2.4l-.6-.5z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cp",
    width: 4,
    height: 5,
    x: 60,
    y: 188,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cn"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cp)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M61.4 190.4v1.2h1.4v-1.2zm.6 1h-.4v-.2h.4zm0-.3h-.4v-.2h.4zm0-.4h-.4v-.2h.4zm.6.7h-.4v-.2h.4zm0-.3h-.4v-.2h.4zm0-.4h-.4v-.2h.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cq",
    width: 4,
    height: 5,
    x: 60,
    y: 188,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cn"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cr)",
    d: "m62.5 189.5 1 1v-1z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cs",
    width: 4,
    height: 5,
    x: 60,
    y: 188,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cn"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cs)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87ceac",
    d: "M62.4 188.5v.8l.3.3h.8z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ct",
    width: 4,
    height: 5,
    x: 60,
    y: 188,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cn"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ct)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M61 188.5q-.3 0-.3.3 0-.2.3-.2h1.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cu",
    width: 4,
    height: 5,
    x: 60,
    y: 188,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cn"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cu)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.2,
    d: "M63.2 192.3H61l-.3-.3q0 .3.3.3zq.2 0 .3-.3z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cv",
    width: 4,
    height: 5,
    x: 60,
    y: 188,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cn"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cv)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.1,
    d: "m62.7 189.6-.3-.3q0 .3.3.3h.8z"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cw)",
    d: "M62.4 188.5H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3v-2.4z"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M91 191.3h-.3l-.4-.5v-.7l.1-.3.3-.2h.6l.3.2.1.2v.6h-1.3v-.3h1v-.2l-.2-.2H91l-.3.1v.9h.2l.2.1h.2l.2-.2.2.2-.1.2h-.2zm-1.8-.3h.2l.1-.1v-.2h.5l-.1.3-.3.3H89l-.2-.2-.2-.3v-.7l.2-.3.2-.2h.7l.3.3v.3h-.3v-.2h-.2l-.2-.1h-.1l-.1.1-.1.2v.6zm-1.5 0v-1l-.1-.1h-.4v.2h-.5v-.2l.2-.2.2-.1h.7l.3.5v1.2h-.3v-.2zm0-.8v.3h-.5v.4l.1.1h.2l.2-.1v-.2l.1.2v.2l-.3.2H87l-.3-.2v-.5l.2-.2.2-.1h.7m-2.5-.4v2h-.5v-2.3h.4zm1 .5v.7l-.3.2h-.6l-.2-.2-.1-.3v-.7l.1-.3.2-.2h.6l.2.2.1.3zm-.3 0v-.2l-.1-.2h-.1l-.2-.1h-.2v.1l-.2.1v.7l.2.1.2.1.3-.2zm-1.9.3-.3-.1h-.2l-.2-.2-.2-.1v-.4l.2-.2.2-.1h.7l.2.2v.3h-.3v-.1l-.2-.1h-.3v.3h.2l.4.2.2.1v.3l-.1.4-.2.1h-.7l-.3-.3v-.2h.3v.1l.2.1h.4zm-2.2-2v2.5h-.5v-2.5zm1 .8-.7.8-.4.4-.1-.3.3-.4.4-.5zm-.4 1.7-.5-.8.3-.3.7 1.1zm-1.9-1.3v1.3h-.4v-1.7h.4zm.6-.4v.4h-.4l-.2.2v.1-.5l.2-.2zm-2.9.9v-.4l.2-.3.2-.2h.7l.3.2.1.3v.7l-.1.3-.3.2h-.7l-.2-.2-.2-.3zm.4 0v.3l.2.2h.3l.2-.2v-.8l-.3-.1-.3.1-.1.2zm-2.6.4.4-2h.3v.5l-.5 1.9H76zm-.3-2 .4 2v.4h-.3l-.6-2.3zm1.5 2 .4-2h.4l-.5 2.4h-.3zm-.4-2 .5 2v.4H77l-.5-2v-.3zm-3.4 2 .4-1.3h.2v.4l-.4 1.3h-.3zm-.2-1.3.3 1.3v.4h-.3l-.4-1.7zm1.2 1.3.3-1.3h.4l-.5 1.7h-.2zm-.3-1.3.3 1.3.1.4h-.2l-.4-1.3-.1-.4zm-2.2 1.7h-.4l-.4-.5v-.7l.1-.3.3-.2h.6l.3.2.1.2v.6h-1.3v-.3h1v-.2l-.2-.2h-.2l-.3.1v.9h.2l.2.1h.2l.2-.2.2.2-.1.2h-.2zm-1.6-1.3v1.3H70v-1.7h.4zm.6-.4v.4h-.5v.2l-.1.1h-.1v-.3l.1-.2.2-.2h.3m-1.7.9h.5l-.2.5-.3.2-.5.1h-.4l-.3-.3-.2-.3v-1.1l.2-.4.3-.2h.9l.3.3.2.5H69v-.3l-.2-.2h-.5l-.2.2v1.3l.2.1h.5l.1-.1zm-1.6.8v.3H66v-.3z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M255.2 191.6h-.3l-.4-.5v-.8l.2-.3.5-.2h.3l.2.3.2.2v.4h-1.3v-.2h1v-.2l-.2-.2h-.2l-.3.1-.1.2v.8l.2.1h.5l.2-.2.2.2-.2.1-.2.2zm-1.8-.3.5-1.5h.3l-.6 1.8h-.2zm-.4-1.5.5 1.5v.3h-.1l-.7-1.8zm-.6 0v1.8h-.3v-1.8zm-.3-.4h.3v.2h-.2zm-.4.4v.3h-1v-.3zm-.6-.4h.3v1.9h.2v.3h-.3l-.2-.2zm-.9 1.9v-1l-.2-.2h-.5v.2h-.4v-.2l.2-.1.2-.1h.6l.3.2v1.3l.1.1h-.3zm0-.8v.2h-.5l-.2.1v.1l-.1.2v.1l.1.1h.2l.4-.2v-.1l.2.1v.2l-.4.3h-.5l-.3-.2v-.6l.2-.1.2-.1zm-2.2 1h-.3l-.4-.5v-.8l.2-.3.5-.2h.3l.3.3.1.2v.4h-1.3v-.2h1v-.2l-.1-.2h-.3l-.3.1-.1.2v.6l.1.2.2.1h.4l.2-.2.2.2-.1.1-.2.2zm-1.5-1.5v1.5h-.3v-1.8h.3zm.6-.3v.3h-.4v.1l-.2.2v.1h-.1v-.2l.1-.3.2-.1zm-1.6 1h.3l-.1.4-.3.3-.5.1h-.3l-.3-.3-.2-.3v-1.2l.2-.3.3-.2h.8l.3.3.1.4h-.3v-.3l-.3-.2h-.5l-.2.2-.1.3v1.1l.3.2h.5l.2-.2z"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 187.7,
    fill: "#2f2f2f",
    rx: 2.7
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 187.7,
    stroke: "#616467",
    strokeWidth: 0.2,
    rx: 2.7
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M299.7 190.2v.8l-.2.3-.2.2h-.5l-.2-.1-.1-.2-.1-.3v-1.1l.1-.3.2-.2h.6l.3.3v.3zm-.3.4v-.9h-.1l-.1-.2h-.4v.2l-.2.2v1.2h.2v.2h.4l.1-.2.1-.2zm-1.9.7.2-.1h.1v.3h-.2zm-.4-1.1v.8l-.2.3-.2.2h-.5l-.2-.1-.1-.2-.1-.3v-1.1l.1-.3.2-.2h.6l.3.3v.3zm-.3.4v-.9h-.1l-.1-.2h-.3l-.2.2v1.4l.2.2h.3l.1-.2.1-.2zm-1.8.7.1-.1h.1v.3h-.2zm-1-2v2.2h-.2v-1.8l-.6.2v-.3zm54.8 1.7v-.2h-.2l-.2-.2h-.3l-.2-.1-.1-.2v-.2l.1-.3.2-.1h.7l.2.2v.3h-.2v-.2h-.2l-.2-.1h-.2l-.1.1v.2l.2.1.2.1.3.1.2.2v.4l-.1.2-.2.1h-.7l-.2-.3-.1-.2h.3v.2h.7zm-2.9-2h.3v2.4h-.3zm1.5 1.5v.4l-.2.3-.2.2h-.6l-.2-.2-.2-.2v-.9l.2-.2.2-.2h.6l.2.2.1.3zm-.3 0v-.2l-.1-.2-.4-.2h-.2l-.1.1-.1.2v.8l.2.1h.4l.2-.1v-.4m-2.2.8h-.3l-.4-.5v-.7q0-.3.2-.3l.5-.3.3.1.2.2.2.3v.4h-1.3v-.2h1v-.3l-.2-.1-.2-.1h-.2l-.1.1-.1.3v.7l.2.1h.5l.2-.1.2.1-.2.2h-.2zm-2.9-.7.4-1.6h.3l-.2.6-.5 1.7h-.2zm-.5-1.6.4 1.6v.7h-.2l-.5-2.3zm1.8 1.6.3-1.6h.3l-.5 2.3h-.3zm-.6-1.6.4 1.6.2.7h-.2l-.5-1.7-.1-.6zm-2.8.6v1.7h-.3v-1.7zm-.3-.5h.3v.2h-.2m-2.7.7v1.4h-.3v-1.7h.3zm0 .5h-.2v-.4l.2-.2.2-.2h.5l.3.3v1.4h-.2V190h-.2l-.2-.1h-.2l-.2.2zm1-.2v-.2l.1-.2.3-.2h.7v.3l.1.3v1.1h-.3V190h-.5l-.2.1zm-2.1.8V190h-.2l-.2-.1h-.2l-.1.1v.2h-.3v-.2l.1-.2.3-.1h.6l.2.2v1.1l.1.2v.2h-.3zm0-.7v.2h-.6l-.1.1v.4h.5l.2-.1v-.2l.1.2v.1l-.3.3h-.6l-.2-.2v-.5l.1-.2.3-.1zM333 189v2.4h-.3v-2.3zm1.4 0-1 1.2-.5.5v-.3l.4-.5.8-.8zm-.3 2.4-.8-1.1.2-.3 1 1.4zm-2.6-.8v.3h-1.7v-.2l1-1.6h.3l-.3.4-.7 1.1zm-.3-1.5v2.3h-.3v-2.3zm-1.7 2.1v.2H328v-.2l.8-.9.2-.2.1-.2v-.4l-.1-.2h-.5l-.2.2v.3h-.3v-.4l.3-.3h.8l.3.2v.8l-.2.2-.2.2-.6.7zm-1.9-1.2v.9l-.2.3-.2.2h-.6l-.2-.1-.1-.2-.1-.3v-1.2l.1-.3.3-.2h.5l.4.3v.3zm-.3.5v-1l-.2-.1-.2-.1h-.2l-.2.1v1.7h.6l.2-.3zm-1.5.7v.2h-1.6v-.2l.8-.9.2-.2.1-.2v-.4l-.1-.2h-.5l-.2.2v.3h-.3v-.4l.3-.3h.8l.3.2v.8l-.2.2-.2.2-.6.7zm-2.8-.2v.6l-.3.3-.1-.1.1-.3v-.4zm-1.2-2v2.4h-.3v-2l-.6.2v-.2zm-3.4 1v1.4h-.3v-1.7h.3zm0 .5h-.2l.1-.4.1-.2.6-.3h.2l.2.2v.2l.1.3v1.1h-.3V190h-.1l-.2-.1-.4.2-.1.2zm-1.1.6V190h-.1l-.2-.1h-.2l-.2.1v.2h-.3v-.2l.2-.2.2-.1h.6l.3.2v1.3l.1.2h-.3zm0-.7.1.2h-.7l-.1.1v.3l.1.1h.4l.2-.1v-.2l.2.2v.1l-.2.2h-.2l-.2.1h-.4l-.2-.2v-.5l.2-.2.2-.1zm-2 .3v-1.6h.3v1.6l-.1.4-.3.3h-.7l-.3-.3v-.3h.2v.2l.2.1h.5l.1-.1zm53.3-.2h-.6v-.3h.7l.2-.1v-.4l-.2-.2h-.7v2h-.3v-2.2h1.1l.2.1.2.2v.5l-.2.2zm0 1h-.8l.2-.2h.8l.2-.2v-.4l-.2-.2h-.7v-.3h.6v.1l.4.1.2.2v.7l-.4.2zm-2.7-2.2v2.3h-.3v-2.3zm1.4 0-1 1-.5.6v-.3l.4-.5.8-.8zm-.3 2.3-.8-1.1.2-.3 1 1.4zm-2.7-.3v.3H363v-.2l.8-.9.2-.2.1-.2v-.4l-.2-.2h-.4l-.2.2v.2h-.3v-.3l.3-.3h.8l.2.2.1.3v.3l-.1.2-.1.2-.2.2-.6.6zm-2.4-2.1v2.4h-.3v-2l-.6.2v-.2z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cx)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cy)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cz",
    width: 5,
    height: 5,
    x: 408,
    y: 188,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 188.5h-4.2v3.8h4.2z"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cz)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m409.1 191.7.2.4.1.1.7-1.1h-1.3v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m410.9 189.7-.7-1.1-.1.1-1.3 2.2v.2h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m412.3 192.2.2-.1v-.2l.4-.6v-.2h-1.2l.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m410.9 189.7.6-1.1h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M411.7 191H410l-.7 1.2h2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m412.3 189.8-.6-1q0-.2-.2-.2l-.6 1.1.8 1.4h1.3v-.2z"
  }))))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M429.4 189.2h.5v.5h-.5zm0 1h.5v1.4h-.5zm.2-2.1a2.3 2.3 0 1 0 0 4.7 2.3 2.3 0 0 0 0-4.7m0 4.2a1.9 1.9 0 1 1 0-3.8 1.9 1.9 0 0 1 0 3.8"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.5 196.5v-.2H57.7v.4h381.8z",
    mask: "url(#cA)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cB)"
  }, _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "cQ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7 196.5h381.8v12.2H57.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cC)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cE",
    width: 4,
    height: 5,
    x: 60,
    y: 200,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use66 || (_use66 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cD"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0f9d58",
    d: "M62.4 200.7H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3v-2.5l-.6-.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cF",
    width: 4,
    height: 5,
    x: 60,
    y: 200,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use67 || (_use67 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cD"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cF)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M61.4 202.6v1.2h1.4v-1.2zm.6 1h-.4v-.2h.4zm0-.3h-.4v-.2h.4zm0-.4h-.4v-.2h.4zm.6.7h-.4v-.2h.4zm0-.3h-.4v-.2h.4zm0-.4h-.4v-.2h.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cG",
    width: 4,
    height: 5,
    x: 60,
    y: 200,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use68 || (_use68 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cD"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cH)",
    d: "m62.5 201.7 1 1v-1z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cI",
    width: 4,
    height: 5,
    x: 60,
    y: 200,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use69 || (_use69 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cD"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87ceac",
    d: "M62.4 200.7v.8l.3.2h.8z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cJ",
    width: 4,
    height: 5,
    x: 60,
    y: 200,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use70 || (_use70 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cD"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cJ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M61 200.7q-.3 0-.3.3 0-.2.3-.3h1.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cK",
    width: 4,
    height: 5,
    x: 60,
    y: 200,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use71 || (_use71 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cD"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.2,
    d: "M63.2 204.4H61l-.3-.2q0 .3.3.3zq.2 0 .3-.3z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cL",
    width: 4,
    height: 5,
    x: 60,
    y: 200,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use72 || (_use72 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cD"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cL)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.1,
    d: "m62.7 201.7-.3-.2zh.8z"
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cM)",
    d: "M62.4 200.7H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3v-2.5z"
  }))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M102 203.5h-.4l-.5-.5v-.7q0-.2.2-.3l.3-.2h.6l.3.2v.2l.1.4v.2h-1.3v-.3h1l-.1-.3h-.1l-.2-.1h-.2v.1l-.2.2v.5l.1.1.2.2h.4l.2-.2.2.2-.1.2h-.3zm-1.9-.3h.2l.1-.3h.4v.3l-.3.2-.4.1h-.3l-.3-.2-.1-.3v-.7l.1-.3.3-.2h.7l.2.2.1.4h-.4v-.2h-.1l-.2-.1h-.2v.1l-.1.2v.6l.1.1zm-1.5-.1v-.9l-.2-.1h-.3l-.1.2h-.4v-.2l.2-.2.2-.1h.7l.3.5v1.2h-.4zm0-.7v.3h-.5l-.1.2v.2l.2.1h.2l.1-.2.2.1-.2.3-.4.1h-.3l-.2-.2v-.5l.1-.2.3-.1h.6m-2.5-.5v2.2h-.4v-2.4h.4zm1.2.6v.4l-.2.3-.2.2h-.6l-.2-.2-.1-.3-.1-.3v-.5l.2-.2.2-.2h.6l.2.2.1.2zm-.5 0v-.4h-.2l-.1-.1h-.3v.2l-.1.2v.5l.2.1h.5zm-1.8.4-.2-.2h-.2l-.3-.1-.2-.1v-.1l-.1-.2v-.2l.1-.2.3-.1h.6l.3.2v.3H95v-.1l-.1-.1h-.4v.2l.1.1h.2l.3.2.3.1v.3l-.1.4h-1l-.2-.2-.1-.3h.4v.2l.2.1h.4zm-2.4-2v2.5h-.4V201zm1.1.8-.7.8-.4.4-.2-.3.3-.4.5-.5zm-.4 1.7-.5-.8.2-.3.8 1zm-1.9-1.4v1.4H91v-1.7h.4zm.5-.4v.4h-.3l-.1.1v.2l-.1.1h-.1v-.3l.1-.3.2-.1zm-2.9.9v-.3l.2-.3.3-.2h.7l.2.2.2.3v.7l-.2.3-.2.2h-.7l-.3-.2-.1-.3zm.4 0v.3l.1.1.2.1h.4l.1-.2v-.7l-.4-.1-.3.1zm-2.7.4.5-1.8h.3v.4l-.5 1.9h-.3zm-.3-1.8.4 1.8v.5h-.3l-.5-2.3zM88 203l.3-1.8h.5l-.6 2.3H88zm-.4-1.8.4 1.9v.4l-.5-2zm-2.2 1.8-.2-.2H85l-.3-.1-.2-.1v-.1l-.1-.2v-.2q0-.2.2-.2l.2-.1h.6l.3.2v.3h-.4v-.2H85l-.1.1v.1l.2.1h.1l.4.2.2.1v.3l-.1.4h-1l-.2-.2v-.3h.3v.2l.2.1h.4zm-2 .5H83l-.4-.5v-.7l.1-.3.3-.2h.7l.2.2.1.2v.6h-1.3v-.3h1v-.3h-.2l-.2-.1h-.1l-.2.1v.8l.2.2h.4l.2-.2.2.2-.1.2h-.2zm-1.2-2.5v2.5h-.5V201zm-2.3 0h.3v2.5h-.4zm1.5 1.6v.4l-.2.3-.2.2h-.6l-.2-.2-.1-.3v-.8l.1-.2.2-.2h.6l.2.2.1.3zm-.5 0v-.4h-.2l-.1-.1h-.3v.2l-.1.2v.5l.2.1h.5zm-2 .5v-1h-.4v.2H78v-.2l.2-.2.2-.1h.7l.3.5v1.2H79zm.1-.7v.3h-.5l-.1.2v.2l.2.1h.2l.1-.2h.1l.1.1-.2.3-.4.1h-.3l-.2-.2v-.5q0-.2.2-.2l.2-.1h.6m-1.7-.4v1.4h-.5v-1.7h.4zm.5-.4v.4h-.3l-.2.1v.3h-.2v-.3l.2-.3.1-.1zm-1.9 1.7h-.4l-.5-.5v-.7q0-.2.2-.3l.2-.2h.7l.2.2.2.2v.6h-1.3v-.3h1l-.1-.3H76l-.2-.1h-.2l-.1.1v.2l-.1.2v.3l.1.1.2.2h.4l.2-.2.2.2-.2.2h-.2zm-2-.3.5-1.4h.4l-.6 1.7H74zm-.2-1.4.4 1.4v.3h-.3l-.6-1.7zm-.8 0v1.7h-.4v-1.7zm-.4-.5v-.2h.4v.4h-.4zm-.5-.3v2.5h-.4V201zm-1.4 2.5h-.4l-.4-.5v-.7l.1-.3.3-.2h.6q.2 0 .3.2l.1.2v.6H70v-.3h1v-.3h-.2l-.2-.1h-.1l-.2.1v.8l.2.2h.4l.2-.2.2.2-.1.2H71zm-2.3 0H68v-.4h.9l.2-.3v-.9l-.1-.2-.2-.1H68v-.4h1l.3.3.2.3.1.5v.5l-.6.6zm-.2-2.3v2.3h-.5v-2.3zm-.7 2.3v.3H66v-.3z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M266.6 202.4v1.4h-.3v-1.7h.2zm-.1.5h-.1v-.4l.2-.2.5-.3h.2l.2.2v.2l.1.3v1.1h-.3v-1.3l-.1-.2h-.2l-.4.2v.2zm-2.2.1v-.4l.2-.3.2-.2h.7l.2.2.2.3v.7l-.2.3-.5.2h-.4l-.4-.5zm.3 0v.2l.1.2.2.1.2.1.3-.2.1-.2v-.7l-.4-.2h-.2l-.2.2v.2zm-.8-1v1.8h-.3v-1.7zm-.3-.4h.3v.2h-.2m-.5.3v.3h-1v-.2zm-.6-.3h.3v1.8h.3v.3h-.4l-.1-.1v-2m-1.3 1.9h.2l.2-.2v-.1h.3v.2l-.7.3h-.3l-.2-.2-.2-.3v-.7l.2-.3.2-.2h.7l.2.3.1.3h-.2l-.1-.2-.1-.2h-.5l-.1.2-.1.2v.7l.2.1zm-1.4-.2v-1.3h.3v1.7h-.3zm0-.4h.1v.4l-.1.2-.2.2h-.6l-.3-.3V202h.3v1.4h.6l.2-.2zm-1.9.5v-2.2h.3v2.5h-.3zm-1.2-.5v-.4l.2-.3.2-.2h.6l.2.2.1.2.1.4v.5l-.2.2-.5.2h-.3l-.2-.2-.1-.3zm.3 0v.2l.1.2.2.1h.4l.2-.1v-1l-.4-.1h-.2l-.2.2v.4m-2.2.1v-.4l.1-.3.3-.2h.6l.3.2.1.3v.7l-.1.3-.6.2h-.3l-.3-.2-.1-.3zm.2 0v.2l.1.2.2.1.2.1.4-.2v-.2l.1-.2v-.3l-.1-.2-.4-.2h-.2l-.2.2zm-1.1-.6v1.5h-.3v-1.7h.3zm.5-.2v.2h-.3l-.1.1-.1.2v.2h-.2v-.3l.2-.2.1-.2zm-2 .8h-.7v-.3h1l.1-.2v-.4l-.1-.2h-.9v2h-.3v-2.3h1.3l.3.3v.8l-.3.2zm-1.3-.2v.2h-.7v-.2zm-1-.7v.3h-1v-.2zm-.6-.3h.3v1.8h.3v.3h-.4l-.1-.1v-2m-.9 1.6-.2-.2h-.2l-.3-.1-.2-.1-.1-.2v-.3l.1-.2.2-.1h.7l.2.2v.3h-.2v-.2h-.2l-.2-.1h-.2l-.1.1v.3h.2l.2.1.3.1.2.2v.2l-.1.4-.2.1h-.7l-.2-.3-.1-.2h.3v.2h.7zm-3-.3v-.4l.2-.3.2-.2h.7l.2.2.2.3v.7l-.2.3-.5.2h-.4l-.4-.5zm.3 0v.2l.1.2.2.1.2.1.3-.2.1-.2v-.7l-.2-.2h-.4l-.2.2v.2zm-1.4-.1h-.6v-.3h.9l.1-.2v-.4l-.1-.2h-.9v2h-.3v-2.3h1.3l.3.3.1.4-.1.4-.3.2z"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 199.9,
    fill: "#2f2f2f",
    rx: 2.7
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 199.9,
    stroke: "#616467",
    strokeWidth: 0.2,
    rx: 2.7
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M299.7 202.4v.8l-.2.3-.2.2h-.5l-.3-.3-.1-.3V202l.1-.3.2-.2h.6l.3.3v.3zm-.3.4v-.9l-.1-.1h-.5l-.2.3v1.1l.2.2h.5l.1-.3zm-1.9.7.2-.1h.1v.2h-.2m-.5-1.2v.8l-.2.3-.2.2h-.5l-.3-.3-.1-.3V202l.1-.3.2-.2h.6l.2.1v.2q.2 0 .2.3zm-.3.4v-.9l-.1-.1h-.6v1.6h.6l.1-.3zm-1.8.7.1-.1h.1v.2zm-1-2.1v2.2h-.2v-1.9l-.6.2v-.2zm54.8 1.6-.2-.2h-.2l-.3-.1-.2-.1-.1-.2v-.2l.1-.3.2-.1h.7l.2.2v.3h-.2v-.2h-.2l-.2-.1h-.2l-.1.1v.2l.2.1h.2l.3.2.2.2v.2l-.1.4h-.2l-.3.1h-.4l-.2-.3-.1-.2h.3v.2h.7zm-2.9-2h.3v2.5h-.3zm1.5 1.6v.4l-.2.3-.2.2h-.6l-.2-.2-.2-.3v-.8l.2-.3.2-.1h.6l.2.2.1.2zm-.3 0v-.2l-.1-.2-.2-.2h-.4l-.1.1-.1.2v.7l.2.2h.4l.2-.1v-.5m-2.2.9h-.3l-.4-.5v-.8l.2-.2.8-.2q.2 0 .2.2l.2.2v.5h-1.3v-.2h1v-.3l-.2-.2h-.2l-.3.1-.1.2v.8l.4.2h.3l.2-.3.2.2-.2.1-.2.2zm-2.9-.7.4-1.6h.3l-.2.6-.5 1.7h-.2zm-.5-1.6.4 1.6v.7h-.2l-.5-2.3zm1.8 1.6.3-1.6h.3l-.5 2.3h-.3zm-.6-1.6.4 1.6.2.7h-.2l-.5-1.7-.1-.6zm-2.8.6v1.7h-.3v-1.7zm-.3-.5h.3v.2h-.2zm-2.6.8v1.4h-.3v-1.7h.3zm0 .5h-.2v-.4l.2-.2.2-.2h.7l.1.3v1.4h-.2v-1.4h-.2l-.2-.1h-.2l-.2.2zm1-.2v-.2l.1-.3.5-.2h.3l.3.4v1.3h-.3v-1.3h-.1l-.2-.1h-.2l-.1.1-.1.1zm-2.1.8v-1.1h-.2l-.2-.1h-.2l-.1.1v.1h-.3v-.1l.1-.2.3-.1h.6l.2.2v1.1l.1.2v.2h-.3zm0-.8v.2h-.5l-.1.1-.1.1v.4h.3l.4-.1v-.2l.1.1v.2l-.3.3h-.6l-.2-.2v-.5l.1-.2.3-.1zm-2.8-1.3v2.3h-.3v-2.3zm1.4 0-1 1-.5.6v-.3l.4-.5.8-.8zm-.3 2.3-.8-1.1.2-.3 1 1.4zm-2.6-.8v.2h-1.7v-.1l1-1.6h.3l-.3.4-.7 1.1zm-.3-1.5v2.3h-.3v-2.3zm-1.7 2v.3H328v-.2l.8-.9.2-.2.1-.2v-.4l-.1-.2h-.5l-.2.2v.2h-.3v-.3l.3-.3h.8l.3.2v.8l-.2.2-.2.2-.6.6zm-1.9-1.1v.9l-.2.3-.2.2h-.6l-.2-.1-.1-.2-.1-.3v-1.2l.1-.4.3-.1h.7l.2.3v.2zm-.3.4v-.9l-.2-.1v-.1h-.4l-.2.1v1.7h.6l.2-.3zm-1.5.7v.3h-1.6v-.2l.8-.9.2-.2.1-.2v-.4l-.1-.2h-.5l-.2.2v.2h-.3v-.3l.3-.3h.8l.3.2v.8l-.2.2-.2.2-.6.6zm-2.8-.1v.6l-.3.3-.1-.2.1-.3v-.4zm-1.2-2v2.4h-.3v-2l-.6.2v-.2zm-3.4 1v1.4h-.3v-1.7h.3zm0 .5h-.2l.1-.4.1-.2.6-.3h.2l.2.2v.2l.1.3v1h-.3V202h-.1l-.2-.1-.4.2-.1.1zm-1.1.6V202h-.1l-.2-.1h-.2l-.2.1v.1h-.3v-.1l.2-.2.2-.1h.6l.3.2v1.3l.1.2h-.3zm0-.8.1.2h-.5l-.2.1-.1.1v.3l.1.1h.2l.4-.1v-.2l.2.1v.2l-.4.3h-.6l-.2-.2v-.5l.2-.2.2-.1h.7m-2 .4v-1.7h.3v1.6l-.1.4q0 .2-.3.2l-.3.1h-.4l-.3-.3v-.4h.2v.3l.2.1h.5l.1-.1zm53.4-.3h-.6v-.3h.8l.1-.2v-.4h-.1l-.3-.1h-.4v2h-.4v-2.3h1.1l.3.2.1.2v.5l-.2.2h-.3zm0 1h-.7l.1-.2h.8l.2-.2v-.4l-.2-.2h-.7v-.3h.6l.1.1.3.1.2.2v.7l-.3.2zm-2.6-2.3v2.4h-.4v-2.4zm1.4 0-1 1.1-.5.6-.1-.3.4-.5.8-.9zm-.3 2.4-.9-1.2.2-.2 1 1.4zm-2.8-1.4v.8l-.2.4-.2.1h-.8l-.1-.2-.1-.3v-1.3l.1-.3.3-.2h.5l.2.1.2.2v.3zm-.3.4v-.9l-.2-.2h-.4l-.2.1v1.6l.2.1h.4v-.1l.2-.3zm-1.5.7v.3h-1.6v-.3l.8-.8.2-.3.1-.2v-.4l-.1-.1h-.5l-.2.2v.2h-.3v-.3l.3-.3.5-.1h.3l.3.3v.7l-.2.2-.2.2-.6.7z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cN)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cO)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cP",
    width: 5,
    height: 5,
    x: 408,
    y: 200,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 200.7h-4.2v3.8h4.2z"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cP)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m409.1 204 .2.3.1.1.7-1.1h-1.3v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m410.9 202-.7-1.2-.1.1-1.3 2.2v.2h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m412.3 204.4.2-.1v-.2l.4-.6v-.2h-1.2l.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m410.9 202 .6-1.2h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M411.7 203.3H410l-.7 1.1h2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m412.3 202-.6-1q0-.2-.2-.2l-.6 1.1.8 1.4h1.3v-.2z"
  }))))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M429.4 201.4h.5v.5h-.5zm0 1h.5v1.4h-.5zm.2-2.2a2.3 2.3 0 1 0 0 4.7 2.3 2.3 0 0 0 0-4.7m0 4.3a1.9 1.9 0 1 1 0-3.8 1.9 1.9 0 0 1 0 3.8"
  }))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.5 208.7v-.2H57.7v.4h381.8z",
    mask: "url(#cQ)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cR)"
  }, _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "dh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7 208.7h381.8v12.2H57.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cS)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cU",
    width: 4,
    height: 5,
    x: 60,
    y: 212,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use73 || (_use73 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cT"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cU)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M62.4 213H61q-.3 0-.3.2v3.2q0 .2.3.3h2.2l.2-.3v-2.5l-.5-.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cV",
    width: 4,
    height: 5,
    x: 60,
    y: 212,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use74 || (_use74 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cT"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cV)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cW)",
    d: "m62.5 213.9 1 .9v-.9z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cX",
    width: 4,
    height: 5,
    x: 60,
    y: 212,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use75 || (_use75 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cT"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cX)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M61.4 215.6h1.4v-.1zm0 .4h1v-.2h-1zm0-1.2v.2h1.4v-.2zm0 .5h1.4v-.2h-1.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cY",
    width: 4,
    height: 5,
    x: 60,
    y: 212,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use76 || (_use76 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cT"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cY)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a1c2fa",
    d: "M62.4 213v.7q0 .2.3.2h.7z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cZ",
    width: 4,
    height: 5,
    x: 60,
    y: 212,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use77 || (_use77 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cT"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M61 213q-.3 0-.3.2 0-.3.3-.3h1.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "da",
    width: 4,
    height: 5,
    x: 60,
    y: 212,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use78 || (_use78 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cT"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#da)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    fillOpacity: 0.2,
    d: "M63.2 216.6H61l-.3-.2q0 .2.3.3zl.2-.3q0 .2-.2.2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "db",
    width: 4,
    height: 5,
    x: 60,
    y: 212,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use79 || (_use79 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cT"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#db)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    fillOpacity: 0.1,
    d: "m62.7 214-.3-.3q0 .2.3.3h.7z"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dc)",
    d: "M62.4 213H61q-.3 0-.3.2v3.2q0 .2.3.3h2.2l.2-.3v-2.5z"
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M88.6 215.7h-.4l-.4-.5v-.8l.1-.2.3-.2h.7l.2.2.1.2v.5H88v-.3h1v-.2l-.2-.1h-.2l-.3.1v.8l.2.1h.4l.2-.1.2.2-.1.1-.2.2zm-1.8-.3.1-.2v-.1h.5l-.1.3-.3.2-.3.1h-.4l-.2-.2-.2-.3v-.8l.2-.2.2-.2h.7l.3.2v.4H87v-.2l-.2-.1h-.3l-.1.1v.2l-.1.2v.4l.2.1zm-1.6-.1v-.9l-.1-.1h-.4v.2h-.5v-.2l.2-.2.2-.1h.7l.3.5v1.2h-.3v-.2zm0-.7v.3h-.5v.4h.5v-.2l.1.2v.1l-.3.3h-.5l-.2-.2-.1-.3v-.2l.2-.2.2-.1h.7m-2.5-.4v2h-.4V214h.3zm1 .5v.7l-.3.1-.3.1H83l-.2-.2v-.3l-.2-.3v-.1l.1-.4.1-.2.2-.2h.6l.2.2.2.2zm-.3 0v-.2l-.1-.2-.1-.1h-.4l-.1.2v.7l.1.1h.5zm-1.8.4-.2-.2h-.2l-.2-.1-.2-.1-.2-.2v-.4l.2-.1.2-.1h.7l.2.2v.3h-.3v-.2H81v.3h.2l.4.2.2.1.1.3-.2.4h-.2l-.3.1h-.4l-.3-.3v-.3h.3l.1.2h.5m-2.1-2.1v2.5h-.4v-2.5zm1 .7-.7.9-.4.4-.1-.3.3-.4.5-.6zm-.4 1.8-.5-.8.3-.3.7 1zm-1.9-1.4v1.4h-.4v-1.8h.4zm.6-.4v.4h-.4v.1l-.2.1v.2-.6l.2-.1zm-2.9.9v-.4l.2-.2.2-.2h.7q.2 0 .3.2l.1.2v.8l-.1.3-.3.1-.3.1H76l-.2-.2-.2-.3zm.4 0v.4l.2.1h.4l.1-.3v-.6l-.3-.2-.3.2v.2zm-2.6.4.4-1.9h.3v.4l-.5 2h-.3zm-.3-1.9.4 2v.4h-.3l-.6-2.4zm1.5 2 .4-2h.4l-.5 2.4h-.3zm-.4-2 .5 2v.4h-.3l-.5-2v-.4zm-2.5 0v2.4h-.4v-2.4zm.7 0v.4h-1.8v-.4zm-2.2 0v2.4H70v-2.4zm-1.9 2.4h-.5v-.4h.8l.2-.3.1-.4v-.5l-.1-.2-.2-.2h-.8v-.4h.5l.4.1.6.6v1a1 1 0 0 1-1 .7m-.3-2.4v2.4h-.4v-2.4zm-.7 2.4v.3H66v-.3z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M258.8 214.6v1.4h-.3v-1.7h.3zm-.1.5h-.1v-.4l.2-.2.5-.3h.2l.2.2.1.2v1.3h-.3v-1.3h-.1l-.2-.1-.4.2zm-2.2 0v-.3l.2-.3.2-.2h.4l.5.2.2.3v.7l-.2.3-.2.2h-.7l-.2-.2-.2-.3zm.3 0v.3l.1.2.2.1h.4l.1-.1.1-.2v-.7l-.2-.2h-.4l-.2.2v.2zm-.8-.8v1.7h-.3v-1.7zm-.3-.5h.3v.2h-.2zm-.4.5v.2h-.9v-.2zm-.6-.5h.3v1.9h.3v.3h-.4l-.1-.2v-2m-1.3 2 .4-.2v-.2h.3v.3l-.3.2-.4.1h-.3l-.2-.2-.2-.3v-.7l.2-.3.2-.2h.7l.2.2.1.4h-.2l-.1-.2-.1-.2h-.5l-.1.2-.1.2v.7l.2.1zm-1.5-.2v-1.3h.4v1.7h-.3zm.1-.4v.3l-.1.3-.2.2h-.6l-.1-.1-.2-.2v-1.4h.3v1.4h.6l.2-.2zm-1.9.5v-2.2h.3v2.5h-.3zm-1.2-.6v-.3l.2-.3.5-.3h.3l.2.3.2.2v.8l-.2.3-.2.2h-.6l-.2-.2-.1-.3zm.3 0v.3l.1.2.2.1h.2l.4-.2v-.9h-.2l-.2-.1-.4.2zm-2.3 0v-.3l.2-.3.3-.2h.6l.3.2.1.3.1.3v.4l-.2.3-.3.2h-.6l-.3-.2-.1-.3zm.3 0v.3l.1.2.2.1h.4l.2-.1v-.2l.1-.3v-.2l-.1-.2-.4-.2h-.2l-.2.2zm-1.1-.6v1.5h-.3v-1.7h.3zm.5-.2v.2h-.3l-.2.3v.1h-.2v-.2l.2-.2.1-.2zm-2 .7h-.6v-.2h.9l.1-.2v-.4l-.1-.2h-.9v2h-.3v-2.3h1.3l.3.3.1.4-.1.4-.3.2z"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 212.1,
    fill: "#2f2f2f",
    rx: 2.7
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 212.1,
    stroke: "#616467",
    strokeWidth: 0.2,
    rx: 2.7
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M299.7 214.6v.8l-.2.3-.2.1h-.7l-.1-.2-.1-.3v-1.1l.1-.3.2-.2h.6l.3.3v.2zm-.3.4v-.9l-.1-.1h-.5l-.2.3v1.1l.2.2h.5l.1-.3zm-1.9.7h.3v.2h-.2m-.5-1.3v.8l-.2.3-.2.1h-.7l-.1-.2-.1-.3v-1.1l.1-.3.2-.2h.6l.3.3v.2zm-.3.4v-.9l-.1-.1h-.1l-.2-.1h-.1l-.2.1v1.6h.6l.1-.3zm-1.8.7h.2v.2h-.2m-1-2.2v2.2h-.2V214l-.6.2v-.2zm54.8 1.6-.2-.1h-.2l-.3-.2h-.2l-.1-.2v-.2l.1-.3.2-.1h.7l.2.2v.3h-.2v-.2l-.2-.1h-.5v.3l.2.1h.2l.3.2.2.2v.4l-.1.2h-.2l-.3.1h-.4l-.2-.3-.1-.3h.3v.2l.2.1h.5zm-2.9-2h.3v2.5h-.3zm1.5 1.6v.4l-.2.3-.2.1-.3.1h-.3l-.2-.2-.2-.3v-.8l.2-.3.2-.1h.6l.2.2.1.2zm-.3 0v-.2l-.1-.2-.4-.2h-.2l-.1.1-.1.2v.7l.2.2h.4l.2-.1v-.5m-2.2.9h-.3l-.4-.5v-.8l.2-.3.5-.2h.3l.2.3.2.2v.4h-1.3v-.1h1v-.3l-.2-.2h-.4l-.1.1-.1.2v.8l.2.1h.5l.2-.2.2.2-.2.1-.2.2zm-2.9-.8.4-1.6h.3l-.2.7-.5 1.7h-.2zm-.5-1.6.4 1.6v.8h-.2l-.5-2.4zm1.8 1.6.3-1.6h.3l-.5 2.4h-.3zm-.6-1.6.4 1.7.2.7h-.2l-.5-1.7-.1-.7zm-2.8.6v1.8h-.3V214zm-.3-.4h.3v.2h-.2zm-2.6.8v1.4h-.3V214h.3zm0 .4h-.2v-.3l.2-.3.2-.1h.5l.3.2v1.5h-.2v-1.4l-.2-.1h-.4l-.2.1zm1-.1v-.2l.1-.3.3-.1h.7v.3l.1.2v1.2h-.3v-1.4l-.1-.1h-.4l-.2.2zm-2.1.8v-1l-.2-.2h-.5v.2h-.3v-.2l.1-.1.3-.1h.6l.2.2v1.1l.1.2v.2h-.3zm0-.8v.2h-.5l-.1.1-.1.1v.4h.5l.2-.1v-.2l.1.1v.2l-.3.3h-.6l-.2-.2v-.5l.1-.2.3-.1zm-2.8-1.4v2.4h-.3v-2.4zm1.4 0-1 1.1-.5.6v-.3l.4-.5.8-.9zm-.3 2.4-.8-1.2.2-.2 1 1.4zm-2.6-.8v.2h-1.7v-.1l1-1.7h.3l-.3.5-.7 1zm-.3-1.6v2.4h-.3v-2.4zm-1.7 2.1v.3H328v-.2l.8-.9.2-.3.1-.1v-.4l-.1-.2h-.5l-.2.2v.2h-.3v-.3l.3-.3h.8l.3.2v.8q-.2 0-.2.2l-.2.2-.6.6zm-1.9-1.1v.9l-.2.3-.2.2h-.6l-.2-.1-.1-.2-.1-.3v-1.3l.1-.3.3-.1h.5l.4.2v.3zm-.3.4v-.9l-.2-.1v-.1h-.4l-.2.1v1.7h.6v-.1l.2-.2zm-1.5.7v.3h-1.6v-.2l.8-.9.2-.3.1-.1v-.4l-.1-.2h-.5l-.2.2v.2h-.3v-.3l.3-.3h.8l.3.2v.8q-.2 0-.2.2l-.2.2-.6.6zm-2.8-.1v.6l-.3.2h-.1l.1-.4v-.4zm-1.2-2v2.4h-.3v-2l-.6.2v-.2zm-3.4 1v1.4h-.3V214h.3zm0 .4h-.2l.1-.3.1-.3.6-.2h.2l.2.2v.2l.1.2v1.2h-.3v-1.4l-.1-.1h-.2l-.4.1-.1.2zm-1.1.7v-1l-.1-.2h-.6v.2h-.3v-.2l.2-.1.2-.1h.6l.3.2v1.3l.1.2h-.3zm0-.8.1.2h-.5l-.2.1-.1.1v.3l.1.1h.4l.2-.1v-.2l.2.1v.2l-.2.1-.2.2h-.6l-.2-.2v-.5l.2-.2.2-.1zm-2 .3v-1.7h.3v1.7l-.1.4-.3.2-.3.1h-.4l-.3-.3v-.4h.2v.3l.2.1h.5l.1-.1zm53.3-.3h-.6v-.2h.7l.2-.2v-.4l-.2-.1h-.7v2h-.3v-2.3h1.1l.2.2.2.1v.6l-.2.2zm0 1.1h-.8l.2-.2h.8l.2-.2v-.5l-.2-.1h-.7v-.3h.6l.4.2.2.2v.6l-.4.3zm-2.7-2.3v2.3h-.3v-2.3zm1.4 0-1 1-.5.7v-.4l.4-.4.8-.9zm-.3 2.3-.8-1.1.2-.2 1 1.3zm-3.8-1.1h-.3l.2-1.2h1.2v.3h-1v.6h.6l.2.1.2.3v.6l-.2.3-.2.1h-.8l-.2-.3v-.3h.2l.1.2.2.2h.4l.1-.1.1-.2v-.6h-.2l-.2-.1h-.3zm-1.3-1.2v2.3h-.3v-2l-.6.3v-.3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#de)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "df",
    width: 5,
    height: 5,
    x: 408,
    y: 212,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 213h-4.2v3.7h4.2z"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#df)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m409.1 216.1.2.3.1.2.7-1.1h-1.3v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m410.9 214.1-.7-1.1-.1.1-1.3 2.1v.3h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m412.3 216.6.2-.2.4-.7v-.2h-1.2l.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m410.9 214.1.6-1.1h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M411.7 215.5H410l-.7 1.1h2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m412.3 214.2-.6-1q0-.2-.2-.2l-.6 1.1.8 1.4h1.3v-.3z"
  }))))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dg)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M429.4 213.6h.5v.5h-.5zm0 1h.5v1.4h-.5zm.2-2.2a2.3 2.3 0 1 0 0 4.7 2.3 2.3 0 0 0 0-4.7m0 4.3a1.9 1.9 0 1 1 0-3.8 1.9 1.9 0 0 1 0 3.8"
  })))), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.5 220.9v-.3H57.7v.5h381.8z",
    mask: "url(#dh)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#di)"
  }, _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    id: "dy",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7 220.9h381.8V233H57.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dj)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dl",
    width: 4,
    height: 4,
    x: 60,
    y: 225,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use80 || (_use80 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dk"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dl)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M62.4 225H61q-.3 0-.3.3v3.3q0 .2.3.2h2.2q.2 0 .2-.2V226l-.5-.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dm",
    width: 4,
    height: 4,
    x: 60,
    y: 225,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use81 || (_use81 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dk"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dm)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dn)",
    d: "m62.5 226 1 1v-.9z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "do",
    width: 4,
    height: 4,
    x: 60,
    y: 225,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use82 || (_use82 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dk"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#do)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M61.4 227.8h1.4v-.1zm0 .4h1v-.2h-1zm0-1.2v.1h1.4v-.1zm0 .5h1.4v-.2h-1.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dp",
    width: 4,
    height: 4,
    x: 60,
    y: 225,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use83 || (_use83 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dk"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dp)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a1c2fa",
    d: "M62.4 225v.9q0 .2.3.2h.7z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dq",
    width: 4,
    height: 4,
    x: 60,
    y: 225,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use84 || (_use84 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dk"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M61 225q-.3 0-.3.3l.3-.2h1.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dr",
    width: 4,
    height: 4,
    x: 60,
    y: 225,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use85 || (_use85 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dk"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dr)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    fillOpacity: 0.2,
    d: "M63.2 228.8H61l-.3-.2q0 .2.3.2zq.2 0 .2-.2 0 .2-.2.2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ds",
    width: 4,
    height: 4,
    x: 60,
    y: 225,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use86 || (_use86 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dk"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ds)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    fillOpacity: 0.1,
    d: "m62.7 226.1-.3-.2q0 .2.3.2h.7z"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dt)",
    d: "M62.4 225H61q-.3 0-.3.3v3.3q0 .2.3.2h2.2q.2 0 .2-.2V226z"
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M92.2 227.9H92l-.5-.5v-.8l.2-.3.3-.1.3-.1h.3l.3.2v.3l.1.4v.1h-1.3v-.3h1l-.1-.2-.1-.1H92l-.2.3v.5l.1.1.2.1h.4l.2-.1.2.2-.1.1-.3.2zm-1.8-.3h.2l.1-.3h.4v.3l-.3.2-.4.1h-.3l-.3-.3-.1-.2v-.8l.1-.2.3-.2.3-.1h.4l.2.3.1.4h-.4v-.2l-.1-.1h-.4v.1l-.1.2v.6l.1.1zm-1.5-.1v-1h-.5l-.1.1h-.4v-.2l.2-.1.2-.2h.7l.3.6v1.1H89zm0-.7v.3h-.5l-.1.1v.3h.5v-.2l.2.2-.2.3-.4.1h-.3l-.2-.3v-.5l.1-.1.3-.2zm-2.6-.3v2H86v-2.4h.4zm1.2.5v.4l-.2.2-.2.2-.3.1h-.3l-.2-.2-.1-.3-.1-.3v-.5l.2-.3.2-.1.3-.1h.3l.2.2.1.3zm-.5 0v-.4l-.2-.1h-.4v.2l-.1.2v.5l.2.1h.3l.2-.1zm-1.9.4-.3-.2h-.3l-.2-.1v-.2l-.1-.2v-.2l.1-.1.3-.2h.6l.3.3v.3h-.4v-.2H85l-.2-.1h-.1l-.1.1v.2h.1l.2.1.4.1.2.2v.3l-.1.3-.3.2h-.7l-.2-.3v-.3h.3v.2h.2l.2.1h.1zm-2.2-2v2.5h-.5v-2.5zm1 .7-.7.9-.4.4-.2-.3.3-.4.5-.6zm-.4 1.8-.5-.8.2-.3.8 1zm-1.9-1.4v1.4h-.4V226h.4zm.5-.4v.4h-.3l-.1.1v.1l-.1.2h-.1v-.3l.1-.3.2-.1zm-2.9.9v-.4l.2-.2.3-.2.3-.1h.4l.2.3.2.2v.8l-.2.2-.2.2-.4.1h-.3l-.3-.3-.1-.2zm.4 0v.2l.1.2.2.1h.4l.1-.3v-.6a.3.3 0 0 0-.4-.2l-.3.2zm-2.7.4.5-1.9h.3v.4l-.5 2H77zm-.3-1.9.4 2v.4zm1.5 2 .4-2h.5l-.6 2.4h-.3zm-.3-2 .4 2v.4H78l-.5-2v-.4zm-2.3 1v1.4h-.4V226h.4zm.6-.4v.4h-.4l-.1.1v.1l-.1.2h-.1v-.3l.1-.3.2-.1.2-.1zm-3 .9v-.4l.2-.2.3-.2.3-.1h.4l.2.3.2.2v.8l-.2.2-.2.2-.4.1h-.3l-.3-.3-.1-.2zm.5 0v.4l.2.1h.4l.1-.3v-.6a.3.3 0 0 0-.4-.2l-.3.2zm-.7-.9v.3h-1v-.3zm-.7-.4h.4v1.7l.1.1h.2v.4h-.5l-.1-.2-.1-.3zm-.5.4v1.8h-.5V226zm-.5-.4v-.2h.4v.3l-.1.1h-.2zm-.8 1.8v-2h.4v2.4h-.4zm-1.1-.5v-.4l.1-.3.5-.2.5.2.1.3.1.4v.4l-.2.3-.2.1-.3.1h-.3l-.2-.3-.1-.2zm.4 0v.4l.2.1h.3l.2-.1v-.8l-.2-.1H70l-.2.1-.1.2zm-.7.5v.4h-1v-.4zm-1-2v2.4h-.5v-2.4zm.9 1v.3h-1v-.3zm.1-1v.4h-1v-.4zm-1.8 2.4v.3H66v-.3z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M266.6 226.8v1.4h-.3v-1.8h.2zm-.1.4h-.1v-.3l.2-.2.5-.3h.2l.2.2v.2l.1.2v1.2h-.3v-1.4h-.1l-.2-.1-.4.1v.2zm-2.2.1v-.3q0-.3.2-.3l.2-.2h.7l.2.2q.2 0 .2.3v.7l-.2.3-.5.2h-.4l-.4-.5zm.3 0v.3l.1.2.2.1h.2l.3-.1.1-.2v-.7l-.4-.2h-.2q-.2 0-.2.2v.2zm-.8-.9v1.8h-.3v-1.8zm-.3-.4h.3v.2h-.2zm-.4.4v.3h-1v-.3zm-.6-.4h.3v1.8l.1.1h.2v.3h-.4l-.1-.2v-2m-1.3 2h.2l.2-.2v-.2h.3v.3l-.7.3h-.3l-.2-.2-.2-.3v-.7q0-.2.2-.3l.2-.2h.7l.2.2.1.3h-.2l-.1-.1-.1-.2h-.5l-.1.2-.1.2v.7l.2.1zm-1.4-.2v-1.4h.3v1.8h-.3zm0-.4h.1v.3l-.1.3-.2.2h-.6l-.3-.3v-1.5h.3v1.4l.2.1h.4l.2-.2zm-1.9.4v-2h.3v2.4h-.3zm-1.2-.5v-.4l.2-.2.2-.2h.6l.2.1.1.3.1.3v.5l-.2.3-.5.2h-.3l-.2-.2-.1-.3zm.3 0v.3l.1.2.2.1h.4l.2-.2v-.9l-.4-.1h-.2l-.2.2v.4m-2.2 0v-.3l.1-.3.3-.2h.6q.2 0 .3.2l.1.3v.7l-.1.3-.6.2h-.3l-.3-.2-.1-.3zm.2 0v.3l.1.2.2.1h.2l.4-.1v-.2l.1-.3v-.2l-.1-.2-.4-.2h-.2l-.2.2zm-1.1-.6v1.5h-.3v-1.8h.3zm.5-.3v.3h-.3l-.1.1-.1.2v.1h-.2v-.2l.2-.3.1-.1zm-2 .9h-.7v-.3h1l.1-.2v-.5l-.1-.1-.3-.1h-.6v2h-.3V226h1.3l.3.3v.7q0 .2-.3.3zm-1.3-.3v.3h-.7v-.2zm-1-.6v.3h-1v-.3zm-.6-.4h.3v1.8l.1.1h.2v.3h-.4l-.1-.2zm-.9 1.7-.2-.1h-.2l-.3-.1-.2-.2h-.1v-.5l.1-.1.2-.1h.7l.2.2v.3h-.2v-.2h-.2l-.2-.1h-.3v.3l.2.1h.2l.3.2.2.2v.2l-.1.4h-.2l-.3.1h-.4l-.2-.3-.1-.3h.3v.2l.2.1h.5zm-3-.4v-.3q0-.3.2-.3l.2-.2h.7l.2.2q.2 0 .2.3v.7l-.2.3-.5.2h-.4l-.4-.5zm.3 0v.3l.1.2.2.1h.2l.3-.1.1-.2v-.7l-.2-.2h-.4q-.2 0-.2.2v.2zm-1.4 0h-.6v-.3h.9l.1-.2v-.5l-.1-.1-.3-.1h-.6v2h-.3V226h1.3l.3.3.1.4-.1.3q0 .2-.3.3z"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 224.3,
    fill: "#2f2f2f",
    rx: 2.7
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 224.3,
    stroke: "#616467",
    strokeWidth: 0.2,
    rx: 2.7
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M299.7 226.8v.8l-.2.3-.2.1h-.5l-.3-.2-.1-.3v-1.2l.1-.2.2-.2h.6l.3.3v.2zm-.3.4v-.9l-.1-.1-.1-.1h-.4v.1l-.2.2v1.2l.2.2h.4l.1-.1.1-.2zm-1.9.8v-.2h.3v.2zm-.4-1.2v.8l-.2.3-.2.1h-.5l-.3-.2-.1-.3v-1.2l.1-.2.2-.2h.8v.3l.2.2zm-.3.4v-.9l-.1-.1-.1-.1h-.3l-.2.1v1.6h.5l.1-.1.1-.2zm-1.8.8v-.2h.2v.2zm-1-2.1v2.2h-.2v-1.9l-.6.2v-.2zm54.8 1.6-.2-.1h-.2l-.3-.2h-.2l-.1-.2v-.2l.1-.3.2-.2h.7l.2.3v.2h-.2v-.1l-.2-.1h-.5v.3l.2.1h.2l.3.2.2.1v.3l-.1.4h-.2l-.3.1h-.4l-.2-.3-.1-.3h.3v.2l.2.1h.5zm-2.9-2h.3v2.5h-.3zm1.5 1.6v.4l-.2.2-.2.2-.3.1h-.3l-.2-.2-.2-.3v-.8l.2-.3.2-.1.3-.1h.3l.2.2.1.3zm-.3 0v-.3l-.1-.2-.2-.1h-.5l-.1.2v.8l.2.2h.4l.2-.1v-.5m-2.2.9h-.3l-.4-.5v-.8l.2-.3.8-.1.2.1.2.3v.5h-1.3v-.3h1v-.2l-.2-.2h-.2l-.3.1-.1.2v.8l.4.2.3-.1.2-.2.2.2-.2.1-.2.1zm-2.9-.7.4-1.7h.3l-.2.7-.5 1.7h-.2zm-.5-1.7.4 1.6v.8h-.2l-.5-2.4zm1.8 1.6.3-1.6h.3l-.5 2.4h-.3zm-.6-1.6.4 1.7.2.7h-.2l-.5-1.7-.1-.7zm-2.8.6v1.8h-.3v-1.8zm-.3-.4v-.2h.3v.2l-.1.1zm-2.6.8v1.4h-.3v-1.8h.3zm0 .4h-.2v-.3l.2-.3.2-.1.3-.1h.2l.2.1.1.2v1.5h-.2v-1.4l-.2-.1h-.4l-.2.1zm1-.1v-.2l.1-.3.5-.2h.3l.3.3v1.5h-.3v-1.4l-.1-.1h-.5l-.1.2zm-2.1.8v-1.1l-.2-.1h-.5v.2h-.3v-.2l.1-.1.3-.2h.6l.2.3v1.1l.1.2v.1h-.3zm0-.8v.2h-.5l-.1.1-.1.1v.4h.3l.4-.2v-.1l.1.1v.2l-.3.3h-.6l-.2-.3v-.5l.1-.1.3-.1zm-2.8-1.4v2.4h-.3v-2.4zm1.4 0-1 1.1-.5.6v-.3l.4-.5.8-.9zm-.3 2.4-.8-1.2.2-.2 1 1.4zm-2.6-.8v.2h-1.7v-.2l1-1.6h.3l-.3.5-.7 1zm-.3-1.6v2.4h-.3v-2.4zm-1.7 2.1v.3H328v-.2l.8-.9.2-.3.1-.2v-.3l-.1-.2h-.5l-.2.2v.2h-.3v-.3l.3-.3.4-.1h.4l.3.3v.7l-.2.2-.2.2-.6.7zm-1.9-1.1v.9l-.2.3-.2.1-.3.1h-.3l-.2-.1-.1-.2-.1-.3V226l.1-.3.3-.1.3-.1h.2l.2.1.2.2v.3zm-.3.4v-.9l-.2-.2h-.4l-.2.1v1.6l.2.1h.4v-.1l.2-.2zm-1.5.7v.3h-1.6v-.2l.8-.9.2-.3.1-.2v-.3l-.1-.2h-.5l-.2.2v.2h-.3v-.3l.3-.3.5-.1h.3l.3.3v.7l-.2.2-.2.2-.6.7zm-2.8-.1v.6l-.3.2h-.1l.1-.4v-.4zm-1.2-2v2.4h-.3v-2l-.6.2v-.3zm-3.4 1v1.4h-.3v-1.8h.3zm0 .4h-.2l.1-.3.1-.3.6-.2h.2l.2.1v.2l.1.3v1.2h-.3v-1.4l-.1-.1h-.2l-.4.1-.1.2zm-1.1.7v-1.1l-.1-.1h-.6v.2h-.3v-.2l.2-.1.2-.2h.6l.3.3v1.3l.1.1h-.3zm0-.8.1.2h-.5l-.2.1-.1.1v.3l.1.1h.2l.4-.2v-.1l.2.1v.2l-.4.3h-.6l-.2-.3v-.5l.2-.1.2-.1zm-1.9.3v-1.7h.3v1.7l-.1.4-.3.2-.3.1h-.4l-.3-.3v-.4h.2v.3l.2.1h.5l.1-.2zm53.3-.3h-.6v-.2h.7l.2-.2v-.4h-.2l-.2-.1h-.5v2h-.3v-2.3h1.1l.2.2q.2 0 .2.2v.5l-.2.2zm0 1.2h-.8l.2-.3h.8l.2-.2v-.4l-.2-.2h-.7v-.3h.6v.1l.4.1.2.2v.6l-.4.3zm-2.7-2.4v2.4h-.3v-2.4zm1.4 0-1 1.1-.5.6v-.4l.4-.4.8-.9zm-.3 2.4-.8-1.2.2-.2 1 1.4zm-2.7-.2v.2H363v-.3l.8-.8.2-.3.1-.2v-.4l-.2-.1h-.4q-.2 0-.2.2v.2h-.3v-.4l.3-.2.4-.1h.4l.2.3.1.3v.2l-.1.2-.1.2-.2.2-.6.7zm-2.4-2.2v2.4h-.3v-2l-.6.2v-.3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#du)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dv)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dw",
    width: 5,
    height: 4,
    x: 408,
    y: 225,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 225h-4.2v3.8h4.2z"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dw)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m409.1 228.3.2.3.1.2.7-1.2h-1.3v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m410.9 226.3-.7-1.1-.1.1-1.3 2.1v.2h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m412.3 228.8.2-.2v-.1l.4-.6v-.3h-1.2l.2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m410.9 226.3.6-1.1-.2-.1h-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M411.7 227.6H410l-.7 1.2h2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m412.3 226.4-.6-1q0-.2-.2-.2l-.6 1.1.8 1.3h1.3v-.2z"
  }))))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dx)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M429.4 225.8h.5v.5h-.5zm0 1h.5v1.3h-.5zm.2-2.2a2.3 2.3 0 1 0 0 4.7 2.3 2.3 0 0 0 0-4.7m0 4.2a1.9 1.9 0 1 1 0-3.7 1.9 1.9 0 0 1 0 3.7"
  })))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.5 233v-.2H57.7v.5h381.8z",
    mask: "url(#dy)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dz)"
  }, _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", {
    id: "dP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7 233h381.8v12.3H57.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dA)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dC",
    width: 4,
    height: 5,
    x: 60,
    y: 237,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use87 || (_use87 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dB"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0f9d58",
    d: "M62.4 237.3H61q-.3 0-.3.2v3.3q0 .2.3.2h2.2q.2 0 .3-.2v-2.5l-.6-.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dD",
    width: 4,
    height: 5,
    x: 60,
    y: 237,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use88 || (_use88 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dB"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dD)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M61.4 239.1v1.2h1.4v-1.2zm.6 1h-.4v-.1zm0-.3h-.4v-.2h.4zm0-.3h-.4v-.2h.4zm.6.7h-.4v-.2h.4zm0-.4h-.4v-.2h.4zm0-.3h-.4v-.2h.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dE",
    width: 4,
    height: 5,
    x: 60,
    y: 237,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use89 || (_use89 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dB"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dF)",
    d: "m62.5 238.2 1 1v-.9z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dG",
    width: 4,
    height: 5,
    x: 60,
    y: 237,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use90 || (_use90 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dB"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87ceac",
    d: "M62.4 237.3v.7q0 .3.3.3h.8z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dH",
    width: 4,
    height: 5,
    x: 60,
    y: 237,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use91 || (_use91 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dB"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dH)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M61 237.3q-.3 0-.3.2zh1.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dI",
    width: 4,
    height: 5,
    x: 60,
    y: 237,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use92 || (_use92 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dB"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.2,
    d: "M63.2 241H61l-.3-.2q0 .2.3.2zq.2 0 .3-.2z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dJ",
    width: 4,
    height: 5,
    x: 60,
    y: 237,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use93 || (_use93 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dB"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dJ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.1,
    d: "m62.7 238.3-.3-.3q0 .3.3.3h.8z"
  }))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dK)",
    d: "M62.4 237.3H61q-.3 0-.3.2v3.3q0 .2.3.2h2.2q.2 0 .3-.2v-2.5z"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M90.5 240h-.3l-.5-.4v-.8l.2-.3.3-.1.3-.1h.3l.2.2.2.3v.5H90v-.3h1l-.1-.2-.1-.1h-.5v.9l.2.1h.4l.2-.2.2.3-.2.1-.2.1zm-1.8-.2h.2v-.2l.1-.1h.4v.3l-.3.2h-.7l-.3-.2-.1-.2v-.8l.1-.3.3-.1.3-.1h.4l.2.3.1.4H89v-.2l-.1-.1h-.4l-.1.3v.6l.1.1zm-1.5-.1v-1H87l-.1-.1h-.2v.1l-.1.1h-.4v-.2l.2-.1.2-.2h.6l.4.6v1.1h-.4zm0-.7v.3h-.6v.4h.4l.1-.1v-.1l.2.2v.1l-.4.2h-.5l-.2-.2v-.5l.1-.2h.3l.3-.1zm-2.5-.3v2h-.4v-2.4h.4zm1.1.5v.4l-.1.2-.2.2h-.6l-.2-.2-.1-.2-.1-.3v-.5l.2-.3.2-.1.3-.1h.3l.2.2.1.3zm-.4 0v-.4l-.2-.1h-.4v.2l-.1.2v.4l.2.2h.2l.2-.1.1-.2zm-1.9.4-.1-.1h-.2l-.3-.1-.2-.1-.1-.2v-.4l.1-.2h.2l.3-.1h.4l.3.3v.2h-.4l-.1-.2H83l-.1.1v.2h.1l.2.1.3.1.3.2v.3l-.1.3-.3.1h-.7l-.2-.2-.1-.3h.4v.2h.6zm-2.3-2v2.5h-.4v-2.5zm1.1.7-.7.9-.4.4-.2-.3.3-.4.5-.6zm-.4 1.8-.5-.9.2-.2.8 1zm-1.9-1.4v1.4h-.4v-1.8h.4zm.5-.4v.4h-.4l-.1.2v.2h-.1v-.3l.1-.3.2-.2zm-2.9.9v-.4l.2-.3.3-.1.3-.1h.4l.2.2.2.3v.8l-.2.2-.2.2H78l-.3-.2-.1-.2zm.4 0v.2l.1.2.1.1h.4l.1-.1.1-.2v-.6a.3.3 0 0 0-.4-.2l-.3.2zm-2.7.4.5-1.9h.2v.4l-.4 2h-.3zm-.3-1.9.4 1.9v.5h-.3l-.5-2.4zm1.5 1.9.4-1.9h.5l-.6 2.4h-.3zm-.3-1.9.4 2v.4h-.2l-.5-2v-.4zm-2.3 1v1.4h-.4v-1.8h.4zm.5-.4v.4H74v.2l-.1.2h-.1v-.3l.1-.3.2-.2zm-1.7 1.4v-1h-.2l-.1-.1h-.2v.1l-.1.1h-.4v-.2l.2-.1.2-.2h.6l.4.6v1.1h-.4zm0-.7v.3h-.6v.4h.4l.1-.1v-.1l.2.2v.1l-.4.2H72l-.2-.2v-.5l.1-.2h.3l.3-.1zm-2 1h-.4l-.4-.4v-.8l.1-.3.3-.1.3-.1h.3l.3.2.1.3v.5H70v-.3h1v-.2l-.2-.1h-.5v.9l.2.1h.4q.2 0 .2-.2l.2.3-.1.1-.2.1zm-1.2-1.2v1l-.2.1-.3.1h-.8l-.3-.2-.2-.4-.1-.4v-.7l.2-.3.4-.2.4-.1h.4q.3.2.3.4l.2.3H69v-.2l-.2-.1h-.5l-.1.1-.1.3v1l.3.2h.6v-.5h-.4v-.4zm-2.1 1.2v.4H66v-.3z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M258.8 239v1.4h-.3v-1.8h.3zm-.1.4h-.1v-.3l.2-.3.5-.2h.2l.2.1.1.2v1.5h-.3V239l-.1-.1h-.2l-.4.1zm-2.2.1v-.4l.2-.2.2-.2.4-.1.5.3.2.2v.8l-.2.3-.2.1-.3.1h-.4l-.2-.2-.2-.3zm.3 0v.3l.1.2.2.1h.4l.1-.1.1-.2v-.8l-.2-.1h-.4l-.2.1v.2zm-.8-.9v1.8h-.3v-1.8zm-.3-.4h.3v.2h-.2zm-.4.4v.3h-.9v-.3zm-.6-.4h.3v1.9h.3v.3h-.4l-.1-.2v-2m-1.3 2 .4-.2v-.2h.3v.3l-.3.2-.4.1h-.3l-.2-.3-.2-.2v-.8l.2-.2.2-.2.3-.1h.4l.2.3.1.3h-.2l-.1-.2-.1-.1h-.5l-.1.1-.1.2v.8l.2.1zm-1.5-.2v-1.4h.4v1.8h-.3zm.1-.4v.3l-.1.3-.2.1-.3.1h-.3l-.1-.1-.2-.2v-1.5h.3v1.4l.2.1h.4l.2-.2zm-1.9.4v-2h.3v2.4h-.3zm-1.2-.5v-.4l.2-.3.5-.2h.3l.2.2.2.3v.8l-.2.3-.2.1h-.6l-.2-.1-.1-.3zm.3 0v.3l.1.2.2.1h.2l.4-.2v-.9l-.2-.1h-.2l-.4.1zm-2.3 0v-.4l.2-.2.3-.2.3-.1h.3l.3.3.1.2.1.4v.4l-.2.3-.3.1-.3.1h-.3l-.3-.2-.1-.3zm.3 0v.3l.1.2.2.1h.4l.2-.1v-.2l.1-.3v-.3l-.1-.2-.4-.2-.2.1-.2.1zm-1.1-.5v1.4h-.3v-1.8h.3zm.5-.4v.3h-.3l-.2.2v.2h-.2v-.2l.2-.3.1-.1zm-2 .9h-.6v-.3h.9l.1-.2v-.5l-.1-.1-.3-.1h-.6v2h-.3V238h.9l.4.1.3.3.1.3-.1.4-.3.3z"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 236.5,
    fill: "#2f2f2f",
    rx: 2.7
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9,
    height: 5.4,
    x: 291,
    y: 236.5,
    stroke: "#616467",
    strokeWidth: 0.2,
    rx: 2.7
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M299.7 239v.8l-.2.3-.2.1h-.7l-.1-.2-.1-.3v-1.2l.1-.3.2-.1h.6l.3.2v.3zm-.3.4v-.9l-.1-.1-.1-.1h-.4v.1l-.2.2v1.2l.2.1v.1h.4l.1-.1.1-.2zm-1.9.6h.3v.2h-.2zm-.4-1v.8l-.2.3-.2.1h-.7l-.1-.2-.1-.3v-1.2l.1-.3.2-.1h.6l.3.2v.3zm-.3.4v-.9l-.1-.1-.1-.1h-.3l-.2.1v1.5l.2.1h.3l.1-.1.1-.2zm-1.8.6h.2v.2h-.2zm-1-2v2.2h-.2v-1.8l-.6.2v-.2zm54.8 1.7-.2-.1-.2-.1h-.3l-.2-.2-.1-.1v-.2l.1-.4h.2l.3-.1h.4l.2.3v.2h-.2v-.1l-.2-.1h-.5v.3l.2.1h.2l.3.2.2.1v.5l-.1.1-.2.1h-.7l-.2-.2-.1-.3h.3v.2l.2.1h.5zm-2.9-2h.3v2.5h-.3zm1.5 1.6v.4l-.2.2-.2.2h-.6l-.2-.1-.2-.3v-.8l.2-.3.2-.2h.6l.2.2.1.3zm-.3 0v-.3l-.1-.2-.4-.2h-.2l-.1.2-.1.1v.8l.2.2h.4l.2-.2v-.4m-2.2.9h-.3l-.4-.5v-.8l.2-.3.5-.2h.3l.2.2.2.3v.5h-1.3v-.3h1v-.2l-.2-.2h-.4l-.1.1-.1.2v.8l.2.1h.5l.2-.2.2.2-.2.1-.2.1zm-2.9-.8.4-1.6h.3l-.2.7-.5 1.7h-.2zm-.5-1.6.4 1.6v.8h-.2l-.5-2.4zm1.8 1.6.3-1.6h.3l-.5 2.4h-.3zm-.6-1.6.4 1.6.2.8h-.2l-.5-1.7-.1-.7zm-2.8.6v1.8h-.3v-1.8zm-.3-.4v-.2h.3v.2l-.1.1zm-2.6.8v1.4h-.3v-1.8h.3zm0 .4h-.2v-.3l.2-.3.2-.2h.5l.3.3v1.5h-.2v-1.4l-.2-.1h-.4l-.2.1zm1-.1v-.3l.1-.2.3-.2h.5l.2.1v.2l.1.3v1.2h-.3v-1.4l-.1-.1h-.4l-.2.2zm-2.1.8v-1.1l-.2-.1h-.5v.2h-.3v-.2l.1-.1.3-.2h.6l.2.2v1.2l.1.2v.1h-.3zm0-.8v.2h-.6l-.1.2v.3l.3.1h.2l.2-.2v-.1l.1.1v.2l-.3.2h-.6l-.2-.2v-.5l.1-.2h.3l.3-.1zm-2.8-1.3v2.4h-.3v-2.4zm1.4 0-1 1.1-.5.6v-.4l.4-.4.8-.9zm-.3 2.4-.8-1.2.2-.2 1 1.4zm-2.6-.8v.2h-1.7v-.2l1-1.6h.3l-.3.5-.7 1zm-.3-1.6v2.4h-.3v-2.4zm-1.7 2.2v.2H328v-.3l.8-.8.2-.3.1-.2v-.4l-.1-.1h-.5l-.2.2v.2h-.3v-.4l.3-.2.4-.1h.4l.3.3v.7l-.2.2-.2.2-.6.7zm-1.9-1.2v.8l-.2.4-.2.1h-.8l-.1-.3-.1-.2v-1.3l.1-.3.3-.2h.5l.4.3v.3zm-.3.4v-.9l-.2-.2h-.6v1.7l.2.1h.4v-.1l.2-.3zm-1.5.8v.2h-1.6v-.3l.8-.8.2-.3.1-.2v-.4l-.1-.1h-.5l-.2.2v.2h-.3v-.4l.3-.2.5-.1h.3l.3.3v.7l-.2.2-.2.2-.6.7zm-2.8-.2v.5l-.3.3-.1-.1.1-.3v-.4zm-1.2-2v2.4h-.3v-2l-.6.2v-.3zm-3.4 1v1.4h-.3v-1.8h.3zm0 .4h-.2l.1-.3.1-.3.6-.2h.2l.2.1v.2l.1.3v1.2h-.3v-1.4l-.1-.1h-.2l-.4.1-.1.2zm-1.1.7v-1.1l-.1-.1h-.6v.2h-.3v-.2l.2-.1.2-.2h.6l.3.2v1.4l.1.1h-.3zm0-.8.1.2h-.7l-.1.2v.3h.1l.2.1h.2l.2-.2v-.1l.2.1v.2l-.2.1-.2.1h-.6l-.2-.2v-.5l.2-.2h.2l.3-.1zm-1.8.4v-1.7h.3v1.7l-.1.4-.3.2h-.7l-.3-.2v-.4h.2v.2l.2.2h.5l.1-.2zm53.3-.3h-.6v-.2h.7l.2-.2v-.4l-.2-.1h-.7v2h-.3V238h1.1l.2.1.2.2v.6l-.2.2zm0 1.1h-.8l.2-.2h.8l.2-.2v-.5l-.2-.1h-.7v-.3h.6l.4.2.2.2v.6l-.4.2zm-2.7-2.3v2.3h-.3V238zm1.4 0-1 1-.5.6v-.3l.4-.4.8-1zm-.3 2.3-.8-1.1.2-.3 1 1.4zm-2.7-.6-.1.4-.3.2h-.7l-.3-.2-.1-.4.2-.5.2-.1h.7l.3.3zm-.3 0v-.2l-.2-.2h-.5l-.2.2v.4l.2.2h.5l.1-.2zm.2-1.1v.3l-.3.2-.4.1h-.3l-.3-.3v-.6l.3-.3h.7l.2.3zm-.3 0v-.2l-.4-.2h-.2l-.1.2v.4l.1.2h.4l.2-.2zm-2-.6v2.3h-.3v-2l-.6.3v-.3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dL)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dM)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dN",
    width: 5,
    height: 5,
    x: 408,
    y: 237,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 237.3h-4.2v3.7h4.2z"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dN)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m409.1 240.5.2.3.1.2.7-1.2h-1.3v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m410.9 238.5-.7-1.2-.1.2-1.3 2.1v.2h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m412.3 241 .2-.2v-.1l.4-.7v-.2h-1.2l.2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m410.9 238.5.6-1.2h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M411.7 239.8H410l-.7 1.2h2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m412.3 238.6-.6-1.1-.2-.2-.6 1.2.8 1.3h1.3v-.2z"
  }))))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dO)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M429.4 238h.5v.5h-.5zm0 1h.5v1.3h-.5zm.2-2.2a2.3 2.3 0 1 0 0 4.7 2.3 2.3 0 0 0 0-4.7m0 4.2a1.9 1.9 0 1 1 0-3.7 1.9 1.9 0 0 1 0 3.7"
  })))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.5 245.3v-.3H57.7v.5h381.8z",
    mask: "url(#dP)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 450,
    height: 253,
    fill: "#fff",
    rx: 8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53 15h391.2v233.4H53z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.7 32.4H92v11.3H57.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58.2 32.4h33.5v11.3H58.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M92.1 32.4h20.4v11.3H92.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.7 50h5.6v5.7h-5.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.7 74.6h381.8v12.2H57.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 78h4.1v5.5h-4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408 78h5.7v5.5H408z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408.8 78.8h4.2v3.8h-4.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M426.8 78h5.6v5.5h-5.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.7 86.8h381.8V99H57.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 90h4.1v5.7h-4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408 90h5.7v5.7H408z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408.8 91h4.2v3.8h-4.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M426.8 90h5.6v5.7h-5.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.7 99h381.8v12.2H57.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 102.3h4.1v5.6h-4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aq"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408 102.3h5.7v5.6H408z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408.8 103.2h4.2v3.8h-4.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "at"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M426.8 102.3h5.6v5.6h-5.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.7 111.2h381.8v12.2H57.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 114.5h4.1v5.6h-4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408 114.5h5.7v5.6H408z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aJ"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408.8 115.4h4.2v3.8h-4.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M426.8 114.5h5.6v5.6h-5.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aN"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.7 123.4h381.8v12.2H57.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aO"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 126.7h4.1v5.6h-4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aZ"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408 126.7h5.7v5.6H408z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408.8 127.6h4.2v3.8h-4.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.7 135.6h381.8v12.2H57.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 138.8h4.3v5.6H60z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bh"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408 138.8h5.7v5.6H408z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bi"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408.8 139.8h4.2v3.8h-4.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bl"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.7 147.8h381.8v12.1H57.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bm"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 151h4.1v5.6h-4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bx"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408 151h5.7v5.6H408z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "by"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408.8 152h4.2v3.8h-4.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bA"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M426.8 151h5.6v5.6h-5.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bC"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.7 160h381.8v12H57.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bD"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 163.2h4.1v5.6h-4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bO"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408 163.2h5.7v5.6H408z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bP"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408.8 164.2h4.2v3.8h-4.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bR"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M426.8 163.2h5.6v5.6h-5.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bT"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.7 172.1h381.8v12.2H57.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bU"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 175.4h4.1v5.6h-4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408 175.4h5.7v5.6H408z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ch"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408.8 176.3h4.2v3.8h-4.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cj"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M426.8 175.4h5.6v5.6h-5.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cl"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.7 184.3h381.8v12.2H57.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cm"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 187.6h4.1v5.6h-4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cx"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408 187.6h5.7v5.6H408z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cy"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408.8 188.5h4.2v3.8h-4.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cB"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.7 196.5h381.8v12.2H57.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cC"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 199.8h4.1v5.6h-4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cN"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408 199.8h5.7v5.6H408z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cO"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408.8 200.7h4.2v3.8h-4.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cR"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.7 208.7h381.8v12.2H57.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cS"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 212h4.1v5.6h-4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408 212h5.7v5.6H408z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "de"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408.8 213h4.2v3.7h-4.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M426.8 212h5.6v5.6h-5.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "di"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.7 220.9h381.8V233H57.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dj"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 224.2h4.1v5.6h-4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "du"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408 224.2h5.7v5.6H408z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dv"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408.8 225h4.2v3.9h-4.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dx"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M426.8 224.2h5.6v5.6h-5.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dz"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.7 233h381.8v12.3H57.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dA"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 236.3h4.1v5.6h-4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408 236.3h5.7v5.6H408z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dM"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408.8 237.3h4.2v3.8h-4.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dO"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M426.8 236.3h5.6v5.6h-5.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 6.2,
    x2: 12.4,
    y1: 10.3,
    y2: 3.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 19.1,
    x2: 19.1,
    y1: 3.7,
    y2: 9.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 3.8,
    x2: 61.7,
    y1: 66.1,
    y2: 72.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 54.8,
    x2: 463.2,
    y1: 19.8,
    y2: 61.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 109.9,
    x2: 109.9,
    y1: 87.9,
    y2: 174.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 109.9,
    x2: 109.9,
    y1: 100.1,
    y2: 186.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 109.9,
    x2: 109.9,
    y1: 112.3,
    y2: 199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 109.9,
    x2: 109.9,
    y1: 124.5,
    y2: 211.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bf360c",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf360c",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 109.9,
    x2: 109.9,
    y1: 136.7,
    y2: 223.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 63.1,
    x2: 63.1,
    y1: 140.9,
    y2: 141.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311b92",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311b92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 109.6,
    x2: 109.6,
    y1: 161.1,
    y2: 247.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1a237e",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bH",
    x1: 109.6,
    x2: 109.6,
    y1: 173.2,
    y2: 259.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1a237e",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bZ",
    x1: 109.9,
    x2: 109.9,
    y1: 185.4,
    y2: 272.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bf360c",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf360c",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cr",
    x1: 109.9,
    x2: 109.9,
    y1: 197.6,
    y2: 284.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cH",
    x1: 109.9,
    x2: 109.9,
    y1: 209.8,
    y2: 296.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cW",
    x1: 109.6,
    x2: 109.6,
    y1: 222,
    y2: 308.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1a237e",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dn",
    x1: 109.6,
    x2: 109.6,
    y1: 234.2,
    y2: 320.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1a237e",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dF",
    x1: 109.9,
    x2: 109.9,
    y1: 246.4,
    y2: 333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "H",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(69.4 86.3)scale(439.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(69.4 98.4)scale(439.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ap",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(69.4 110.6)scale(439.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(69.4 122.8)scale(439.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(69.4 135)scale(439.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(60.8 139.9)scale(36.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(69.3 159.3)scale(437.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(69.3 171.5)scale(437.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ce",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(69.4 183.8)scale(439.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(69.4 196)scale(439.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(69.4 208.1)scale(439.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(69.3 220.3)scale(437.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dt",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(69.3 232.5)scale(437.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(69.4 244.7)scale(439.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "k",
    fill: "#fff",
    d: "M444.4 0h-389v15h389z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    fill: "#fff",
    d: "M62.4 78.8H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3V80z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P",
    fill: "#fff",
    d: "M62.4 91H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3v-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag",
    fill: "#fff",
    d: "M62.4 103.2H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3v-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax",
    fill: "#fff",
    d: "M62.4 115.4H61q-.3 0-.3.3v3.2q0 .2.3.3h2.2l.3-.3v-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP",
    fill: "#fff",
    d: "M62.4 127.6H61q-.3 0-.3.2v3.3q0 .2.3.2h2.2q.2 0 .3-.2v-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bn",
    fill: "#fff",
    d: "M62.4 152H61q-.3 0-.3.2v3.3q0 .2.3.2h2.2l.2-.2V153z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE",
    fill: "#fff",
    d: "M62.4 164.2H61q-.3 0-.3.2v3.3l.3.2h2.2l.2-.2v-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bV",
    fill: "#fff",
    d: "M62.4 176.3H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3v-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cn",
    fill: "#fff",
    d: "M62.4 188.5H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3v-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cD",
    fill: "#fff",
    d: "M62.4 200.7H61q-.3 0-.3.3v3.2q0 .3.3.3h2.2q.2 0 .3-.3v-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cT",
    fill: "#fff",
    d: "M62.4 213H61q-.3 0-.3.2v3.2q0 .2.3.3h2.2l.2-.3v-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dk",
    fill: "#fff",
    d: "M62.4 225H61q-.3 0-.3.3v3.3q0 .2.3.2h2.2q.2 0 .2-.2V226z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dB",
    fill: "#fff",
    d: "M62.4 237.3H61q-.3 0-.3.2v3.3q0 .2.3.2h2.2q.2 0 .3-.2v-2.5z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: 27.4,
    height: 17.1,
    x: 1.8,
    y: 18.2,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.303597 0 0 0 0 0.303597 0 0 0 0 0.303597 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_103_64909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_103_64909",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    width: 396.8,
    height: 239.1,
    x: 50.2,
    y: 12.7,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.273861 0 0 0 0 0.273861 0 0 0 0 0.273861 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_103_64909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_103_64909",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourGraphic5);
export default __webpack_public_path__ + "static/media/Tour-Graphic-5.c76239ae331553b94f97660e2c1860ce.svg";
export { ForwardRef as ReactComponent };